import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from 'shared/context/AuthContext';
import API, { getImagenUrl, getImagenFallbackUrl } from 'shared/api';
import { empresaUrl } from 'shared/config';
import socket from 'shared/socket';
import usePersistentState from 'shared/hooks/usePersistentState';
import useImageReorder, { buildImageDisplay } from 'shared/hooks/useImageReorder';
import VisorImagen from 'shared/components/VisorImagen';
import ImagenProducto from 'shared/components/ImagenProducto';
import StockBadge, { stockColor } from 'shared/components/StockBadge';
import TagBadge from 'shared/components/TagBadge';
import Spinner from 'shared/components/Spinner';
import SeleccionMasivaBar from 'shared/components/SeleccionMasivaBar';
import KpiCard from 'shared/components/ui/KpiCard';
import EmptyState from 'shared/components/ui/EmptyState';
import { C, M, BS, SY, IMG } from './Inventario.styles';
import {
  FiPackage,
  FiAlertCircle,
  FiMinusCircle,
  FiCheckCircle,
  FiCheck,
  FiBox,
  FiFolder,
  FiStar,
  FiSearch,
  FiX,
  FiRefreshCw,
  FiDownload,
  FiUpload,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiEyeOff,
  FiArrowUp,
  FiArrowDown,
  FiClipboard,
  FiTrendingUp,
  FiTrendingDown,
  FiDollarSign,
  FiHelpCircle,
  FiImage,
  FiEye,
  FiGrid,
  FiList,
  FiLayers,
  FiZap,
  FiTag,
  FiShare2,
  FiInfo,
  FiPlusSquare,
  FiBriefcase,
  FiPrinter,
} from 'react-icons/fi';
import DepositosTab from './DepositosTab';
import ExtrasTab from './ExtrasTab';
import TicketArticulo from '../components/Tienda/TicketArticulo';
import ListaPreciosModal from '../components/Tienda/ListaPreciosModal';
import ConteoInventarioModal from '../components/Tienda/ConteoInventarioModal';
import { fmtMonto } from 'shared/format';
import BotonEscanear from 'shared/components/BotonEscanear';

function Inventario({ onNavigate }) {
  const { isAdmin, isPlanExterno, tienePermiso, tieneVisibilidad, isTipoEmpresa, usuario } = useAuth();
  const tp = (c) => tienePermiso(c);
  const v = (c) => tieneVisibilidad(c);
  const puedeGestionarCombos = () => tp('inventario.combos') && (isTipoEmpresa('importador') || !isPlanExterno());
  const puedeGestionarDescuentos = () => (tp('inventario.combos') || tp('inventario.productos') || tp('inventario.editar_basico')) && (isTipoEmpresa('importador') || !isPlanExterno());
  const [tab, setTab] = usePersistentState('agorax_inv_tab', 'todos');
  const [sede, setSede] = usePersistentState('agorax_inv_sede', 'todas');
  const [ordenarPor, setOrdenarPor] = usePersistentState('agorax_inv_ordenar_por', 'nombre');
  const [ordenDir, setOrdenDir] = usePersistentState('agorax_inv_orden_dir', 'asc');
  const [ordenarPorSede, setOrdenarPorSede] = useState(null);
  const [sedes, setSedes] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [productos, setProductos] = useState([]);
  const [cargandoProd, setCargandoProd] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [ultimoCursor, setUltimoCursor] = useState(null);

  const [filtroQ, setFiltroQ] = usePersistentState('agorax_inv_filtro_q', '');
  const [filtroDepto, setFiltroDepto] = usePersistentState('agorax_inv_filtro_depto', '');
  const [filtroCategoria, setFiltroCategoria] = usePersistentState('agorax_inv_filtro_categoria', '');
  const [filtroTagId, setFiltroTagId] = useState(null);
  const [filtroEstado, setFiltroEstado] = usePersistentState('agorax_inv_filtro_estado', 'todos');
  const [filtroMarca, setFiltroMarca] = usePersistentState('agorax_inv_filtro_marca', '');
  const [busquedaTimeout, setBusquedaTimeout] = useState(null);

  const [departamentos, setDepartamentos] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [productosModelo, setProductosModelo] = useState({});
  const [cargandoModelo, setCargandoModelo] = useState({});
  const [agregandoModelo, setAgregandoModelo] = useState({});

  const [modeloActivo, setModeloActivo] = useState(null);
  const [busquedaModeloModal, setBusquedaModeloModal] = useState('');
  const [resultadosBusquedaModelo, setResultadosBusquedaModelo] = useState([]);
  const [buscandoProducto, setBuscandoProducto] = useState(false);
  const busquedaModeloTimer = useRef(null);

  const [marcas, setMarcas] = useState([]);
  const [cargandoMarcas, setCargandoMarcas] = useState(false);
  const [marcaModal, setMarcaModal] = useState(null);
  const [marcaForm, setMarcaForm] = useState('');
  const [guardandoMarca, setGuardandoMarca] = useState(false);

  const [modeloModal, setModeloModal] = useState(null);
  const [modeloForm, setModeloForm] = useState('');
  const [guardandoModelo, setGuardandoModelo] = useState(false);

  const [productoModelos, setProductoModelos] = useState([]);
  const [nuevaMarca, setNuevaMarca] = useState(false);

  const [productoTipo, setProductoTipo] = useState('simple');
  const [productoRecetaId, setProductoRecetaId] = useState('');
  const [productoStockCliente, setProductoStockCliente] = useState('produccion');
  const [productoPrecioManual, setProductoPrecioManual] = useState(false);
  const [recetasDisponibles, setRecetasDisponibles] = useState([]);
  const [cargandoRecetas, setCargandoRecetas] = useState(false);
  const [ticketArticulo, setTicketArticulo] = useState(null); // { producto, modo }
  const [showListaPrecios, setShowListaPrecios] = useState(false);
  const [showConteo, setShowConteo] = useState(false);

  const [grupos, setGrupos] = useState([]);
  const [cargandoGrupos, setCargandoGrupos] = useState(false);
  const [grupoModal, setGrupoModal] = useState(null);
  const [grupoForm, setGrupoForm] = useState({ codigo: '', descripcion: '' });
  const [guardandoGrupo, setGuardandoGrupo] = useState(false);

  const [tagQuickCodigo, setTagQuickCodigo] = useState(null);
  const [guardandoTagQuick, setGuardandoTagQuick] = useState(false);

  const [combos, setCombos] = useState([]);
  const [cargandoCombos, setCargandoCombos] = useState(false);
  const [comboModal, setComboModal] = useState(null);

  const [descuentos, setDescuentos] = useState([]);
  const [cargandoDescuentos, setCargandoDescuentos] = useState(false);
  const [showDescuentoModal, setShowDescuentoModal] = useState(false);
  const descuentoTimer = useRef(null);
  const [descuentoCatalogo, setDescuentoCatalogo] = useState([]);
  const [cargandoCatalogo, setCargandoCatalogo] = useState(false);
  const [descuentoBusqueda, setDescuentoBusqueda] = useState('');
  const [descuentoProducto, setDescuentoProducto] = useState(null);
  const [descuentoTipo, setDescuentoTipo] = useState('porcentaje');
  const [descuentoValor, setDescuentoValor] = useState('');
  const [guardandoDescuento, setGuardandoDescuento] = useState(false);
  const [errorDescuento, setErrorDescuento] = useState('');

  const [productoDetalle, setProductoDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);

  const [showExportModal, setShowExportModal] = useState(false);
  const [exportCols, setExportCols] = useState([
    'descripcion',
    'codigo',
    'precio',
    'stock',
    'departamento',
  ]);
  const [exportSoloConStock, setExportSoloConStock] = useState(false);
  const [exportSede, setExportSede] = useState(sede);
  const [exportMoneda, setExportMoneda] = useState('');
  const [exportMonedas, setExportMonedas] = useState([]);
  const [exportando, setExportando] = useState(false);

  const [showImgModal, setShowImgModal] = useState(false);
  const [imgSede, setImgSede] = useState('');
  const [imgFile, setImgFile] = useState(null);
  const [subiendoImg, setSubiendoImg] = useState(false);
  const [imgResult, setImgResult] = useState(null);

  const [clasificandoIA, setClasificandoIA] = useState(false);

  const prodListRef = useRef(null);

  const [showProductoModal, setShowProductoModal] = useState(false);
  const [productoForm, setProductoForm] = useState({});
  const [editandoProducto, setEditandoProducto] = useState(null);
  const [guardandoProducto, setGuardandoProducto] = useState(false);
  const [errorProducto, setErrorProducto] = useState('');
  const [productoEtiquetas, setProductoEtiquetas] = useState([]);
  const [productoNactivo, setProductoNactivo] = useState('1');
  const [productosInactivos, setProductosInactivos] = useState([]);
  const [cargandoInactivos, setCargandoInactivos] = useState(false);
  const [showDeptoModal, setShowDeptoModal] = useState(false);
  const [deptoForm, setDeptoForm] = useState({ codigo: '', nombre: '', grupo: '', subgrupo: '' });
  const [editandoDepto, setEditandoDepto] = useState(null);
  const [guardandoDepto, setGuardandoDepto] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [showStockModal, setShowStockModal] = useState(false);
  const [stockTipo, setStockTipo] = useState('carga');
  const [stockSede, setStockSede] = useState('');
  const [stockItems, setStockItems] = useState([]);
  const [stockBusqueda, setStockBusqueda] = useState('');
  const [stockResultados, setStockResultados] = useState([]);
  const [stockNotas, setStockNotas] = useState('');
  const [procesandoStock, setProcesandoStock] = useState(false);
  const [stockResultado, setStockResultado] = useState(null);
  const [imgProdFile, setImgProdFile] = useState(null);
  const [productoImagenes, setProductoImagenes] = useState([]);
  const [productoFilesPendientes, setProductoFilesPendientes] = useState([]);
  const [productoDeletePendientes, setProductoDeletePendientes] = useState([]);
  const [productoOrdenOriginal, setProductoOrdenOriginal] = useState([]);
  const [productoSubiendoImg, setProductoSubiendoImg] = useState(false);
  const [imgRefreshKey, setImgRefreshKey] = useState(0);

  const [showExternoModal, setShowExternoModal] = useState(false);
  const [externoEditando, setExternoEditando] = useState(null);
  const [externoForm, setExternoForm] = useState({
    descripcion: '',
    descripcion_corta: '',
    marca: '',
    modelo: '',
  });
  const [guardandoExterno, setGuardandoExterno] = useState(false);
  const [errorExterno, setErrorExterno] = useState('');
  const [externoImagenes, setExternoImagenes] = useState([]);
  const [externoFilesPendientes, setExternoFilesPendientes] = useState([]);
  const [externoDeletePendientes, setExternoDeletePendientes] = useState([]);
  const [externoOrdenOriginal, setExternoOrdenOriginal] = useState([]);
  const [subiendoExternoImg, setSubiendoExternoImg] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [visorOpen, setVisorOpen] = useState(null);
  const [previewGalIdx, setPreviewGalIdx] = useState(0);
  const [previewHovered, setPreviewHovered] = useState(false);
  const [hoveredCodigo, setHoveredCodigo] = useState(null);
  const [detGalIdx, setDetGalIdx] = useState(0);
  const [progresoGuardado, setProgresoGuardado] = useState({ total: 0, actual: 0 });

  // ── Tags (badges visuales configurables de producto) ──
  const [tagsDisponibles, setTagsDisponibles] = useState([]);
  const [cargandoTags, setCargandoTags] = useState(false);
  const [showTagModal, setShowTagModal] = useState(false);
  const [editandoTag, setEditandoTag] = useState(null);
  const [tagForm, setTagForm] = useState({ nombre: '', color: '#0B1A4A', icono: '', orden: 0, prioridad: false });
  const [guardandoTag, setGuardandoTag] = useState(false);
  const [errorTag, setErrorTag] = useState('');
  // Tags seleccionados en el modal de producto
  const [productoTags, setProductoTags] = useState([]);
  const [guardandoProductoTags, setGuardandoProductoTags] = useState(false);

  // Seleccion masiva de productos (checkbox) para aplicar/quitar tags en lote.
  const [seleccionMasiva, setSeleccionMasiva] = useState({});
  const [masivoModal, setMasivoModal] = useState(null); // 'asignar' | 'quitar'
  const [masivoTagId, setMasivoTagId] = useState('');
  const [procesandoMasivo, setProcesandoMasivo] = useState(false);

  const codigosSeleccionados = Object.keys(seleccionMasiva).filter((k) => seleccionMasiva[k]);

  const toggleSeleccion = (codigo) => {
    setSeleccionMasiva((prev) => ({ ...prev, [codigo]: !prev[codigo] }));
  };

  const toggleSeleccionTodos = () => {
    const todos = productos.map((p) => p.codigo);
    const todosSel = todos.length > 0 && todos.every((c) => seleccionMasiva[c]);
    const next = { ...seleccionMasiva };
    todos.forEach((c) => {
      if (todosSel) delete next[c];
      else next[c] = true;
    });
    setSeleccionMasiva(next);
  };

  const limpiarSeleccion = () => setSeleccionMasiva({});

  const ejecutarMasivo = async () => {
    if (!codigosSeleccionados.length || !masivoTagId) return;
    setProcesandoMasivo(true);
    try {
      const url =
        masivoModal === 'asignar' ? '/inventario/tags/masivo/asignar' : '/inventario/tags/masivo/quitar';
      await API.post(url, { tag_id: Number(masivoTagId), codigos: codigosSeleccionados });
      setMasivoModal(null);
      setMasivoTagId('');
      limpiarSeleccion();
      resetCursor();
      await cargarProductos(true);
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al procesar la selección');
    } finally {
      setProcesandoMasivo(false);
    }
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        if (visorOpen) setVisorOpen(null);
        else if (showPreview) setShowPreview(false);
        else if (showExternoModal) cancelarEdicionExterna();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visorOpen, showPreview, showExternoModal]);

  const [vista, setVista] = usePersistentState('agorax_inv_vista', 'tabla');

  const [showImportModal, setShowImportModal] = useState(false);
  const [importPaso, setImportPaso] = useState(1);
  const [importFile, setImportFile] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMapeo, setImportMapeo] = useState(null);
  const [importFilas, setImportFilas] = useState([]);
  const [importPreview, setImportPreview] = useState([]);
  const [importConfianza, setImportConfianza] = useState('');
  const [importSede, setImportSede] = useState('');
  const [importResult, setImportResult] = useState(null);
  const [importError, setImportError] = useState('');

  const [historial, setHistorial] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  const [estadisticas, setEstadisticas] = useState(null);
  const [cargandoEstadisticas, setCargandoEstadisticas] = useState(false);
  const [detSection, setDetSection] = useState('rendimiento');

  const cargarSedes = useCallback(async () => {
    try {
      const res = await API.get('/sedes/listar');
      if (res.data.status === 'success') setSedes(res.data.data);
    } catch {}
  }, []);

  const cargarResumen = useCallback(async () => {
    try {
      const res = await API.get(`/inventario/resumen?sede=${sede}`);
      if (res.data.status === 'success') setResumen(res.data.data);
    } catch {}
  }, [sede]);

  const handleExportar = () => {
    setExportSede(sede);
    setShowExportModal(true);
    API.get('/ventas/monedas')
      .then((r) => {
        const arr = r.data?.data || [];
        setExportMonedas(arr);
        const principal = arr.find((m) => m.es_principal) || arr[0];
        if (principal) setExportMoneda(principal.codigo);
      })
      .catch(() => {});
  };

  const openImgModal = () => {
    setImgSede(sede !== 'todas' ? sede : sedes.find((s) => s.activa)?.codigo || '');
    setImgFile(null);
    setImgResult(null);
    setShowImgModal(true);
  };

  const clasificarIA = async () => {
    setClasificandoIA(true);
    try {
      const res = await API.post('/inventario/ia/clasificar', { sede }, { timeout: 180000 });
      if (res.data.status === 'success') {
        const d = res.data.data || {};
        alert(
          `Clasificación IA completada: ${d.clasificados ?? 0} productos clasificados de ${d.total_enviados ?? 0} enviados.`
        );
        cargarResumen();
        cargarProductos(true);
      } else {
        alert(res.data.message || 'Error en la clasificación IA');
      }
    } catch (e) {
      alert(e.response?.data?.detail || e.message || 'Error en la clasificación IA');
    } finally {
      setClasificandoIA(false);
    }
  };

  const handlePublicarImagenes = async () => {
    if (!imgFile || !imgSede) {
      alert('Selecciona una sede y un archivo ZIP');
      return;
    }
    setSubiendoImg(true);
    setImgResult(null);
    try {
      const formData = new FormData();
      formData.append('sede_codigo', imgSede);
      formData.append('archivo', imgFile);
      const res = await API.post('/inventario/publicar-imagenes', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000,
      });
      setImgResult(res.data);
    } catch (e) {
      setImgResult({ status: 'error', message: e.response?.data?.detail || e.message });
    } finally {
      setSubiendoImg(false);
    }
  };

  const confirmExport = async () => {
    setExportando(true);
    try {
      const params = new URLSearchParams();
      params.set('sede', exportSede);
      params.set('filtro', exportSoloConStock ? 'con_stock' : tab);
      if (filtroDepto) params.set('departamento', filtroDepto);
      if (filtroCategoria) params.set('categoria', filtroCategoria);
      if (filtroQ.trim()) params.set('q', filtroQ.trim());
      params.set('ordenar_por', ordenarPor);
      params.set('orden_dir', ordenDir);
      if (ordenarPorSede) params.set('ordenar_por_sede', ordenarPorSede);
      params.set('columnas', exportCols.join(','));
      if (exportMoneda) params.set('moneda', exportMoneda);

      const res = await API.get(`/inventario/exportar?${params.toString()}`, {
        responseType: 'arraybuffer',
      });
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inventario_${exportSede}_${tab}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, '')}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      setShowExportModal(false);
    } catch (e) {
      alert('Error al exportar: ' + (e.response?.data?.detail || e.message));
    } finally {
      setExportando(false);
    }
  };

  const cargarProductos = useCallback(
    async (reset = false) => {
      setCargandoProd(true);
      try {
        const params = new URLSearchParams();
        params.set('sede', sede);
        params.set('filtro', filtroEstado === 'servicios' ? 'todos' : filtroEstado);
        params.set('limite', '20');
        params.set('ordenar_por', ordenarPor);
        params.set('orden_dir', ordenDir);
        if (ordenarPorSede) params.set('ordenar_por_sede', ordenarPorSede);
        if (!reset && ultimoCursor) params.set('ultimo_cursor', ultimoCursor);
        if (filtroQ.trim()) params.set('q', filtroQ.trim());
        if (filtroDepto) params.set('departamento', filtroDepto);
        if (filtroCategoria) params.set('categoria', filtroCategoria);
        if (filtroMarca) params.set('marca', filtroMarca);
        if (filtroTagId) params.set('tag_id', filtroTagId);
        if (filtroEstado === 'servicios') params.set('tipo', 'servicio');

        const res = await API.get(`/inventario/productos?${params.toString()}`);
        if (res.data.status === 'success') {
          if (reset) {
            setProductos(res.data.data);
          } else {
            setProductos((prev) => [...prev, ...res.data.data]);
          }
          setHasMore(res.data.has_more);
          setUltimoCursor(res.data.has_more ? res.data.ultimo_cursor : null);
        }
      } catch {
      } finally {
        setCargandoProd(false);
      }
    },
    [sede, filtroEstado, filtroQ, filtroDepto, filtroCategoria, filtroMarca, filtroTagId, ordenarPor, ordenDir, ordenarPorSede, ultimoCursor]
  );

  const cargarDepartamentos = useCallback(async () => {
    try {
      const res = await API.get(`/inventario/departamentos?sede=${sede}`);
      if (res.data.status === 'success') {
        setDepartamentos(res.data.data);
        const grouped = {};
        res.data.data.forEach((d) => {
          const g = d.grupo_nombre || d.grupo || 'Sin categoría';
          if (!grouped[g]) grouped[g] = [];
          grouped[g].push(d);
        });
        setExpandedGroups(
          Object.fromEntries(Object.keys(grouped).map((g) => [g, true]))
        );
      }
    } catch {}
  }, [sede]);

  const cargarModelos = useCallback(async () => {
    try {
      const res = await API.get(`/inventario/modelos`);
      if (res.data.status === 'success') {
        setModelos(res.data.data);
      }
    } catch {}
  }, []);

  const cargarMarcas = useCallback(async () => {
    setCargandoMarcas(true);
    try {
      const res = await API.get('/inventario/marcas');
      if (res.data.status === 'success') setMarcas(res.data.data || []);
    } catch {
    } finally {
      setCargandoMarcas(false);
    }
  }, []);

  const cargarGrupos = useCallback(async () => {
    setCargandoGrupos(true);
    try {
      const res = await API.get('/inventario/grupos');
      if (res.data.status === 'success') setGrupos(res.data.data || []);
    } catch {
    } finally {
      setCargandoGrupos(false);
    }
  }, []);

  const abrirNuevoGrupo = () => {
    setGrupoForm({ codigo: '', descripcion: '' });
    setGrupoModal('crear');
  };

  const abrirEditarGrupo = (g) => {
    setGrupoForm({ codigo: g.codigo, descripcion: g.descripcion || '' });
    setGrupoModal('editar');
  };

  const guardarGrupo = async () => {
    const descripcion = grupoForm.descripcion.trim();
    if (!descripcion) {
      alert('La descripción del grupo es obligatoria');
      return;
    }
    setGuardandoGrupo(true);
    try {
      if (grupoModal === 'crear') {
        await API.post('/inventario/grupos', { descripcion });
      } else {
        await API.put(`/inventario/grupo/${encodeURIComponent(grupoForm.codigo)}`, { descripcion });
      }
      setGrupoModal(null);
      cargarGrupos();
      cargarDepartamentos();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al guardar el grupo');
    } finally {
      setGuardandoGrupo(false);
    }
  };

  const eliminarGrupo = async (g) => {
    if (!window.confirm(`Eliminar el grupo "${g.descripcion}"?`)) return;
    try {
      const res = await API.delete(`/inventario/grupo/${encodeURIComponent(g.codigo)}`);
      if (res.data.status === 'success') {
        cargarGrupos();
        cargarDepartamentos();
      } else alert(res.data.message || 'Error');
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al eliminar el grupo');
    }
  };

  const cargarCombos = useCallback(async () => {
    setCargandoCombos(true);
    try {
      const res = await API.get(`/inventario/combos`);
      if (res.data.status === 'success') {
        setCombos(res.data.data);
      }
    } catch {
    } finally {
      setCargandoCombos(false);
    }
  }, []);

  const cargarDescuentos = useCallback(async () => {
    setCargandoDescuentos(true);
    try {
      const res = await API.get(`/inventario/productos?sede=todas&filtro=descuento&limite=100`);
      if (res.data.status === 'success') setDescuentos(res.data.data || []);
    } catch {
    } finally {
      setCargandoDescuentos(false);
    }
  }, []);

  const cargarCatalogoDescuento = async (q = '') => {
    setCargandoCatalogo(true);
    try {
      const params = new URLSearchParams();
      params.set('sede', 'todas');
      params.set('limite', '100');
      if (q && q.trim()) params.set('q', q.trim());
      const res = await API.get(`/inventario/productos?${params.toString()}`);
      if (res.data.status === 'success') setDescuentoCatalogo(res.data.data || []);
    } catch {
    } finally {
      setCargandoCatalogo(false);
    }
  };

  const abrirDescuentoModal = () => {
    setDescuentoBusqueda('');
    setDescuentoProducto(null);
    setDescuentoTipo('porcentaje');
    setDescuentoValor('');
    setErrorDescuento('');
    setShowDescuentoModal(true);
    cargarCatalogoDescuento();
  };

  const cerrarDescuentoModal = () => {
    setShowDescuentoModal(false);
    setDescuentoProducto(null);
    setDescuentoBusqueda('');
    setDescuentoCatalogo([]);
  };

  useEffect(() => {
    if (!showDescuentoModal) return;
    if (descuentoTimer.current) clearTimeout(descuentoTimer.current);
    const t = setTimeout(() => {
      cargarCatalogoDescuento(descuentoBusqueda);
    }, 350);
    descuentoTimer.current = t;
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [descuentoBusqueda]);

  const seleccionarDescuentoProducto = (p) => {
    setDescuentoProducto(p);
    setDescuentoBusqueda('');
  };

  const guardarDescuento = async () => {
    if (!descuentoProducto) {
      setErrorDescuento('Selecciona un producto');
      return;
    }
    const valorNum = parseFloat(descuentoValor);
    if (!descuentoTipo || !descuentoValor || isNaN(valorNum) || valorNum <= 0) {
      setErrorDescuento('Ingresa un valor de descuento válido');
      return;
    }
    setGuardandoDescuento(true);
    setErrorDescuento('');
    try {
      const res = await API.put(`/inventario/producto/${descuentoProducto.codigo}/descuento`, {
        tipo: descuentoTipo,
        valor: valorNum,
      });
      if (res.data.status === 'success') {
        setShowDescuentoModal(false);
        setDescuentoProducto(null);
        cargarDescuentos();
        cargarProductos(true);
        cargarResumen();
      } else {
        setErrorDescuento(res.data.message || 'Error al aplicar descuento');
      }
    } catch (e) {
      setErrorDescuento(e.response?.data?.detail || 'Error al aplicar descuento');
    } finally {
      setGuardandoDescuento(false);
    }
  };

  const quitarDescuento = async (p) => {
    if (!window.confirm(`¿Quitar el descuento de "${p.descripcion}"?`)) return;
    try {
      const res = await API.put(`/inventario/producto/${p.codigo}/descuento`, {
        tipo: null,
        valor: null,
      });
      if (res.data.status === 'success') {
        cargarDescuentos();
        cargarProductos(true);
        cargarResumen();
      } else {
        alert(res.data.message || 'Error al quitar descuento');
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al quitar descuento');
    }
  };

  const abrirComboEditor = (combo) => {
    setComboModal({ combo: combo || null });
  };

  const cerrarComboModal = () => {
    setComboModal(null);
  };

  const [comboDetalle, setComboDetalle] = useState(null);
  const abrirComboDetalle = (combo) => setComboDetalle(combo);
  const cerrarComboDetalle = () => setComboDetalle(null);

  const guardarCombo = async (payload) => {
    try {
      let res;
      if (payload.id) {
        res = await API.put(`/inventario/combos/${payload.id}`, payload);
      } else {
        res = await API.post(`/inventario/combos`, payload);
      }
      cargarCombos();
      return res.data.data;
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al guardar la promoción');
      throw e;
    }
  };

  const eliminarCombo = async (combo) => {
    if (!window.confirm(`¿Eliminar la promoción "${combo.nombre}"?`)) return;
    try {
      await API.delete(`/inventario/combos/${combo.id}`);
      cargarCombos();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al eliminar la promoción');
    }
  };

  const toggleCombo = async (combo) => {
    try {
      await API.post(`/inventario/combos/${combo.id}/toggle`);
      cargarCombos();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al cambiar el estado de la promoción');
    }
  };

  // ── Gestión visual de modelos (modal dual-panel) ──

  const abrirModeloModal = async (categoria) => {
    setModeloActivo(categoria);
    setBusquedaModeloModal('');
    setResultadosBusquedaModelo([]);
    if (!productosModelo[categoria]) {
      setCargandoModelo((prev) => ({ ...prev, [categoria]: true }));
      try {
        const res = await API.get(`/inventario/modelo/${encodeURIComponent(categoria)}/productos`);
        if (res.data.status === 'success') {
          setProductosModelo((prev) => ({ ...prev, [categoria]: res.data.data }));
        }
      } catch {
      } finally {
        setCargandoModelo((prev) => ({ ...prev, [categoria]: false }));
      }
    }
  };

  const cerrarModeloModal = () => {
    setModeloActivo(null);
    setBusquedaModeloModal('');
    setResultadosBusquedaModelo([]);
    cargarModelos();
  };

  const onBuscarProductoModal = (termino) => {
    setBusquedaModeloModal(termino);
    if (busquedaModeloTimer.current) clearTimeout(busquedaModeloTimer.current);
    if (!termino || termino.trim().length < 2) {
      setResultadosBusquedaModelo([]);
      return;
    }
    busquedaModeloTimer.current = setTimeout(async () => {
      setBuscandoProducto(true);
      try {
        const res = await API.get(`/inventario/productos?q=${encodeURIComponent(termino)}&limite=50`);
        if (res.data.status === 'success') {
          setResultadosBusquedaModelo(res.data.data);
        }
      } catch {
      } finally {
        setBuscandoProducto(false);
      }
    }, 350);
  };

  const agregarDesdeModal = async (p) => {
    if (!modeloActivo) return;
    setAgregandoModelo((prev) => ({ ...prev, [p.codigo]: true }));
    try {
      const res = await API.post(`/inventario/modelo/${encodeURIComponent(modeloActivo)}/producto`, {
        codigo_producto: p.codigo,
      });
      if (res.data.status === 'success') {
        const nuevo = {
          codigo: p.codigo,
          descripcion: p.descripcion,
          marca: p.marca,
          precio: p.precio,
          activo: '1',
        };
        setProductosModelo((prev) => ({
          ...prev,
          [modeloActivo]: [nuevo, ...(prev[modeloActivo] || [])],
        }));
      } else {
        alert(res.data.message || 'Error');
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Error');
    } finally {
      setAgregandoModelo((prev) => ({ ...prev, [p.codigo]: false }));
    }
  };

  const quitarDesdeModal = async (codigo) => {
    if (!modeloActivo) return;
    setAgregandoModelo((prev) => ({ ...prev, [codigo]: true }));
    try {
      const res = await API.delete(
        `/inventario/modelo/${encodeURIComponent(modeloActivo)}/producto/${encodeURIComponent(codigo)}`
      );
      if (res.data.status === 'success') {
        setProductosModelo((prev) => ({
          ...prev,
          [modeloActivo]: (prev[modeloActivo] || []).filter((p) => p.codigo !== codigo),
        }));
      } else {
        alert(res.data.message || 'Error');
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Error');
    } finally {
      setAgregandoModelo((prev) => ({ ...prev, [codigo]: false }));
    }
  };

  useEffect(() => {
    cargarSedes();
    cargarDepartamentos();
    cargarModelos();
    cargarMarcas();
    cargarGrupos();
  }, [cargarSedes, cargarDepartamentos, cargarModelos, cargarMarcas, cargarGrupos]);

  useEffect(() => {
    const onInvActualizado = () => {
      cargarResumen();
    };
    socket.on('inventario_actualizado', onInvActualizado);
    return () => {
      socket.off('inventario_actualizado', onInvActualizado);
    };
  }, [cargarResumen]);
  useEffect(() => {
    cargarResumen();
  }, [cargarResumen]);
  useEffect(() => {
    cargarDepartamentos();
  }, [sede]); // eslint-disable-line
  useEffect(() => {
    setSeleccionMasiva({});
    resetCursor();
    if (tab !== 'todos') return;
    if (filtroEstado === 'inactivos') {
      cargarInactivos();
    } else {
      setProductos([]);
      cargarProductos(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, filtroEstado, sede, ordenarPor, ordenDir, ordenarPorSede, filtroDepto, filtroCategoria, filtroMarca, filtroTagId]);
  useEffect(() => {
    if (busquedaTimeout) clearTimeout(busquedaTimeout);
    const t = setTimeout(() => {
      if (tab !== 'todos') return;
      setSeleccionMasiva({});
      resetCursor();
      if (filtroEstado === 'inactivos') {
        cargarInactivos();
      } else {
        setProductos([]);
        cargarProductos(true);
      }
    }, 400);
    setBusquedaTimeout(t);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroQ]);

  const verDetalle = async (codigo) => {
    setCargandoDetalle(true);
    setDetGalIdx(0);
    setEstadisticas(null);
    setDetSection('rendimiento');
    try {
      const res = await API.get(`/inventario/producto/${codigo}?sede=${sede}`);
      if (res.data.status === 'success') {
        setProductoDetalle(res.data.data);
        cargarHistorial(codigo);
        cargarEstadisticas(codigo);
      } else setProductoDetalle(null);
    } catch {
      setProductoDetalle(null);
    } finally {
      setCargandoDetalle(false);
    }
  };

  // Comparte un producto por WhatsApp: imagen principal + texto con link directo
  // al articulo en el catalogo del cliente (abre el detalle de una vez).
  const compartirProducto = async (prod) => {
    const slug = localStorage.getItem('agorax_empresa_slug') || '';
    const nombre = prod?.descripcion || prod?.nombre || 'Producto';
    const link = `${empresaUrl(slug)}/?producto=${encodeURIComponent(prod?.codigo || '')}`;
    const precio = prod?.precio != null ? `\nPrecio: $${fmtMonto(prod.precio)}` : '';
    const texto = `${nombre}${precio}\n\nMira este producto: ${link}`;

    const imagenPrincipal =
      prod?.imagenes?.[0]?.url || prod?.imagen_url || prod?.thumb_url;

    const candidatos = [];
    if (imagenPrincipal) {
      const pub = getImagenUrl(imagenPrincipal);
      const api = getImagenFallbackUrl(imagenPrincipal);
      if (pub) candidatos.push(pub);
      if (api && api !== pub) candidatos.push(api);
    }

    let blob = null;
    for (const url of candidatos) {
      try {
        const resp = await fetch(url);
        if (!resp.ok) continue;
        const b = await resp.blob();
        if (b && b.size > 0) {
          blob = b;
          break;
        }
      } catch {
        // siguiente candidato
      }
    }

    let files = [];
    if (blob) {
      const ext = (blob.type?.split('/')[1] || 'jpg').split('+')[0];
      files.push(new File([blob], `${prod?.codigo || 'producto'}.${ext}`, { type: blob.type }));
    }

    if (navigator.share) {
      try {
        const shareData = { title: nombre, text: texto };
        if (files.length > 0 && navigator.canShare && navigator.canShare({ files })) {
          shareData.files = files;
        }
        await navigator.share(shareData);
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }

    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
  };

  const cargarInactivos = useCallback(async () => {
    setCargandoInactivos(true);
    try {
      const qs = filtroQ.trim() ? `&q=${encodeURIComponent(filtroQ.trim())}` : '';
      const res = await API.get(`/inventario/productos/inactivos?sede=${sede}${qs}`);
      if (res.data.status === 'success') setProductosInactivos(res.data.data);
    } catch {
    } finally {
      setCargandoInactivos(false);
    }
  }, [sede, filtroQ]);

  const guardarMarca = async () => {
    if (!marcaModal) return;
    const accion = marcaModal.accion;
    const destino = marcaForm.trim();
    if (!destino) {
      alert('Ingresa un valor');
      return;
    }
    setGuardandoMarca(true);
    try {
      if (accion === 'crear') {
        await API.post('/inventario/marcas', { marca: destino });
      } else if (accion === 'renombrar') {
        await API.put(`/inventario/marca/${encodeURIComponent(marcaModal.marca)}`, { marca: destino });
      } else if (accion === 'merge') {
        await API.post('/inventario/marca/merge', { origen: marcaModal.marca, destino });
      }
      setMarcaModal(null);
      setMarcaForm('');
      cargarMarcas();
      cargarProductos(true);
      cargarResumen();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al guardar la marca');
    } finally {
      setGuardandoMarca(false);
    }
  };

  const abrirNuevaMarca = () => {
    setMarcaModal({ accion: 'crear', marca: '' });
    setMarcaForm('');
  };

  const eliminarMarca = async (marca) => {
    if (!window.confirm(`Eliminar la marca "${marca}"? Se quitará de todos sus productos.`)) return;
    try {
      await API.delete(`/inventario/marca/${encodeURIComponent(marca)}`);
      cargarMarcas();
      cargarProductos(true);
      cargarResumen();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al eliminar la marca');
    }
  };

  const guardarModelo = async () => {
    if (!modeloModal) return;
    const nombre = modeloForm.trim();
    if (!nombre) {
      alert('Ingresa un nombre');
      return;
    }
    setGuardandoModelo(true);
    try {
      if (modeloModal.accion === 'crear') {
        await API.post('/inventario/modelos', { nombre });
      } else if (modeloModal.accion === 'renombrar') {
        await API.put(`/inventario/modelo/${encodeURIComponent(modeloModal.categoria)}`, { nombre });
      }
      setModeloModal(null);
      setModeloForm('');
      cargarModelos();
      cargarProductos(true);
      cargarResumen();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al guardar el modelo');
    } finally {
      setGuardandoModelo(false);
    }
  };

  const abrirNuevoModelo = () => {
    setModeloModal({ accion: 'crear', categoria: '' });
    setModeloForm('');
  };

  const abrirRenombrarModelo = (categoria) => {
    setModeloModal({ accion: 'renombrar', categoria });
    setModeloForm(categoria);
  };

  const eliminarModelo = async (categoria) => {
    if (!window.confirm(`Eliminar el modelo "${categoria}"? Se desasignará de todos sus productos.`)) return;
    try {
      await API.delete(`/inventario/modelo/${encodeURIComponent(categoria)}`);
      cargarModelos();
      cargarProductos(true);
      cargarResumen();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al eliminar el modelo');
    }
  };

  const verProductosDeModelo = (categoria) => {
    setFiltroEstado('todos');
    setFiltroDepto('');
    setFiltroCategoria(categoria);
    setFiltroMarca('');
    setFiltroTagId(null);
    setFiltroQ('');
    setTab('todos');
  };

  const verProductosDeMarca = (marca) => {
    setFiltroEstado('todos');
    setFiltroDepto('');
    setFiltroCategoria('');
    setFiltroTagId(null);
    setFiltroQ('');
    setFiltroMarca(marca);
    setTab('todos');
  };

  const EMPTY_PROD = {
    codigo: '',
    descripcion: '',
    descripcion_corta: '',
    departamento: '',
    grupo: '',
    subgrupo: '',
    marca: '',
    referencia: '',
    precio1: '',
    precio2: '',
    precio3: '',
    costo: '',
    impuesto1: '16',
    pesable: false,
    es_cocina: false,
    tiempo_preparacion_min: 0,
    sedes_stock: [],
    descuento_tipo: '',
    descuento_valor: '',
    precio_original: null,
    en_promocion: false,
  };

  const imagenesDesdeProducto = (p) => {
    if (p?.imagenes?.length > 0) return p.imagenes;
    if (p?.imagen_url) return [{ url: p.imagen_url, prioridad: 1, tipo: 'imagen' }];
    return [];
  };

  const resolveDeptoCodigo = (val) => {
    if (!val) return '';
    const byCodigo = departamentos.find((x) => x.codigo === val);
    if (byCodigo) return byCodigo.codigo;
    const byNombre = departamentos.find((x) => x.nombre === val);
    return byNombre ? byNombre.codigo : val;
  };

  const onChangeDepartamento = (codigo) => {
    const d = departamentos.find((x) => x.codigo === codigo);
    setProductoForm((f) => ({
      ...f,
      departamento: codigo,
      grupo: d ? d.grupo || '' : '',
      subgrupo: d ? d.subgrupo || '' : '',
    }));
  };

  const toggleProductoModelo = (categoria) => {
    setProductoModelos((prev) =>
      prev.includes(categoria) ? prev.filter((c) => c !== categoria) : [...prev, categoria]
    );
  };

  const cargarRecetasProducto = useCallback(async () => {
    if (!isTipoEmpresa('restaurante')) return;
    setCargandoRecetas(true);
    try {
      const res = await API.get('/produccion/recetas?activa=true&limite=200');
      setRecetasDisponibles(res.data?.data?.items || []);
    } catch {
      setRecetasDisponibles([]);
    } finally {
      setCargandoRecetas(false);
    }
  }, [isTipoEmpresa]);

  const abrirCrearProducto = () => {
    setEditandoProducto(null);
    setProductoForm({
      ...EMPTY_PROD,
      sedes_stock: sedes.filter((s) => s.activa).map((s) => ({ sede: s.codigo, cantidad: 0 })),
    });
    setErrorProducto('');
    setImgProdFile(null);
    setProductoImagenes([]);
    setProductoFilesPendientes([]);
    setProductoDeletePendientes([]);
    setProductoOrdenOriginal([]);
    setProductoEtiquetas([]);
    setProductoNactivo('1');
    setProductoTags([]);
    setProductoModelos([]);
    setProductoTipo('simple');
    setProductoRecetaId('');
    setProductoStockCliente('produccion');
    setProductoPrecioManual(false);
    setNuevaMarca(false);
    setShowProductoModal(true);
    cargarRecetasProducto();
  };

  // Handoff desde Produccion: abrir el modal de creacion de articulo al entrar.
  useEffect(() => {
    let retorno = null;
    try { retorno = localStorage.getItem('agorax_inv_nuevo_producto_return'); } catch {}
    if (retorno === 'produccion') {
      try { localStorage.removeItem('agorax_inv_nuevo_producto_return'); } catch {}
      abrirCrearProducto();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const abrirEditarProducto = async (codigo) => {
    const cached = productos.find((p) => p.codigo === codigo);
    if (cached) {
      setEditandoProducto(codigo);
      setProductoForm({
        codigo,
        descripcion: cached.descripcion || '',
        descripcion_corta: '',
        departamento: resolveDeptoCodigo(cached.departamento),
        grupo: cached.grupo || '',
        subgrupo: cached.subgrupo || '',
        marca: cached.marca || '',
        referencia: cached.referencia || '',
        precio1: cached.precio ?? '',
        precio2: '',
        precio3: '',
        costo: '',
        impuesto1: '',
        pesable: !!cached.pesable,
        es_cocina: !!cached.es_cocina,
        tiempo_preparacion_min: cached.tiempo_preparacion_min || 0,
        descuento_tipo: cached.en_promocion ? (cached.descuento_tipo || '') : '',
        descuento_valor: cached.en_promocion ? (cached.descuento_valor ?? '') : '',
        precio_original: cached.en_promocion ? cached.precio_original : null,
        en_promocion: !!cached.en_promocion,
      });
      setErrorProducto('');
      setImgProdFile(null);
      setProductoImagenes(imagenesDesdeProducto(cached));
      setProductoFilesPendientes([]);
      setProductoDeletePendientes([]);
      setProductoOrdenOriginal(imagenesDesdeProducto(cached).map((img) => img.prioridad));
      setProductoEtiquetas((cached.etiquetas || []).filter(e => e.activo !== false));
      setProductoTags((cached.tags || []).map((t) => t.id));
      setProductoNactivo(cached.n_activo == null ? '1' : cached.n_activo);
      setProductoModelos([]);
      setProductoTipo(cached.tipo_producto || 'simple');
      setProductoRecetaId(cached.receta?.id || '');
      setProductoStockCliente(cached.stock_cliente || 'produccion');
      setProductoPrecioManual(!!cached.precio_manual);
      setNuevaMarca(false);
      setShowProductoModal(true);
    }
    try {
      const res = await API.get(`/inventario/producto/${codigo}?sede=${sede}`);
      if (res.data.status === 'success') {
        const p = res.data.data;
        setProductoForm({
          codigo: p.codigo,
          descripcion: p.descripcion || '',
          descripcion_corta: p.descripcion_corta || '',
          departamento: p.departamento_codigo || p.departamento || '',
          grupo: p.grupo || '',
          subgrupo: p.subgrupo || '',
          marca: p.marca || '',
          referencia: p.referencia || '',
          precio1: p.en_promocion ? (p.precio_original ?? p.precio ?? '') : (p.precio ?? ''),
          precio2: p.precio2 ?? '',
          precio3: p.precio3 ?? '',
          costo: p.costo ?? '',
          impuesto1: p.impuesto1 ?? '',
          pesable: !!p.pesable,
          es_cocina: !!p.es_cocina,
          tiempo_preparacion_min: p.tiempo_preparacion_min || 0,
          descuento_tipo: p.en_promocion ? (p.descuento_tipo || '') : '',
          descuento_valor: p.en_promocion ? (p.descuento_valor ?? '') : '',
          precio_original: p.en_promocion ? p.precio_original : null,
          en_promocion: !!p.en_promocion,
        });
        setProductoImagenes(imagenesDesdeProducto(p));
        setProductoEtiquetas((p.etiquetas || []).filter(e => e.activo !== false));
        setProductoTags((p.tags || []).map((t) => t.id));
        setProductoNactivo(p.n_activo == null ? '1' : p.n_activo);
        setProductoModelos(p.modelos || []);
        setProductoTipo(p.tipo_producto || 'simple');
        setProductoRecetaId(p.receta?.id || '');
        setProductoStockCliente(p.stock_cliente || 'produccion');
        setProductoPrecioManual(!!p.precio_manual);
        cargarRecetasProducto();
        if (!cached) {
          setEditandoProducto(p.codigo);
          setErrorProducto('');
          setImgProdFile(null);
          setProductoFilesPendientes([]);
          setProductoDeletePendientes([]);
          setProductoOrdenOriginal(imagenesDesdeProducto(p).map((img) => img.prioridad));
          setNuevaMarca(false);
          setShowProductoModal(true);
        }
      }
    } catch {
      if (!cached) alert('Error al cargar producto');
    }
  };

  const guardarProducto = async () => {
    if (!productoForm.codigo?.trim()) {
      setErrorProducto('Código es obligatorio');
      return;
    }
    if (!productoForm.descripcion?.trim()) {
      setErrorProducto('Descripción es obligatoria');
      return;
    }
    const targetCodigo = editandoProducto || productoForm.codigo;
    setGuardandoProducto(true);
    setErrorProducto('');
    const sedeCod = sede !== 'todas' ? sede : sedes.find((s) => s.activa)?.codigo || 'general';
    try {
      if (editandoProducto && productoDeletePendientes.length > 0) {
        for (const prio of productoDeletePendientes) {
          await API.delete(`/inventario/producto/${editandoProducto}/imagen/${prio}`);
        }
      }

      if (
        editandoProducto &&
        productoOrdenOriginal.filter((p) => !productoDeletePendientes.includes(p)).length > 1
      ) {
        const ordenFinal = productoImagenes
          .filter((img) => !productoDeletePendientes.includes(img.prioridad))
          .map((img) => img.prioridad);
        const ordenOriginalVivo = productoOrdenOriginal.filter(
          (p) => !productoDeletePendientes.includes(p)
        );
        if (JSON.stringify(ordenFinal) !== JSON.stringify(ordenOriginalVivo)) {
          await API.put(`/inventario/producto/${editandoProducto}/imagenes/reorder`, {
            orden: ordenFinal,
          });
        }
      }

      const body = { ...productoForm, precio1: parseFloat(productoForm.precio1) || 0 };
      body.precio2 = body.precio2 !== '' && body.precio2 != null ? parseFloat(body.precio2) : null;
      body.precio3 = body.precio3 !== '' && body.precio3 != null ? parseFloat(body.precio3) : null;
      body.costo = body.costo !== '' && body.costo != null ? parseFloat(body.costo) : null;
      body.impuesto1 =
        body.impuesto1 !== '' && body.impuesto1 != null ? parseFloat(body.impuesto1) : null;
      delete body.descuento_tipo;
      delete body.descuento_valor;
      delete body.precio_original;
      delete body.en_promocion;
      delete body.modelo;
      if (isTipoEmpresa('restaurante') || productoTipo === 'servicio') {
        body.tipo_producto = productoTipo;
        body.receta_id = productoTipo === 'compuesto' && productoRecetaId ? Number(productoRecetaId) : null;
        body.stock_cliente = productoTipo === 'compuesto' ? productoStockCliente : null;
        body.precio_manual = productoTipo === 'servicio' ? productoPrecioManual : false;
      }
      let res;
      if (editandoProducto) {
        const { codigo, sedes_stock, ...upd } = body;
        const nuevoCodigo = (codigo || '').trim().toUpperCase();
        if (nuevoCodigo && nuevoCodigo !== String(editandoProducto).toUpperCase()) {
          upd.codigo_nuevo = nuevoCodigo;
        }
        res = await API.put(`/inventario/producto/${editandoProducto}`, upd);
      } else {
        res = await API.post('/inventario/producto', body);
      }
      if (res.data.status === 'success') {
        const codigoEfectivo = res.data.data?.codigo || targetCodigo;
        if (editandoProducto) {
          try {
            await API.put(`/inventario/producto/${codigoEfectivo}/modelos`, {
              categorias: productoModelos,
            });
          } catch (e) {
            alert(e.response?.data?.detail || 'Error sincronizando modelos');
          }
        }
        const tipoDesc = productoForm.descuento_tipo || '';
        const valorDesc = productoForm.descuento_valor;
        if (tipoDesc && valorDesc !== '' && valorDesc != null) {
          try {
            await API.put(`/inventario/producto/${codigoEfectivo}/descuento`, {
              tipo: tipoDesc,
              valor: parseFloat(valorDesc) || 0,
            });
          } catch (e) {
            alert(e.response?.data?.message || 'Error aplicando descuento');
          }
        }
        if (productoFilesPendientes.length > 0) {
          for (const f of productoFilesPendientes) {
            const fd = new FormData();
            fd.append('sede_codigo', sedeCod);
            fd.append('archivo', f.file);
            try {
              await API.post(`/inventario/producto/${codigoEfectivo}/imagen`, fd);
            } catch {}
          }
        } else if (!editandoProducto && imgProdFile) {
          const fd = new FormData();
          fd.append('sede_codigo', sedeCod);
          fd.append('archivo', imgProdFile);
          try {
            await API.post(`/inventario/producto/${codigoEfectivo}/imagen`, fd, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
          } catch {}
        }
        productoFilesPendientes.forEach((f) => {
          try {
            URL.revokeObjectURL(f.previewUrl);
          } catch {}
        });
        setShowProductoModal(false);
        cargarProductos(true);
        cargarResumen();
        cargarDepartamentos();
      } else {
        setErrorProducto(res.data.message || 'Error');
      }
    } catch (e) {
      setErrorProducto(e.response?.data?.detail || e.message);
    } finally {
      setGuardandoProducto(false);
    }
  };

  const toggleProducto = async (codigo) => {
    try {
      await API.put(`/inventario/producto/${codigo}/toggle`);
      const nuevoEstado = productoNactivo === '1' ? '0' : '1';
      setProductoNactivo(nuevoEstado);
      if (filtroEstado === 'inactivos') cargarInactivos();
      else {
        cargarProductos(true);
        cargarResumen();
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Error');
    }
  };

  const eliminarProducto = async (codigo) => {
    if (
      !window.confirm(
        `¿Eliminar el producto "${codigo}"? Se borrará definitivamente del catálogo, el stock y sus imágenes. Esta acción no se puede deshacer.`
      )
    )
      return;
    try {
      const res = await API.delete(`/inventario/producto/${codigo}`);
      if (res.data.status === 'success') {
        setShowProductoModal(false);
        cargarProductos(true);
        cargarResumen();
      } else {
        alert(res.data.message || 'Error al eliminar');
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al eliminar');
    }
  };

  const cerrarProductoModal = () => {
    productoFilesPendientes.forEach((f) => {
      try {
        URL.revokeObjectURL(f.previewUrl);
      } catch {}
    });
    setProductoFilesPendientes([]);
    setProductoDeletePendientes([]);
    setShowProductoModal(false);
  };

  const subirImagenProducto = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/mp4,video/webm';
    input.multiple = true;
    input.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;
      setProductoSubiendoImg(true);
      try {
        const nuevos = files.map((file) => ({
          file,
          previewUrl: URL.createObjectURL(file),
          tipo: file.type.startsWith('video/') ? 'video' : 'imagen',
        }));
        setProductoFilesPendientes((prev) => [...prev, ...nuevos]);
      } catch (err) {
        alert('Error al procesar archivos');
      } finally {
        setProductoSubiendoImg(false);
      }
    };
    input.click();
  };

  const eliminarImagenProducto = (prioridad) => {
    setProductoDeletePendientes((prev) => [...prev, prioridad]);
  };

  const eliminarFilePendienteProducto = (fileIdx) => {
    setProductoFilesPendientes((prev) => {
      const siguiente = prev.filter((_, i) => i !== fileIdx);
      const eliminado = prev[fileIdx];
      if (eliminado?.previewUrl) {
        try { URL.revokeObjectURL(eliminado.previewUrl); } catch {}
      }
      return siguiente;
    });
  };

  const {
    dragIdx: productoDragIdx,
    handleDragStart: handleDragStartProd,
    handleDragOver: handleDragOverProd,
    handleDrop: handleDropProd,
    handleDragEnd: handleDragEndProd,
  } = useImageReorder({
    imagenes: productoImagenes,
    filesPendientes: productoFilesPendientes,
    deletePendientes: productoDeletePendientes,
    setImagenes: setProductoImagenes,
    setFilesPendientes: setProductoFilesPendientes,
  });

  const abrirEditarExterno = async (codigo) => {
    const cached = productos.find((p) => p.codigo === codigo);
    if (cached) {
      setExternoEditando(codigo);
      setExternoForm({
        descripcion: cached.descripcion || '',
        descripcion_corta: '',
        marca: cached.marca || '',
        modelo: cached.modelo || '',
      });
      setExternoImagenes(cached.imagenes || []);
      setExternoFilesPendientes([]);
      setExternoDeletePendientes([]);
      setExternoOrdenOriginal((cached.imagenes || []).map((img) => img.prioridad));
      setErrorExterno('');
      setShowExternoModal(true);
    }
    try {
      const res = await API.get(`/inventario/producto/${codigo}?sede=${sede}`);
      if (res.data.status === 'success') {
        const p = res.data.data;
        setExternoForm({
          descripcion: p.descripcion || '',
          descripcion_corta: p.descripcion_corta || '',
          marca: p.marca || '',
          modelo: p.modelo || '',
        });
        setExternoImagenes(p.imagenes || cached?.imagenes || []);
        setExternoFilesPendientes([]);
        setExternoDeletePendientes([]);
        setExternoOrdenOriginal((p.imagenes || cached?.imagenes || []).map((img) => img.prioridad));
        if (!cached) {
          setExternoEditando(p.codigo);
          setErrorExterno('');
          setShowExternoModal(true);
        }
      }
    } catch {
      if (!cached) alert('Error al cargar producto');
    }
  };

  const subirImagenExterno = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/mp4,video/webm';
    input.multiple = true;
    input.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;
      setSubiendoExternoImg(true);
      try {
        const nuevos = files.map((file) => ({
          file,
          previewUrl: URL.createObjectURL(file),
          tipo: file.type.startsWith('video/') ? 'video' : 'imagen',
        }));
        setExternoFilesPendientes((prev) => [...prev, ...nuevos]);
      } catch (err) {
        const detail = err.response?.data?.detail;
        const msg = Array.isArray(detail)
          ? detail.map((d) => d.msg).join(', ')
          : String(detail || 'Error al procesar archivos');
        alert(msg);
      } finally {
        setSubiendoExternoImg(false);
      }
    };
    input.click();
  };

  const eliminarImagenExterno = (prioridad) => {
    setExternoDeletePendientes((prev) => [...prev, prioridad]);
  };

  const guardarEdicionExterna = async () => {
    if (!externoEditando) return;
    const survivingCount = externoImagenes.filter(
      (img) => !externoDeletePendientes.includes(img.prioridad)
    ).length;
    const needsReorder =
      survivingCount > 1 &&
      JSON.stringify(
        externoImagenes
          .filter((img) => !externoDeletePendientes.includes(img.prioridad))
          .map((i) => i.prioridad)
      ) !==
        JSON.stringify(externoOrdenOriginal.filter((p) => !externoDeletePendientes.includes(p)));
    const totalOps =
      externoDeletePendientes.length + (needsReorder ? 1 : 0) + externoFilesPendientes.length + 1;
    let actual = 0;
    setGuardandoExterno(true);
    setErrorExterno('');
    setProgresoGuardado({ total: totalOps, actual: 0 });
    try {
      for (const prio of externoDeletePendientes) {
        await API.delete(`/inventario/producto/${externoEditando}/imagen/${prio}`);
        actual++;
        setProgresoGuardado({ total: totalOps, actual });
      }

      if (needsReorder) {
        const nuevoOrden = externoImagenes
          .filter((img) => !externoDeletePendientes.includes(img.prioridad))
          .map((img) => img.prioridad);
        const reorderRes = await API.put(
          `/inventario/producto/${externoEditando}/imagenes/reorder`,
          { orden: nuevoOrden }
        );
        if (reorderRes.data.status !== 'success') {
          setErrorExterno('Error al reordenar: ' + (reorderRes.data.message || ''));
          setGuardandoExterno(false);
          return;
        }
        actual++;
        setProgresoGuardado({ total: totalOps, actual });
      }

      for (const f of externoFilesPendientes) {
        const fd = new FormData();
        fd.append(
          'sede_codigo',
          sede !== 'todas' ? sede : sedes.find((s) => s.activa)?.codigo || 'general'
        );
        fd.append('archivo', f.file);
        await API.post(`/inventario/producto/${externoEditando}/imagen`, fd);
        actual++;
        setProgresoGuardado({ total: totalOps, actual });
      }

      const body = {
        descripcion: externoForm.descripcion?.trim() || null,
        descripcion_corta: externoForm.descripcion_corta?.trim() || null,
        marca: externoForm.marca?.trim() || null,
        modelo: externoForm.modelo?.trim() || null,
      };
      const res = await API.put(`/inventario/producto/${externoEditando}/externo`, body);
      actual++;
      setProgresoGuardado({ total: totalOps, actual });
      if (res.data.status === 'success') {
        externoFilesPendientes.forEach((f) => URL.revokeObjectURL(f.previewUrl));
        setImgRefreshKey((k) => k + 1);
        setShowExternoModal(false);
        setProgresoGuardado({ total: 0, actual: 0 });
        cargarProductos(true);
        cargarResumen();
      } else {
        setErrorExterno(res.data.message || 'Error');
      }
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg = Array.isArray(detail)
        ? detail.map((d) => d.msg).join(', ')
        : String(detail || 'Error al guardar');
      setErrorExterno(msg);
    } finally {
      setGuardandoExterno(false);
    }
  };

  const cancelarEdicionExterna = () => {
    externoFilesPendientes.forEach((f) => URL.revokeObjectURL(f.previewUrl));
    setShowExternoModal(false);
  };

  const { dragIdx, handleDragStart, handleDragOver, handleDrop, handleDragEnd } = useImageReorder({
    imagenes: externoImagenes,
    filesPendientes: externoFilesPendientes,
    deletePendientes: externoDeletePendientes,
    setImagenes: setExternoImagenes,
    setFilesPendientes: setExternoFilesPendientes,
  });

  const cambiarVista = (nv) => {
    setVista(nv);
  };

  const abrirCrearDepto = () => {
    setEditandoDepto(null);
    setDeptoForm({ codigo: '', nombre: '', grupo: '', subgrupo: '' });
    setShowDeptoModal(true);
  };

  const abrirEditarDepto = (d) => {
    setEditandoDepto(d.codigo);
    setDeptoForm({ codigo: d.codigo, nombre: d.nombre || '', grupo: d.grupo || '', subgrupo: d.subgrupo || '' });
    setShowDeptoModal(true);
  };

  const guardarDepto = async () => {
    if (!deptoForm.nombre?.trim()) {
      alert('Nombre es obligatorio');
      return;
    }
    setGuardandoDepto(true);
    try {
      let res;
      if (editandoDepto) {
        res = await API.put(`/inventario/departamento/${editandoDepto}`, {
          nombre: deptoForm.nombre.trim(),
          grupo: deptoForm.grupo || null,
          subgrupo: deptoForm.subgrupo || null,
        });
      } else {
        res = await API.post('/inventario/departamento', {
          nombre: deptoForm.nombre.trim(),
          grupo: deptoForm.grupo || null,
        });
      }
      if (res.data.status === 'success') {
        setShowDeptoModal(false);
        cargarDepartamentos();
      } else alert(res.data.message || 'Error');
    } catch (e) {
      alert(e.response?.data?.detail || 'Error');
    } finally {
      setGuardandoDepto(false);
    }
  };

  const eliminarDepto = async (codigo) => {
    if (!window.confirm(`Eliminar subgrupo ${codigo}?`)) return;
    try {
      const res = await API.delete(`/inventario/departamento/${codigo}`);
      if (res.data.status === 'success') cargarDepartamentos();
      else alert(res.data.message || 'Error');
    } catch (e) {
      alert(e.response?.data?.detail || 'Error');
    }
  };

  const abrirStockModal = () => {
    setStockTipo('carga');
    setStockSede(sede !== 'todas' ? sede : sedes.find((s) => s.activa)?.codigo || '');
    setStockItems([]);
    setStockBusqueda('');
    setStockResultados([]);
    setStockNotas('');
    setProcesandoStock(false);
    setStockResultado(null);
    setShowStockModal(true);
  };

  const buscarProductoStock = async (q) => {
    if (!q || q.length < 2) {
      setStockResultados([]);
      return;
    }
    try {
      const s = stockSede || sede;
      const res = await API.get(
        `/inventario/productos?sede=${s}&q=${encodeURIComponent(q)}&limite=10`
      );
      if (res.data.status === 'success')
        setStockResultados(
          res.data.data.filter((p) => !stockItems.find((si) => si.codigo === p.codigo))
        );
    } catch {}
  };

  const agregarItemStock = (p) => {
    setStockItems((prev) => [
      ...prev,
      {
        codigo: p.codigo,
        nombre: p.descripcion,
        stock_actual: p.stock,
        tipo_producto: p.tipo_producto,
        stock_cliente: p.stock_cliente,
        stock_fisico: p.stock_fisico,
        stock_produccion: p.stock_produccion,
        cantidad: '',
      },
    ]);
    setStockBusqueda('');
    setStockResultados([]);
  };

  const quitarItemStock = (i) => setStockItems((prev) => prev.filter((_, idx) => idx !== i));

  const procesarStock = async () => {
    const items = stockItems.filter((i) => parseFloat(i.cantidad) > 0);
    if (items.length === 0) {
      alert('Agrega al menos un producto con cantidad');
      return;
    }
    if (!stockSede) {
      alert('Selecciona una sede');
      return;
    }
    setProcesandoStock(true);
    const results = [];
    for (const item of items) {
      try {
        const res = await API.put(`/inventario/producto/${item.codigo}/stock`, {
          sede: stockSede,
          cantidad: parseFloat(item.cantidad),
          tipo: stockTipo,
          notas: stockNotas || null,
        });
        results.push({
          codigo: item.codigo,
          nombre: item.nombre,
          ok: res.data.status === 'success',
          msg:
            res.data.status === 'success'
              ? `${res.data.data.stock_anterior} → ${res.data.data.stock_nuevo}`
              : res.data.message,
        });
      } catch (e) {
        results.push({
          codigo: item.codigo,
          nombre: item.nombre,
          ok: false,
          msg: e.response?.data?.detail || e.message,
        });
      }
    }
    setStockResultado(results);
    setProcesandoStock(false);
    cargarProductos(true);
    cargarResumen();
  };

  const abrirImportModal = () => {
    setImportPaso(1);
    setImportFile(null);
    setImportMapeo(null);
    setImportFilas([]);
    setImportPreview([]);
    setImportConfianza('');
    setImportSede(sede !== 'todas' ? sede : sedes.find((s) => s.activa)?.codigo || '');
    setImportResult(null);
    setImportError('');
    setImportLoading(false);
    setShowImportModal(true);
  };

  const analizarExcel = async () => {
    if (!importFile) {
      setImportError('Selecciona un archivo');
      return;
    }
    setImportLoading(true);
    setImportError('');
    setImportPaso(2);
    try {
      const fd = new FormData();
      fd.append('archivo', importFile);
      const res = await API.post('/inventario/importar-excel/analizar', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000,
      });
      if (res.data.status === 'success') {
        const d = res.data.data;
        setImportMapeo(d.mapeo);
        setImportConfianza(d.confianza);
        setImportPreview(d.preview || []);
        setImportFilas(d.filas || []);
        setImportPaso(3);
      } else {
        setImportError(res.data.message || 'Error al analizar');
        setImportPaso(1);
      }
    } catch (e) {
      setImportError(e.response?.data?.detail || e.message || 'Error al analizar archivo');
      setImportPaso(1);
    } finally {
      setImportLoading(false);
    }
  };

  const ejecutarImport = async () => {
    if (!importSede) {
      setImportError('Selecciona una sede');
      return;
    }
    if (!importFilas.length) {
      setImportError('No hay filas para importar');
      return;
    }
    setImportLoading(true);
    setImportError('');
    try {
      const res = await API.post(
        '/inventario/importar-excel/ejecutar',
        { filas: importFilas, sede: importSede },
        { timeout: 300000 }
      );
      if (res.data.status === 'success') {
        setImportResult(res.data.data);
        setImportPaso(4);
      } else {
        setImportError(res.data.message || 'Error al importar');
      }
    } catch (e) {
      setImportError(e.response?.data?.detail || e.message || 'Error al importar');
    } finally {
      setImportLoading(false);
    }
  };

  const cargarTags = async () => {
    setCargandoTags(true);
    try {
      const res = await API.get('/inventario/tags');
      if (res.data.status === 'success') setTagsDisponibles(res.data.data || []);
    } catch {
    } finally {
      setCargandoTags(false);
    }
  };

  const abrirNuevoTag = () => {
    setEditandoTag(null);
    setTagForm({ nombre: '', color: '#0B1A4A', icono: '', orden: 0, prioridad: false });
    setErrorTag('');
    setShowTagModal(true);
  };

  const abrirEditarTag = (t) => {
    setEditandoTag(t);
    setTagForm({ nombre: t.nombre, color: t.color, icono: t.icono || '', orden: t.orden || 0, prioridad: !!t.prioridad });
    setErrorTag('');
    setShowTagModal(true);
  };

  const guardarTag = async () => {
    const nombre = tagForm.nombre.trim();
    if (!nombre) {
      setErrorTag('El nombre es obligatorio');
      return;
    }
    setGuardandoTag(true);
    setErrorTag('');
    try {
      const payload = {
        nombre,
        color: tagForm.color,
        icono: tagForm.icono.trim(),
        orden: Number(tagForm.orden) || 0,
        prioridad: !!tagForm.prioridad,
      };
      let res;
      if (editandoTag) {
        res = await API.put(`/inventario/tag/${editandoTag.id}`, payload);
      } else {
        res = await API.post('/inventario/tag', payload);
      }
      if (res.data.status === 'success') {
        setShowTagModal(false);
        await cargarTags();
      } else {
        setErrorTag(res.data.message || 'Error al guardar');
      }
    } catch (e) {
      setErrorTag(e.response?.data?.detail || 'Error al guardar el tag');
    } finally {
      setGuardandoTag(false);
    }
  };

  const eliminarTag = async (t) => {
    if (!window.confirm(`Eliminar la etiqueta "${t.nombre}"? Se quitará de todos los productos.`)) return;
    try {
      await API.delete(`/inventario/tag/${t.id}`);
      await cargarTags();
    } catch (e) {
      setErrorTag(e.response?.data?.detail || 'Error al eliminar');
    }
  };

  const toggleTagActivo = async (t) => {
    try {
      await API.put(`/inventario/tag/${t.id}`, { activo: !t.activo });
      await cargarTags();
    } catch {
    }
  };

  const toggleTagPrioridad = async (t) => {
    const count = tagsDisponibles.filter((x) => x.prioridad).length;
    if (!t.prioridad && count >= 2) {
      setErrorTag('Solo puedes destacar 2 etiquetas de prioridad. Quita una para destacar otra.');
      return;
    }
    try {
      await API.put(`/inventario/tag/${t.id}`, { prioridad: !t.prioridad });
      await cargarTags();
    } catch (e) {
      setErrorTag(e.response?.data?.detail || 'Error al actualizar prioridad');
    }
  };

  const moverTag = async (t, dir) => {
    const list = [...tagsDisponibles].sort((a, b) => (a.orden - b.orden) || (a.id - b.id));
    const idx = list.findIndex((x) => x.id === t.id);
    const swap = dir === -1 ? idx - 1 : idx + 1;
    if (idx < 0 || swap < 0 || swap >= list.length) return;
    const neighbor = list[swap];
    try {
      await API.put(`/inventario/tag/${t.id}`, { orden: neighbor.orden ?? 0 });
      await API.put(`/inventario/tag/${neighbor.id}`, { orden: t.orden ?? 0 });
      await cargarTags();
    } catch {
    }
  };

  // Ir a la pestaña "Productos" filtrada por la etiqueta, para editar sus productos.
  const verProductosDeTag = (t) => {
    setFiltroEstado('todos');
    setFiltroDepto('');
    setFiltroCategoria('');
    setFiltroMarca('');
    setFiltroQ('');
    setFiltroTagId(t.id);
    setTab('todos');
  };

  const toggleProductoTag = async (tagId) => {
    const next = productoTags.includes(tagId)
      ? productoTags.filter((id) => id !== tagId)
      : [...productoTags, tagId];
    setProductoTags(next);
    if (!editandoProducto) return;
    setGuardandoProductoTags(true);
    try {
      await API.put(`/inventario/producto/${editandoProducto}/tags`, { tag_ids: next });
    } catch {
    } finally {
      setGuardandoProductoTags(false);
    }
  };

  const toggleTagQuick = async (tagId) => {
    const prod = productos.find((p) => p.codigo === tagQuickCodigo);
    const actuales = (prod?.tags || []).map((t) => t.id);
    const next = actuales.includes(tagId) ? actuales.filter((id) => id !== tagId) : [...actuales, tagId];
    setGuardandoTagQuick(true);
    try {
      await API.put(`/inventario/producto/${tagQuickCodigo}/tags`, { tag_ids: next });
      setProductos((prev) =>
        prev.map((p) =>
          p.codigo === tagQuickCodigo
            ? { ...p, tags: tagsDisponibles.filter((t) => next.includes(t.id)).map((t) => ({ id: t.id, nombre: t.nombre, color: t.color, icono: t.icono || '' })) }
            : p
        )
      );
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al actualizar etiquetas');
    } finally {
      setGuardandoTagQuick(false);
    }
  };

  // Cargar tags una sola vez (para el selector del modal de producto).
  useEffect(() => {
    cargarTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargarHistorial = async (codigo) => {
    setCargandoHistorial(true);
    setHistorial([]);
    try {
      const res = await API.get(`/inventario/historial-precios/${codigo}?limite=50`);
      if (res.data.status === 'success') setHistorial(res.data.data.historial || []);
    } catch {
    } finally {
      setCargandoHistorial(false);
    }
  };

  const cargarEstadisticas = async (codigo) => {
    setCargandoEstadisticas(true);
    setEstadisticas(null);
    try {
      const res = await API.get(`/inventario/producto/${codigo}/estadisticas?sede=${sede}`);
      if (res.data.status === 'success') setEstadisticas(res.data.data);
    } catch {
    } finally {
      setCargandoEstadisticas(false);
    }
  };

  useEffect(() => {
    if (tab === 'combos') {
      cargarCombos();
      cargarDescuentos();
    }
    if (tab === 'tags') cargarTags();
    if (tab === 'marcas') cargarMarcas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  const resetCursor = () => setUltimoCursor(null);

  const tieneVisCols =
    v('vis.inventario.precio') ||
    v('vis.inventario.stock') ||
    v('vis.inventario.codigo') ||
    v('vis.inventario.depto') ||
    v('vis.inventario.descripcion') ||
    v('vis.inventario.marca') ||
    v('vis.inventario.imagenes');

  const allTabs = [
    { id: 'todos', label: 'Productos', icon: FiPackage, color: '#1a73e8', requiereVis: true },
    { id: 'deptos', label: 'Grupos', icon: FiFolder, color: '#0d47a1' },
    { id: 'modelos', label: 'Modelos', icon: FiGrid, color: '#0d8043' },
    { id: 'marcas', label: 'Marcas', icon: FiTag, color: '#e37400' },
    { id: 'tags', label: 'Etiquetas', icon: FiStar, color: '#0d904f' },
    { id: 'combos', label: 'Promociones', icon: FiLayers, color: '#c5221f' },
    { id: 'depositos', label: 'Depósitos', icon: FiBox, color: '#0b8043' },
    { id: 'extras', label: 'Extras', icon: FiPlusSquare, color: '#9334e6' },
  ];

  const tabs = allTabs.filter((t) => {
    if (!tp(`inventario.seccion.${t.id}`)) return false;
    if (t.requiereVis && !tieneVisCols) return false;
    return true;
  });

  const tabsIds = tabs.map((t) => t.id);
  useEffect(() => {
    if (!tabsIds.includes(tab) && tabsIds.length > 0) {
      setTab(tabsIds[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, tabsIds]);

  if (!isAdmin() && !tieneVisibilidad('inventario.ver')) {
    return (
      <div className="inv-container" style={C.container}>
        <h2 style={C.title}>Inventario</h2>
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--agx-muted)' }}>
          Acceso restringido. Solo el administrador puede ver el inventario.
        </div>
      </div>
    );
  }

  const tieneAlgunaTarjeta =
    tp('inventario.tarjeta.total') ||
    tp('inventario.tarjeta.agotados') ||
    tp('inventario.tarjeta.negativos') ||
    tp('inventario.tarjeta.pesables') ||
    tp('inventario.tarjeta.deptos') ||
    tp('inventario.tarjeta.valor') ||
    tp('inventario.tarjeta.sin_depto') ||
    tp('inventario.tarjeta.con_imagen') ||
    tp('inventario.tarjeta.sin_imagen');

  if (tabs.length === 0 && !tieneAlgunaTarjeta) {
    return (
      <div className="inv-container" style={C.container}>
        <h2 style={C.title}>Inventario</h2>
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--agx-muted)' }}>
          No tienes acceso a ninguna sección del inventario. Contacta a un administrador para que te
          asigne permisos.
        </div>
      </div>
    );
  }

  const STATS = [
    {
      id: 'total',
      label: 'Total Productos',
      icon: FiPackage,
      color: '#1a73e8',
      key: 'total_productos',
    },
    { id: 'agotados', label: 'Agotados', icon: FiAlertCircle, color: '#ea4335', key: 'agotados' },
    {
      id: 'negativos',
      label: 'Negativos',
      icon: FiMinusCircle,
      color: '#ff6d01',
      key: 'negativos',
    },
    { id: 'pesables', label: 'Pesables', icon: FiBox, color: '#7b1fa2', key: 'pesables' },
    {
      id: 'deptos',
      label: 'Grupos',
      icon: FiFolder,
      color: '#1a73e8',
      key: 'total_departamentos',
    },
    {
      id: 'valor',
      label: 'Valor inventario',
      icon: FiDollarSign,
      color: '#137333',
      key: 'valor_inventario',
      isMoney: true,
    },
    {
      id: 'sin_depto',
      label: 'Sin subgrupo',
      icon: FiHelpCircle,
      color: '#e65100',
      key: 'sin_departamento',
    },
    { id: 'con_imagen', label: 'Con imagen', icon: FiImage, color: '#00897b', key: 'con_imagen' },
    { id: 'sin_imagen', label: 'Sin imagen', icon: FiImage, color: '#e65100', key: 'sin_imagen' },
  ];

  const visibleStats = STATS.filter((s) => {
    if (!tp(`inventario.tarjeta.${s.id}`)) return false;
    const val = resumen?.[s.key];
    return val != null;
  });

  const CARD_FILTRO = {
    agotados: 'agotados',
    negativos: 'negativos',
    pesables: 'pesables',
    sin_depto: 'sin_departamento',
    con_imagen: 'con_imagen',
    sin_imagen: 'sin_imagen',
  };

  const handleCardClick = (s) => {
    if (s.id === 'deptos') {
      setTab('deptos');
      return;
    }
    if (s.id === 'valor') {
      try {
        localStorage.setItem('agorax_dashboard_tab', 'inventario');
      } catch (e) {}
      if (onNavigate) onNavigate('dashboard');
      return;
    }
    if (s.id === 'total') {
      setFiltroEstado('todos');
      setFiltroDepto('');
      setFiltroCategoria('');
      setFiltroMarca('');
      setFiltroTagId(null);
      setFiltroQ('');
      setTab('todos');
      return;
    }
    const f = CARD_FILTRO[s.id];
    if (!f) return;
    setFiltroEstado(f);
    setTab('todos');
  };

  const MAIN_COLS = ['nombre', 'codigo', 'precio', 'stock', 'departamento', 'referencia'];

  const toggleOrden = (col) => {
    if (!MAIN_COLS.includes(col)) {
      if (ordenarPorSede === col) {
        setOrdenDir((d) => (d === 'asc' ? 'desc' : 'asc'));
      } else {
        setOrdenarPor('stock');
        setOrdenarPorSede(col);
        setOrdenDir('asc');
      }
      return;
    }
    setOrdenarPorSede(null);
    if (ordenarPor === col) {
      setOrdenDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setOrdenarPor(col);
      setOrdenDir('asc');
    }
  };

  const renderSortIndicator = (activo, fontSize, marginLeft) => (
    <span style={{ color: activo ? '#1a73e8' : '#ccc', fontSize, marginLeft }}>
      {activo ? (ordenDir === 'asc' ? ' \u25B2' : ' \u25BC') : ' \u25B2\u25BC'}
    </span>
  );

  const sedeSortIndicator = (cod) => renderSortIndicator(ordenarPorSede === cod, '9px', '1px');

  const sortIndicator = (col) => renderSortIndicator(ordenarPor === col, '10px', '2px');

  const thSort = (col, label) => (
    <th onClick={() => toggleOrden(col)} style={{ ...C.th, cursor: 'pointer', userSelect: 'none' }}>
      {label}
      {sortIndicator(col)}
    </th>
  );

  const getSedeNombre = (cod) => {
    const s = sedes.find((s) => s.codigo === cod);
    return s ? s.nombre : cod;
  };

  const getSedesActivas = () => sedes.filter((s) => s.activa);

  const esTabProductos = tab === 'todos';

  const sedeStockColor = (st) => {
    const c = stockColor(st);
    return { bg: c.backgroundColor, fg: c.color };
  };

  return (
    <div style={C.container}>
      <style>{`
        @media (max-width: 1024px) {
          .inv-stats-row { grid-template-columns: repeat(3, 1fr) !important; }
        }
        @media (max-width: 768px) {
          .inv-container { padding: 10px 8px !important; }
          .inv-top-bar { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; }
          .inv-top-actions { width: 100% !important; flex-wrap: wrap !important; gap: 4px !important; }
          .inv-top-actions select { flex: 1 1 auto !important; min-width: 0 !important; font-size: 12px !important; padding: 6px 8px !important; }
          .inv-top-actions > button { padding: 6px !important; min-width: 36px !important; min-height: 36px !important; }
          .inv-title { font-size: 18px !important; }
          .inv-stats-row { grid-template-columns: repeat(2, 1fr) !important; gap: 6px !important; }
          .inv-tab-bar { overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; flex-wrap: nowrap !important; padding-bottom: 4px !important; margin-bottom: 10px !important; gap: 0 !important; border-bottom-width: 1px !important; }
          .inv-tab-bar button { font-size: 10px !important; padding: 6px 8px !important; white-space: nowrap !important; flex-shrink: 0 !important; }
          .inv-tab-bar button svg { display: none !important; }
          .inv-filter-bar { flex-direction: column !important; gap: 6px !important; }
          .inv-search-wrap { min-width: 100% !important; }
          .inv-select-depto { min-width: 100% !important; font-size: 12px !important; }
          .inv-table-wrap { overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; border-radius: 8px !important; }
          .inv-table-wrap table { min-width: 500px !important; }
          .inv-table-wrap th, .inv-table-wrap td { padding: 6px 8px !important; font-size: 11px !important; }
           .inv-modal { max-width: 100vw !important; max-height: 100vh !important; border-radius: 0 !important; margin: 0 !important; }
           .inv-modal-body { flex-direction: column !important; padding: 14px !important; }
           .inv-image-section { width: 100% !important; justify-content: center !important; }
           .inv-detail-grid { grid-template-columns: 1fr 1fr !important; gap: 4px !important; }
           .inv-det-hero { flex-direction: column !important; align-items: center !important; padding: 14px !important; }
           .inv-det-hero-img { width: 140px !important; }
           .inv-det-hero-viewer { height: 140px !important; }
           .inv-det-hero-info { min-width: 100% !important; text-align: center !important; }
           .inv-det-info-grid { grid-template-columns: repeat(2, 1fr) !important; }
           .inv-det-section-box { margin: 0 14px 4px !important; padding: 10px 14px !important; }
           .inv-det-tabs { margin: 12px 14px 0 !important; }
           .inv-det-tabs button { font-size: 10px !important; padding: 8px 10px !important; }
           .inv-det-tab-content { padding: 12px 14px 14px !important; }
           .inv-det-kpi-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 6px !important; }
           .inv-det-kpi-card { padding: 10px !important; }
           .inv-det-kpi-val { font-size: 16px !important; }
           .import-modal { max-width: 100vw !important; padding: 12px !important; max-height: 100vh !important; border-radius: 0 !important; }
          .alert-section { flex-direction: column !important; }
          .inv-cards-grid { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)) !important; gap: 8px !important; }
          .inv-catalogo-grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)) !important; gap: 10px !important; }
        }
        @media (max-width: 480px) {
          .inv-container { padding: 8px 4px !important; }
          .inv-stats-row { grid-template-columns: 1fr 1fr !important; gap: 4px !important; }
          .inv-detail-grid { grid-template-columns: 1fr !important; }
          .inv-top-bar > div:first-child { width: 100%; }
          .inv-top-actions { gap: 2px !important; }
          .inv-top-actions select { font-size: 11px !important; }
          .inv-cards-grid { grid-template-columns: 1fr 1fr !important; gap: 6px !important; }
          .inv-catalogo-grid { grid-template-columns: 1fr 1fr !important; gap: 8px !important; }
        }
        @media (min-width: 769px) {
          .inv-tab-bar { gap: 2px !important; margin-bottom: 20px !important; border-bottom-width: 1.5px !important; }
          .inv-tab-bar button { font-size: 13px !important; padding: 10px 16px !important; }
        }
        .inv-row:hover { background: var(--agx-bg2) !important; }
      `}</style>
      <div className="inv-top-bar" style={C.topBar}>
        <h2 className="inv-title" style={C.title}>
          Inventario
        </h2>
        <div className="inv-top-actions" style={C.topActions}>
          <select value={sede} onChange={(e) => setSede(e.target.value)} style={C.selectSede}>
            <option value="todas">Todas las sedes</option>
            {sedes
              .filter((s) => s.activa)
              .map((s) => (
                <option key={s.codigo} value={s.codigo}>
                  {s.codigo} - {s.nombre}
                </option>
              ))}
          </select>
          {tp('inventario.exportar') && (
            <button onClick={handleExportar} style={C.btnIcon} title="Exportar a Excel">
              <FiDownload size={16} />
            </button>
          )}
          {tp('inventario.exportar') && (
            <button onClick={() => setShowListaPrecios(true)} style={C.btnIcon} title="Imprimir lista de precios">
              <FiPrinter size={16} />
            </button>
          )}
          {tp('inventario.exportar') && (
            <button onClick={() => setShowConteo(true)} style={{ ...C.btnIcon, color: '#5f6368', borderColor: '#dadce0' }} title="Lista para conteo físico">
              <FiClipboard size={16} />
            </button>
          )}
          {tp('inventario.imagenes') && !isPlanExterno() && (
            <button onClick={openImgModal} style={C.btnIcon} title="Publicar imagenes en masa">
              <FiUpload size={16} />
            </button>
          )}
          {tp('inventario.clasificar') && !isPlanExterno() && (
            <button
              onClick={clasificarIA}
              disabled={clasificandoIA}
              style={{ ...C.btnIcon, color: '#7b1fa2', borderColor: '#7b1fa2' }}
              title="Clasificar productos con IA (volumen y stock objetivo)"
            >
              {clasificandoIA ? (
                <span
                  style={{
                    width: 14,
                    height: 14,
                    borderRadius: '50%',
                    border: '2px solid #e0e0e0',
                    borderTopColor: '#7b1fa2',
                    display: 'inline-block',
                    animation: 'spin 0.7s linear infinite',
                  }}
                />
              ) : (
                <FiZap size={16} />
              )}
            </button>
          )}
          {tp('inventario.importar') && !isPlanExterno() && (
            <button
              onClick={abrirImportModal}
              style={{ ...C.btnIcon, color: '#34a853', borderColor: '#34a853' }}
              title="Importar desde Excel"
            >
              <FiDownload size={16} style={{ transform: 'rotate(180deg)' }} />
            </button>
          )}
          {tp('inventario.stock') && !isPlanExterno() && (
            <button
              onClick={abrirStockModal}
              style={{ ...C.btnIcon, color: '#1a73e8', borderColor: '#1a73e8' }}
              title="Carga / Descarga de stock"
            >
              <FiArrowUp size={16} />
            </button>
          )}
          {tp('inventario.productos') && !isPlanExterno() && (
            <button
              onClick={abrirCrearProducto}
              style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <FiPlus size={14} /> Nuevo
            </button>
          )}
        </div>
      </div>

      {isPlanExterno() && (
        <div
          style={{
            background: '#eef3ff',
            border: '1px solid #c6d4f5',
            borderRadius: '12px',
            padding: '12px 16px',
            marginBottom: '14px',
            fontSize: '13px',
            color: '#1a3a7a',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
          }}
        >
          <FiRefreshCw size={16} style={{ flexShrink: 0, marginTop: '1px' }} />
          <span>
            <strong>Modo solo lectura (plan Externo).</strong> El inventario se sincroniza desde tu
            base de datos externa; configura y administra la sincronización en{' '}
            <strong>Configuración → Sincronización</strong>. No puedes crear, editar, eliminar ni
            cargar/descargar inventario desde aquí.
          </span>
        </div>
      )}

      <div className="inv-stats-row" style={C.statsRow}>
        {visibleStats.map((s) => (
          <KpiCard
            key={s.id}
            icon={<s.icon size={20} />}
            color={s.color}
            label={s.label}
            value={
              s.isMoney && resumen?.[s.key] != null
                ? `$${Number(resumen[s.key]).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : (resumen?.[s.key] ?? '-')
            }
            onClick={
              CARD_FILTRO[s.id] || s.id === 'deptos' || s.id === 'total' || s.id === 'valor'
                ? () => handleCardClick(s)
                : undefined
            }
          />
        ))}
      </div>

      {tabs.length > 0 && (
        <>
          <div className="inv-tab-bar" style={C.tabBar}>
            {tabs.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                style={{
                  ...C.tab,
                  borderBottom: tab === t.id ? `3px solid ${t.color}` : '3px solid transparent',
                  color: tab === t.id ? t.color : '#5f6368',
                  fontWeight: tab === t.id ? 600 : 400,
                }}
              >
                <t.icon size={15} style={{ marginRight: '6px' }} /> {t.label}
              </button>
            ))}
          </div>

          {esTabProductos && (
            <div className="inv-filter-bar" style={C.filterBar}>
              <div className="inv-search-wrap" style={C.searchWrap}>
                <FiSearch size={16} color="#9aa0a6" />
                <input
                  placeholder="Buscar por nombre, código, referencia, marca o modelo..."
                  value={filtroQ}
                  onChange={(e) => setFiltroQ(e.target.value)}
                  style={C.searchInput}
                />
                <BotonEscanear onScan={(codigo) => setFiltroQ(codigo)} />
                {filtroQ && (
                  <button onClick={() => setFiltroQ('')} style={C.clearBtn}>
                    <FiX size={14} />
                  </button>
                )}
              </div>
              <select
                className="inv-select-depto"
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                style={{ ...C.selectDepto, minWidth: '140px' }}
              >
                <option value="todos">Estado: Todos</option>
                <option value="agotados">Estado: Agotados</option>
                <option value="negativos">Estado: Negativos</option>
                <option value="por_reponer">Estado: Bajo stock (reponer)</option>
                <option value="pesables">Estado: Pesables</option>
                <option value="sin_imagen">Estado: Sin imagen</option>
                <option value="con_imagen">Estado: Con imagen</option>
                <option value="sin_departamento">Estado: Sin subgrupo</option>
                <option value="servicios">Estado: Servicios</option>
                <option value="inactivos">Estado: Inactivos</option>
              </select>
              <select
                className="inv-select-depto"
                value={filtroDepto}
                onChange={(e) => setFiltroDepto(e.target.value)}
                style={C.selectDepto}
              >
                <option value="">Todos los subgrupos</option>
                {(function () {
                  const grouped = {};
                  departamentos.forEach((d) => {
                    const g = d.grupo_nombre || d.grupo || 'Sin categoría';
                    if (!grouped[g]) grouped[g] = [];
                    grouped[g].push(d);
                  });
                  return Object.entries(grouped).map(([grupo, depts]) => (
                    <optgroup key={grupo} label={grupo}>
                      {depts.map((d) => (
                        <option key={d.codigo} value={d.nombre}>
                          {d.nombre}
                        </option>
                      ))}
                    </optgroup>
                  ));
                })()}
              </select>
              <select
                className="inv-select-depto"
                value={filtroCategoria}
                onChange={(e) => setFiltroCategoria(e.target.value)}
                style={{ ...C.selectDepto, minWidth: '140px' }}
              >
                <option value="">Todos los modelos</option>
                {modelos.map((c) => (
                  <option key={c.categoria} value={c.categoria}>
                    {c.categoria} ({c.total_productos})
                  </option>
                ))}
              </select>
              <select
                className="inv-select-depto"
                value={filtroMarca}
                onChange={(e) => setFiltroMarca(e.target.value)}
                style={{ ...C.selectDepto, minWidth: '140px' }}
              >
                <option value="">Todas las marcas</option>
                {marcas.map((m) => (
                  <option key={m.marca} value={m.marca}>
                    {m.marca} ({m.total_productos})
                  </option>
                ))}
              </select>
              <select
                className="inv-select-depto"
                value={filtroTagId || ''}
                onChange={(e) => setFiltroTagId(e.target.value ? Number(e.target.value) : null)}
                style={{ ...C.selectDepto, minWidth: '130px' }}
              >
                <option value="">Todas las etiquetas</option>
                {tagsDisponibles.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.icono ? t.icono + ' ' : ''}{t.nombre} ({t.total_productos ?? 0})
                  </option>
                ))}
              </select>
              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <button
                  onClick={() => {
                    cambiarVista('tabla');
                  }}
                  title="Vista tabla"
                  style={{
                    padding: '6px 10px',
                    borderRadius: '8px',
                    border: vista === 'tabla' ? '2px solid #1a73e8' : '1px solid #dadce0',
                    background: vista === 'tabla' ? '#e8f0fe' : '#fff',
                    color: vista === 'tabla' ? '#1a73e8' : '#5f6368',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FiList size={16} />
                </button>
                <button
                  onClick={() => {
                    cambiarVista('tarjetas');
                  }}
                  title="Vista tarjetas"
                  style={{
                    padding: '6px 10px',
                    borderRadius: '8px',
                    border: vista === 'tarjetas' ? '2px solid #1a73e8' : '1px solid #dadce0',
                    background: vista === 'tarjetas' ? '#e8f0fe' : '#fff',
                    color: vista === 'tarjetas' ? '#1a73e8' : '#5f6368',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FiGrid size={16} />
                </button>
              </div>
            </div>
          )}

          {esTabProductos && filtroEstado !== 'inactivos' && vista === 'tabla' && (
            <>
              {codigosSeleccionados.length > 0 && (
                <SeleccionMasivaBar
                  count={codigosSeleccionados.length}
                  onAsignar={() => setMasivoModal('asignar')}
                  onQuitar={() => setMasivoModal('quitar')}
                  onLimpiar={limpiarSeleccion}
                />
              )}
              <div className="inv-table-wrap" style={C.tableWrap} ref={prodListRef}>
                <table style={C.table}>
                  <thead>
                    <tr>
                      <th style={{ ...C.th, width: '34px' }}>
                        <input
                          type="checkbox"
                          checked={
                            productos.length > 0 &&
                            productos.every((p) => seleccionMasiva[p.codigo])
                          }
                          onChange={toggleSeleccionTodos}
                          style={{ cursor: 'pointer' }}
                        />
                      </th>
                      {v('vis.inventario.imagenes') && <th style={C.th}></th>}
                      {v('vis.inventario.codigo') && thSort('codigo', 'Código')}
                      {thSort('referencia', 'Ref./Serial')}
                      {thSort('nombre', 'Producto')}
                      {v('vis.inventario.precio') && thSort('precio', 'Precio')}
                      {v('vis.inventario.stock') && filtroEstado !== 'servicios' && thSort('stock', 'Stock')}
                      {v('vis.inventario.stock_por_sede') &&
                        filtroEstado !== 'servicios' &&
                        sede === 'todas' &&
                        getSedesActivas().map((s) => (
                          <th
                            key={s.codigo}
                            onClick={() => toggleOrden(s.codigo)}
                            style={{
                              ...C.th,
                              cursor: 'pointer',
                              userSelect: 'none',
                              fontSize: '10px',
                              textAlign: 'center',
                            }}
                            title={`Ordenar por stock en ${s.nombre}`}
                          >
                            {s.nombre}
                            {sedeSortIndicator(s.codigo)}
                          </th>
                        ))}
                      {v('vis.inventario.depto') && thSort('departamento', 'Subgrupo')}
                      <th style={C.th}></th>
                    </tr>
                  </thead>
                  <tbody>
                      {productos.length === 0 && !cargandoProd && (
                        <tr>
                          <td
                            colSpan={
                              4 +
                              (v('vis.inventario.imagenes') ? 1 : 0) +
                              (v('vis.inventario.codigo') ? 1 : 0) +
                              (v('vis.inventario.precio') ? 1 : 0) +
                              (v('vis.inventario.stock') ? 1 : 0) +
                              (v('vis.inventario.depto') ? 1 : 0) +
                              (v('vis.inventario.stock_por_sede') && sede === 'todas'
                                ? getSedesActivas().length
                                : 0)
                            }
                            style={C.emptyRow}
                          >
                            Sin resultados
                          </td>
                        </tr>
                      )}
                    {productos.map((p) => {
                      const sps = p.stock_por_sede || {};
                      return (
                        <tr
                          key={p.codigo}
                          style={{ ...C.tr, transition: 'background 0.15s', cursor: 'pointer' }}
                          className="inv-row"
                          onClick={() => verDetalle(p.codigo)}
                        >
                          <td style={{ ...C.td, width: '34px' }} onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={!!seleccionMasiva[p.codigo]}
                              onChange={() => toggleSeleccion(p.codigo)}
                              style={{ cursor: 'pointer' }}
                            />
                          </td>
                          {v('vis.inventario.imagenes') && (
                            <td style={C.td}>
                              <ImagenProducto
                                imagen_url={p.imagen_url}
                                thumb_url={p.thumb_url}
                                size={32}
                                refreshKey={imgRefreshKey}
                              />
                            </td>
                          )}
                          {v('vis.inventario.codigo') && (
                            <td style={{ ...C.td, fontFamily: 'monospace', fontSize: '12px' }}>
                              {p.codigo}
                            </td>
                          )}
                          <td
                            style={{
                              ...C.td,
                              fontFamily: 'monospace',
                              fontSize: '12px',
                              color: 'var(--agx-muted)',
                            }}
                          >
                            {p.referencia || '-'}
                          </td>
                          <td style={C.td}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                              <span style={{ fontWeight: 500 }}>{p.descripcion}</span>
                              {p.tipo_producto === 'compuesto' && (
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    padding: '1px 7px',
                                    borderRadius: '6px',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    background: '#fef7e0',
                                    color: '#b45309',
                                    whiteSpace: 'nowrap',
                                  }}
                                  title={p.receta?.nombre ? `Receta: ${p.receta.nombre}` : 'Producto compuesto'}
                                >
                                  <FiLayers size={10} /> Compuesto
                                </span>
                              )}
                              {p.tipo_producto === 'servicio' && (
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    padding: '1px 7px',
                                    borderRadius: '6px',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    background: '#e8eaed',
                                    color: '#5f6368',
                                    whiteSpace: 'nowrap',
                                  }}
                                  title="Servicio (sin stock)"
                                >
                                  <FiBriefcase size={10} /> Servicio
                                </span>
                              )}
                            </div>
                            {(p.tags || []).length > 0 && (
                              <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginTop: '3px' }}>
                                {(p.tags || []).map((t) => (
                                  <TagBadge key={t.id} tag={t} />
                                ))}
                              </div>
                            )}
                            {v('vis.inventario.modelo') &&
                              (p.modelo || '').split(', ').filter(Boolean).length > 0 && (
                                <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginTop: '3px' }}>
                                  {(p.modelo || '').split(', ').filter(Boolean).map((m) => (
                                    <span
                                      key={m}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        padding: '1px 6px',
                                        borderRadius: '6px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background: '#e8f0fe',
                                        color: '#1967d2',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {m}
                                    </span>
                                  ))}
                                </div>
                              )}
                            <div style={{ fontSize: '11px', color: 'var(--agx-faint)', marginTop: '2px' }}>
                              {v('vis.inventario.marca') && p.marca && `${p.marca}`}
                              {v('vis.inventario.marca') && p.marca && p.pesable && ' · '}
                              {p.pesable && 'Pesable'}
                            </div>
                          </td>
                          {v('vis.inventario.precio') && (
                            <td style={C.td}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>${fmtMonto(p.precio)}</span>
                                {p.en_promocion && (
                                  <span
                                    style={{
                                      background: '#c5221f',
                                      color: '#fff',
                                      fontSize: '10px',
                                      fontWeight: 700,
                                      padding: '1px 6px',
                                      borderRadius: '8px',
                                    }}
                                  >
                                    -{p.porcentaje_descuento}%
                                  </span>
                                )}
                              </div>
                              {p.en_promocion && p.precio_original != null && (
                                <div
                                  style={{
                                    fontSize: '11px',
                                    color: 'var(--agx-muted)',
                                    textDecoration: 'line-through',
                                  }}
                                >
                                  ${fmtMonto(p.precio_original)}
                                </div>
                              )}
                            </td>
                          )}
                          {v('vis.inventario.stock') && p.tipo_producto !== 'servicio' && (
                            <td style={C.td}>
                              {p.tipo_producto === 'compuesto' ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                  <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                    Real <StockBadge stock={p.stock_fisico ?? 0} />
                                  </span>
                                  <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                    Prod. <StockBadge stock={p.stock_produccion ?? 0} />
                                  </span>
                                </div>
                              ) : (
                                <StockBadge stock={p.stock} />
                              )}
                            </td>
                          )}
                          {v('vis.inventario.stock_por_sede') &&
                            filtroEstado !== 'servicios' &&
                            sede === 'todas' &&
                            getSedesActivas().map((s) => {
                              const st = sps[s.codigo] !== undefined ? sps[s.codigo] : 0;
                              const c = sedeStockColor(st);
                              const esCompuesto = p.tipo_producto === 'compuesto';
                              const esProdCompuesto =
                                esCompuesto && p.stock_cliente !== 'real';
                              return (
                                <td
                                  key={s.codigo}
                                  style={{ ...C.td, textAlign: 'center', padding: '4px' }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      padding: '2px 8px',
                                      borderRadius: '8px',
                                      fontSize: '12px',
                                      fontWeight: 600,
                                      fontFamily: 'monospace',
                                      backgroundColor: esProdCompuesto ? 'transparent' : c.bg,
                                      color: esProdCompuesto ? 'var(--agx-faint)' : c.fg,
                                    }}
                                    title={esProdCompuesto ? 'Stock calculado por receta' : undefined}
                                  >
                                    {esProdCompuesto ? '—' : st}
                                  </span>
                                </td>
                              );
                            })}
                          {v('vis.inventario.depto') && <td style={C.td}>{p.departamento}</td>}
                          <td style={C.td}>
                            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                              {tp('inventario.editar_basico') && !isPlanExterno() && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    abrirEditarProducto(p.codigo);
                                  }}
                                  style={C.btnIconSm}
                                  title="Editar"
                                >
                                  <FiEdit2 size={12} />
                                </button>
                              )}
                              {isPlanExterno() && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    abrirEditarExterno(p.codigo);
                                  }}
                                  style={{ ...C.btnIconSm, color: '#1a73e8' }}
                                  title="Editar info"
                                >
                                  <FiEdit2 size={12} />
                                </button>
                              )}
                              {tp('inventario.editar_basico') && !isPlanExterno() && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTagQuickCodigo(p.codigo);
                                  }}
                                  style={{ ...C.btnIconSm, color: '#0d904f' }}
                                  title="Etiquetas"
                                >
                                  <FiStar size={12} />
                                </button>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTicketArticulo({ producto: { codigo: p.codigo, descripcion: p.descripcion, precio: p.precio }, modo: 'identificacion' });
                                }}
                                style={{ ...C.btnIconSm, color: '#5f6368' }}
                                title="Etiqueta de identificación (código de barras)"
                              >
                                <FiClipboard size={12} />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTicketArticulo({ producto: { codigo: p.codigo, descripcion: p.descripcion, precio: p.precio }, modo: 'precio' });
                                }}
                                style={{ ...C.btnIconSm, color: '#137333' }}
                                title="Etiqueta de precio"
                              >
                                <FiDollarSign size={12} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {cargandoProd && <Spinner />}
              {hasMore && !cargandoProd && (
                <div style={{ textAlign: 'center', padding: '12px' }}>
                  <button onClick={() => cargarProductos(false)} style={C.btnCargarMas}>
                    Cargar mas
                  </button>
                </div>
              )}
            </>
          )}

          {esTabProductos && filtroEstado !== 'inactivos' && vista === 'tarjetas' && (
            <>
              {codigosSeleccionados.length > 0 && (
                <SeleccionMasivaBar
                  count={codigosSeleccionados.length}
                  onAsignar={() => setMasivoModal('asignar')}
                  onQuitar={() => setMasivoModal('quitar')}
                  onLimpiar={limpiarSeleccion}
                />
              )}
              <div
                ref={prodListRef}
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
                  gap: '12px',
                  paddingBottom: '12px',
                }}
              >
                {productos.length === 0 && !cargandoProd && (
                  <div
                    style={{
                      gridColumn: '1 / -1',
                      textAlign: 'center',
                      padding: '40px',
                      color: 'var(--agx-faint)',
                      fontSize: '14px',
                    }}
                  >
                    Sin resultados
                  </div>
                )}
                {productos.map((p) => {
                  const imagenes = p.imagenes || [];
                  const isHovered = hoveredCodigo === p.codigo;
                  const currentMedia =
                    isHovered && imagenes.length > 1
                      ? imagenes[1]
                      : imagenes.length > 0
                        ? imagenes[0]
                        : null;
                  const isVideo = currentMedia?.tipo === 'video';
                  const showThumb = !isHovered && getImagenUrl(p.thumb_url || p.imagen_url);
                  return (
                    <div
                      key={p.codigo}
                      style={{
                        background: '#fff',
                        borderRadius: '14px',
                        border: '1px solid #e8eaed',
                        overflow: 'hidden',
                        transition: 'box-shadow 0.2s, transform 0.15s',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        setHoveredCodigo(p.codigo);
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.transform = 'none';
                        setHoveredCodigo(null);
                      }}
                      onClick={() => verDetalle(p.codigo)}
                    >
                      <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          left: '8px',
                          zIndex: 3,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={!!seleccionMasiva[p.codigo]}
                          onChange={() => toggleSeleccion(p.codigo)}
                          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                        />
                      </div>
                      {v('vis.inventario.imagenes') && (
                        <div
                          style={{
                            width: '100%',
                            height: '160px',
                            background: '#f8f9fa',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                          }}
                        >
                          {isVideo ? (
                            <video
                              src={getImagenUrl(currentMedia.url)}
                              autoPlay
                              muted
                              loop
                              playsInline
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : showThumb ? (
                            <img
                              src={getImagenUrl(p.thumb_url || p.imagen_url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : currentMedia ? (
                            <img
                              src={getImagenUrl(currentMedia.url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : getImagenUrl(p.thumb_url || p.imagen_url) ? (
                            <img
                              src={getImagenUrl(p.thumb_url || p.imagen_url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <FiPackage size={40} color="#dadce0" />
                          )}
                          {p.pesable && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '8px',
                                left: '8px',
                                background: 'rgba(123,31,162,0.85)',
                                color: '#fff',
                                fontSize: '10px',
                                fontWeight: 600,
                                padding: '2px 8px',
                                borderRadius: '6px',
                              }}
                            >
                              PES
                            </span>
                          )}
                        </div>
                      )}
                      <div
                        style={{
                          padding: '12px',
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '4px',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: 500,
                            color: '#202124',
                            lineHeight: '1.3',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                          }}
                        >
                          {p.descripcion}
                        </div>
                        {p.tipo_producto === 'compuesto' && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginTop: '3px' }}>
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px',
                                padding: '1px 7px',
                                borderRadius: '6px',
                                fontSize: '10px',
                                fontWeight: 700,
                                background: '#fef7e0',
                                color: '#b45309',
                                whiteSpace: 'nowrap',
                              }}
                              title={p.receta?.nombre ? `Receta: ${p.receta.nombre}` : 'Producto compuesto'}
                            >
                              <FiLayers size={10} /> Compuesto
                            </span>
                          </div>
                        )}
                        {p.tipo_producto === 'servicio' && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginTop: '3px' }}>
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px',
                                padding: '1px 7px',
                                borderRadius: '6px',
                                fontSize: '10px',
                                fontWeight: 700,
                                background: '#e8eaed',
                                color: '#5f6368',
                                whiteSpace: 'nowrap',
                              }}
                              title="Servicio (sin stock)"
                            >
                              <FiBriefcase size={10} /> Servicio
                            </span>
                          </div>
                        )}
                        {v('vis.inventario.codigo') && (
                          <div
                            style={{
                              fontSize: '11px',
                              color: 'var(--agx-faint)',
                              fontFamily: 'monospace',
                            }}
                          >
                            {p.codigo}
                          </div>
                        )}
                        <div
                          style={{
                            fontSize: '11px',
                            color: 'var(--agx-muted)',
                            fontFamily: 'monospace',
                          }}
                        >
                          {p.referencia || '-'}
                        </div>
                        {v('vis.inventario.modelo') &&
                          (p.modelo || '').split(', ').filter(Boolean).length > 0 && (
                            <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginTop: '3px' }}>
                              {(p.modelo || '').split(', ').filter(Boolean).map((m) => (
                                <span
                                  key={m}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    padding: '1px 6px',
                                    borderRadius: '6px',
                                    fontSize: '10px',
                                    fontWeight: 600,
                                    background: '#e8f0fe',
                                    color: '#1967d2',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {m}
                                </span>
                              ))}
                            </div>
                          )}
                        {(p.tags || []).length > 0 && (
                          <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginTop: '3px' }}>
                            {(p.tags || []).map((t) => (
                              <TagBadge key={t.id} tag={t} />
                            ))}
                          </div>
                        )}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '4px',
                          }}
                        >
                          {v('vis.inventario.precio') && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span style={{ fontSize: '16px', fontWeight: 700, color: '#1a73e8' }}>
                                ${fmtMonto(p.precio)}
                              </span>
                              {p.en_promocion && (
                                <span
                                  style={{
                                    background: '#c5221f',
                                    color: '#fff',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    padding: '1px 6px',
                                    borderRadius: '8px',
                                  }}
                                >
                                  -{p.porcentaje_descuento}%
                                </span>
                              )}
                            </span>
                          )}
                          {v('vis.inventario.stock') && p.tipo_producto !== 'servicio' &&
                            (p.tipo_producto === 'compuesto' ? (
                              <span style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                  Real <StockBadge stock={p.stock_fisico ?? 0} />
                                </span>
                                <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                  Prod. <StockBadge stock={p.stock_produccion ?? 0} />
                                </span>
                              </span>
                            ) : (
                              <StockBadge stock={p.stock} />
                            ))}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            gap: '4px',
                            marginTop: '8px',
                            flexWrap: 'wrap',
                          }}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              verDetalle(p.codigo);
                            }}
                            style={{
                              ...C.btnDetalle,
                              fontSize: '11px',
                              padding: '4px 10px',
                              flex: 1,
                            }}
                          >
                            Detalle
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setTicketArticulo({ producto: { codigo: p.codigo, descripcion: p.descripcion, precio: p.precio }, modo: 'identificacion' });
                            }}
                            style={{
                              padding: '4px 8px',
                              borderRadius: '6px',
                              border: '1px solid #dadce0',
                              background: '#fff',
                              color: '#5f6368',
                              cursor: 'pointer',
                            }}
                            title="Etiqueta de identificación (código de barras)"
                          >
                            <FiClipboard size={13} />
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setTicketArticulo({ producto: { codigo: p.codigo, descripcion: p.descripcion, precio: p.precio }, modo: 'precio' });
                            }}
                            style={{
                              padding: '4px 8px',
                              borderRadius: '6px',
                              border: '1px solid #dadce0',
                              background: '#fff',
                              color: '#137333',
                              cursor: 'pointer',
                            }}
                            title="Etiqueta de precio"
                          >
                            <FiDollarSign size={13} />
                          </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                abrirEditarExterno(p.codigo);
                              }}
                              style={{
                                padding: '4px 8px',
                                borderRadius: '6px',
                                border: '1px solid #1a73e8',
                                background: '#e8f0fe',
                                color: '#1a73e8',
                                cursor: 'pointer',
                              }}
                              title="Editar info"
                            >
                              <FiEdit2 size={13} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {cargandoProd && <Spinner />}
              {hasMore && !cargandoProd && (
                <div style={{ textAlign: 'center', padding: '12px' }}>
                  <button onClick={() => cargarProductos(false)} style={C.btnCargarMas}>
                    Cargar mas
                  </button>
                </div>
              )}
            </>
          )}

          {esTabProductos && filtroEstado === 'inactivos' && (
            <div>
              <div className="inv-table-wrap" style={C.tableWrap}>
                {cargandoInactivos ? (
                  <Spinner />
                ) : (
                  <table style={C.table}>
                    <thead>
                      <tr>
                        <th style={C.th}></th>
                        {v('vis.inventario.codigo') && <th style={C.th}>Codigo</th>}
                        <th style={C.th}>Producto</th>
                        {v('vis.inventario.precio') && <th style={C.th}>Precio</th>}
                        {v('vis.inventario.depto') && <th style={C.th}>Subgrupo</th>}
                        <th style={C.th}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {productosInactivos.length === 0 && (
                        <tr>
                          <td colSpan={6} style={C.emptyRow}>
                            No hay productos inactivos
                          </td>
                        </tr>
                      )}
                      {productosInactivos.map((p) => (
                        <tr key={p.codigo} style={{ ...C.tr, opacity: 0.7 }}>
                          {v('vis.inventario.imagenes') && (
                            <td style={C.td}>
                              <ImagenProducto
                                imagen_url={p.imagen_url}
                                thumb_url={p.thumb_url}
                                size={32}
                                refreshKey={imgRefreshKey}
                              />
                            </td>
                          )}
                          <td style={{ ...C.td, fontFamily: 'monospace', fontSize: '12px' }}>
                            {p.codigo}
                          </td>
                          <td style={C.td}>
                            <div style={{ fontWeight: 500 }}>{p.descripcion}</div>
                            {v('vis.inventario.modelo') &&
                              (p.modelo || '').split(', ').filter(Boolean).length > 0 && (
                                <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginTop: '3px' }}>
                                  {(p.modelo || '').split(', ').filter(Boolean).map((m) => (
                                    <span
                                      key={m}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        padding: '1px 6px',
                                        borderRadius: '6px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background: '#e8f0fe',
                                        color: '#1967d2',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {m}
                                    </span>
                                  ))}
                                </div>
                              )}
                            <div style={{ fontSize: '11px', color: 'var(--agx-faint)', marginTop: '2px' }}>
                              {v('vis.inventario.marca') && p.marca && `${p.marca}`}
                            </div>
                          </td>
                          {v('vis.inventario.precio') && (
                            <td style={C.td}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>${fmtMonto(p.precio)}</span>
                                {p.en_promocion && (
                                  <span
                                    style={{
                                      background: '#c5221f',
                                      color: '#fff',
                                      fontSize: '10px',
                                      fontWeight: 700,
                                      padding: '1px 6px',
                                      borderRadius: '8px',
                                    }}
                                  >
                                    -{p.porcentaje_descuento}%
                                  </span>
                                )}
                              </div>
                              {p.en_promocion && p.precio_original != null && (
                                <div
                                  style={{
                                    fontSize: '11px',
                                    color: 'var(--agx-muted)',
                                    textDecoration: 'line-through',
                                  }}
                                >
                                  ${fmtMonto(p.precio_original)}
                                </div>
                              )}
                            </td>
                          )}
                          {v('vis.inventario.depto') && <td style={C.td}>{p.departamento}</td>}
                          <td style={C.td}>
                            {!isPlanExterno() && (
                              <button
                                onClick={() => toggleProducto(p.codigo)}
                                style={{ ...C.btnAdd, fontSize: '11px', padding: '4px 10px' }}
                              >
                                Reactivar
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

          {tab === 'deptos' && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px', gap: '8px', flexWrap: 'wrap' }}>
                {tp('inventario.departamentos') && !isPlanExterno() && (
                  <>
                    <button
                      onClick={() => setGrupoModal('lista')}
                      style={{ ...C.btnDetalle, display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <FiFolder size={14} /> Gestionar grupos
                    </button>
                    <button
                      onClick={abrirCrearDepto}
                      style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <FiPlus size={14} /> Nuevo subgrupo
                    </button>
                  </>
                )}
              </div>
              {departamentos.length === 0 ? (
                <EmptyState
                  icon={FiFolder}
                  title="No hay subgrupos"
                  description="Crea tu primer subgrupo para organizar el catálogo por categorías."
                  action={tp('inventario.departamentos') && !isPlanExterno() ? abrirCrearDepto : undefined}
                  actionLabel="Nuevo subgrupo"
                />
              ) : (
                (function () {
                  const PALETTE = [
                    '#1a73e8', '#0d8043', '#c5221f', '#e37400', '#7b1fa2',
                    '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                    '#f9ab00', '#185abc', '#129eaf', '#ea8600', '#a142f4',
                  ];
                  const grouped = {};
                  departamentos.forEach((d) => {
                    const g = d.grupo_nombre || d.grupo || 'Sin categoría';
                    if (!grouped[g]) grouped[g] = [];
                    grouped[g].push(d);
                  });
                  const groupNames = Object.keys(grouped).sort();
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {groupNames.map((grupo, idx) => {
                        const color = PALETTE[idx % PALETTE.length];
                        const isOpen = expandedGroups[grupo] !== false;
                        return (
                          <div
                            key={grupo}
                            style={{
                              borderRadius: '12px',
                              border: '1px solid #e8eaed',
                              background: '#fff',
                              overflow: 'hidden',
                              transition: 'box-shadow 0.15s',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '14px 16px',
                                background: isOpen ? `${color}08` : '#fff',
                                borderLeft: `4px solid ${color}`,
                                transition: 'background 0.15s',
                              }}
                            >
                              <button
                                onClick={() =>
                                  setExpandedGroups((prev) => ({ ...prev, [grupo]: !prev[grupo] }))
                                }
                                style={{
                                  flex: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '12px',
                                  padding: 0,
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  fontFamily: 'inherit',
                                  textAlign: 'left',
                                  minWidth: 0,
                                }}
                              >
                                <div
                                  style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '10px',
                                    background: `${color}15`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                  }}
                                >
                                  <FiFolder size={18} color={color} />
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ fontSize: '14px', fontWeight: 600, color: '#202124' }}>
                                    {grupo}
                                  </div>
                                  <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '1px' }}>
                                    {grouped[grupo].length} subcategorías
                                  </div>
                                </div>
                                <span
                                  style={{
                                    ...BS.blue,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    padding: '2px 10px',
                                    borderRadius: '20px',
                                    background: `${color}12`,
                                    color,
                                    flexShrink: 0,
                                  }}
                                >
                                  {grouped[grupo].length}
                                </span>
                                <span
                                  style={{
                                    fontSize: '16px',
                                    color: '#9aa0a6',
                                    transition: 'transform 0.2s',
                                    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                  }}
                                >
                                  ›
                                </span>
                              </button>
                              {tp('inventario.departamentos') && !isPlanExterno() && (() => {
                                const codigoGrupo =
                                  (grupos.find((g) => g.descripcion === grupo) || {}).codigo ||
                                  grouped[grupo][0]?.grupo ||
                                  '';
                                return codigoGrupo ? (
                                  <button
                                    onClick={() =>
                                      abrirEditarGrupo({ codigo: codigoGrupo, descripcion: grupo })
                                    }
                                    style={{ ...C.btnIconSm, flexShrink: 0 }}
                                    title="Editar grupo"
                                  >
                                    <FiEdit2 size={13} />
                                  </button>
                                ) : null;
                              })()}
                            </div>
                            {isOpen && (
                              <div
                                className="inv-table-wrap"
                                style={{ ...C.tableWrap, margin: '0 16px 16px 16px' }}
                              >
                                <table style={C.table}>
                                  <thead>
                                    <tr>
                                      <th style={C.th}>Código</th>
                                      <th style={C.th}>Nombre</th>
                                      <th style={C.th}>Productos</th>
                                      <th style={C.th}></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {grouped[grupo].map((d) => (
                                      <tr key={d.codigo} style={C.tr}>
                                        <td style={{ ...C.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                          {d.codigo}
                                        </td>
                                        <td style={{ ...C.td, fontWeight: 500 }}>{d.nombre}</td>
                                        <td style={C.td}>
                                          <span style={{ ...BS.blue, fontSize: '11px' }}>
                                            {d.total_productos ?? '-'}
                                          </span>
                                        </td>
                                        <td style={C.td}>
                                          <div style={{ display: 'flex', gap: '4px' }}>
                                            {tp('inventario.departamentos') && !isPlanExterno() && (
                                              <>
                                                <button
                                                  onClick={() => abrirEditarDepto(d)}
                                                  style={C.btnIconSm}
                                                  title="Editar"
                                                >
                                                  <FiEdit2 size={12} />
                                                </button>
                                                <button
                                                  onClick={() => eliminarDepto(d.codigo)}
                                                  style={{ ...C.btnIconSm, color: '#ea4335' }}
                                                  title="Eliminar"
                                                >
                                                  <FiTrash2 size={12} />
                                                </button>
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()
              )}
            </div>
          )}

          {tab === 'modelos' && (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}
              >
                <div style={{ color: 'var(--agx-muted)', fontSize: '12px', maxWidth: '560px' }}>
                  Gestiona los modelos de vehículo. Crea, renombra o elimina modelos y usa «Gestionar
                  productos» para asignarles artículos. Un producto puede estar en varios modelos.
                </div>
                {tp('inventario.modelos') && !isPlanExterno() && (
                  <button
                    onClick={abrirNuevoModelo}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <FiPlus size={14} /> Nuevo modelo
                  </button>
                )}
              </div>
              {modelos.length === 0 ? (
                <EmptyState
                  icon={FiGrid}
                  title="No hay modelos definidos"
                  description="Crea modelos de vehículo para agrupar productos y autopartes relacionados."
                  action={tp('inventario.modelos') && !isPlanExterno() ? abrirNuevoModelo : undefined}
                  actionLabel="Nuevo modelo"
                />
              ) : (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                    gap: '12px',
                  }}
                >
                  {modelos.map((m, idx) => {
                    const color = [
                      '#0d8043', '#1a73e8', '#c5221f', '#e37400', '#7b1fa2',
                      '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                    ][idx % 10];
                    return (
                      <div
                        key={m.categoria}
                        style={{
                          borderRadius: '14px',
                          border: '1px solid #e8eaed',
                          background: '#fff',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                          transition: 'box-shadow 0.15s',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '14px 16px 10px',
                            borderLeft: `4px solid ${color}`,
                          }}
                        >
                          <div
                            style={{
                              width: '38px',
                              height: '38px',
                              borderRadius: '10px',
                              background: `${color}15`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <FiGrid size={18} color={color} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#202124',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {m.categoria}
                            </div>
                            <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '1px' }}>
                              {m.total_productos} productos
                            </div>
                          </div>
                        </div>
                        <div style={{ padding: '0 16px 16px', display: 'flex', gap: '6px', marginTop: 'auto' }}>
                          <button
                            onClick={() => verProductosDeModelo(m.categoria)}
                            title="Ver productos de este modelo"
                            style={{
                              flex: 1,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              padding: '9px 12px',
                              borderRadius: '9px',
                              border: `1px solid ${color}`,
                              background: `${color}08`,
                              color,
                              fontSize: '12px',
                              fontWeight: 600,
                              cursor: 'pointer',
                              fontFamily: 'inherit',
                            }}
                          >
                            <FiEye size={14} /> Ver productos
                          </button>
                          <button
                            onClick={() => abrirModeloModal(m.categoria)}
                            title="Gestionar productos"
                            style={{ ...C.btnIconSm, padding: '9px 10px' }}
                          >
                            <FiPlus size={14} />
                          </button>
                          {tp('inventario.modelos') && !isPlanExterno() && (
                            <>
                              <button
                                onClick={() => abrirRenombrarModelo(m.categoria)}
                                title="Renombrar"
                                style={{ ...C.btnIconSm, padding: '9px 10px' }}
                              >
                                <FiEdit2 size={14} />
                              </button>
                              <button
                                onClick={() => eliminarModelo(m.categoria)}
                                title="Eliminar"
                                style={{ ...C.btnIconSm, color: '#ea4335', padding: '9px 10px' }}
                              >
                                <FiTrash2 size={14} />
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {tab === 'marcas' && (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}
              >
                <div style={{ color: 'var(--agx-muted)', fontSize: '12px', maxWidth: '560px' }}>
                  Gestiona las marcas de tus productos. Crea, renombra, fusiona o elimina una marca;
                  el cambio se aplica en cadena a todos los productos que la usan.
                </div>
                {tp('inventario.marcas') && !isPlanExterno() && (
                  <button
                    onClick={abrirNuevaMarca}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <FiPlus size={14} /> Nueva marca
                  </button>
                )}
              </div>
              {cargandoMarcas ? (
                <Spinner />
              ) : marcas.length === 0 ? (
                <EmptyState
                  icon={FiTag}
                  title="No hay marcas definidas"
                  description="Las marcas se asignan al crear o editar un producto, en el campo 'Marca'."
                />
              ) : (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                    gap: '12px',
                  }}
                >
                  {marcas.map((m, idx) => {
                    const color = [
                      '#e37400', '#1a73e8', '#0d8043', '#c5221f', '#7b1fa2',
                      '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                    ][idx % 10];
                    return (
                      <div
                        key={m.marca}
                        style={{
                          borderRadius: '14px',
                          border: '1px solid #e8eaed',
                          background: '#fff',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '14px 16px 10px',
                            borderLeft: `4px solid ${color}`,
                          }}
                        >
                          <div
                            style={{
                              width: '38px',
                              height: '38px',
                              borderRadius: '10px',
                              background: `${color}15`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <FiTag size={18} color={color} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#202124',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {m.marca}
                            </div>
                            <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '1px' }}>
                              {m.total_productos} productos
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            padding: '0 16px 16px',
                            display: 'flex',
                            gap: '6px',
                            marginTop: 'auto',
                          }}
                        >
                          <button
                            onClick={() => verProductosDeMarca(m.marca)}
                            style={{
                              flex: 1,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              padding: '9px 12px',
                              borderRadius: '9px',
                              border: `1px solid ${color}`,
                              background: `${color}08`,
                              color,
                              fontSize: '12px',
                              fontWeight: 600,
                              cursor: 'pointer',
                              fontFamily: 'inherit',
                            }}
                          >
                            <FiEye size={14} /> Ver productos
                          </button>
                          {tp('inventario.marcas') && !isPlanExterno() && (
                            <>
                              <button
                                onClick={() => {
                                  setMarcaModal({ accion: 'renombrar', marca: m.marca });
                                  setMarcaForm(m.marca);
                                }}
                                title="Renombrar"
                                style={{ ...C.btnIconSm, padding: '9px 10px' }}
                              >
                                <FiEdit2 size={14} />
                              </button>
                              <button
                                onClick={() => {
                                  setMarcaModal({ accion: 'merge', marca: m.marca });
                                  setMarcaForm('');
                                }}
                                title="Fusionar en otra marca"
                                style={{ ...C.btnIconSm, padding: '9px 10px' }}
                              >
                                <FiLayers size={14} />
                              </button>
                              <button
                                onClick={() => eliminarMarca(m.marca)}
                                title="Eliminar"
                                style={{ ...C.btnIconSm, color: '#ea4335', padding: '9px 10px' }}
                              >
                                <FiTrash2 size={14} />
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {tab === 'combos' && (
            <div>
              {/* ─────────── Descuentos ─────────── */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '12px',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}
              >
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FiTag size={18} color="#c5221f" />
                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#202124' }}>
                      Descuentos
                    </h3>
                  </div>
                  <div style={{ color: 'var(--agx-muted)', fontSize: '12px', marginTop: '2px' }}>
                    Productos con el precio rebajado. Busca un producto y aplica un descuento.
                  </div>
                </div>
                {puedeGestionarDescuentos() && (
                  <button
                    onClick={abrirDescuentoModal}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <FiPlus size={14} /> Nuevo descuento
                  </button>
                )}
              </div>

              {cargandoDescuentos ? (
                <Spinner />
              ) : descuentos.length === 0 ? (
                <div
                  style={{
                    padding: '20px',
                    textAlign: 'center',
                    color: 'var(--agx-muted)',
                    fontSize: '13px',
                    border: '1px dashed var(--agx-border)',
                    borderRadius: '10px',
                    marginBottom: '24px',
                  }}
                >
                  No hay productos con descuento.
                </div>
              ) : (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
                    gap: '12px',
                    marginBottom: '28px',
                  }}
                >
                  {descuentos.map((d) => (
                    <div
                      key={d.codigo}
                      style={{
                        borderRadius: '12px',
                        border: '1px solid #fce8e6',
                        background: '#fff',
                        padding: '12px',
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                      }}
                    >
                      {v('vis.inventario.imagenes') && (
                        <ImagenProducto imagen_url={d.imagen_url} thumb_url={d.thumb_url} size={44} />
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#202124',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {d.descripcion}
                        </div>
                        <div
                          style={{
                            fontSize: '11px',
                            color: 'var(--agx-muted)',
                            textDecoration: 'line-through',
                          }}
                        >
                          ${d.precio_original != null ? fmtMonto(d.precio_original) : '—'}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '15px', fontWeight: 700, color: '#c5221f' }}>
                            ${d.precio != null ? fmtMonto(d.precio) : '0.00'}
                          </span>
                          {d.porcentaje_descuento != null && (
                            <span
                              style={{
                                background: '#c5221f',
                                color: '#fff',
                                fontSize: '10px',
                                fontWeight: 700,
                                padding: '1px 6px',
                                borderRadius: '8px',
                              }}
                            >
                              -{d.porcentaje_descuento}%
                            </span>
                          )}
                        </div>
                      </div>
                      {puedeGestionarDescuentos() && (
                        <button
                          onClick={() => quitarDescuento(d)}
                          title="Quitar descuento"
                          style={{ ...C.btnIconSm, color: '#ea4335', flexShrink: 0 }}
                        >
                          <FiTrash2 size={13} />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* ─────────── Combos ─────────── */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '12px',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}
              >
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FiLayers size={18} color="#0d8043" />
                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#202124' }}>
                      Combos
                    </h3>
                  </div>
                  <div style={{ color: 'var(--agx-muted)', fontSize: '12px', marginTop: '2px' }}>
                    Paquetes de productos con precio cerrado. El cliente ve cuánto se ahorra.
                  </div>
                </div>
                {puedeGestionarCombos() && (
                  <button
                    onClick={() => abrirComboEditor(null)}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <FiPlus size={14} /> Nuevo combo
                  </button>
                )}
              </div>

              {cargandoCombos ? (
                <Spinner />
              ) : combos.length === 0 ? (
                <div
                  style={{
                    padding: '20px',
                    textAlign: 'center',
                    color: 'var(--agx-muted)',
                    fontSize: '13px',
                    border: '1px dashed var(--agx-border)',
                    borderRadius: '10px',
                  }}
                >
                  No hay combos creados.
                </div>
              ) : (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                    gap: '14px',
                  }}
                >
                  {combos.map((c, idx) => {
                    const color = [
                      '#c5221f', '#0d8043', '#1a73e8', '#e37400', '#7b1fa2',
                      '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                    ][idx % 10];
                    const pctAhorro = c.precio_sin_descuento > 0
                      ? Math.round((c.ahorro / c.precio_sin_descuento) * 100)
                      : 0;
                    return (
                      <div
                        key={c.id}
                        onClick={() => abrirComboDetalle(c)}
                        style={{
                          borderRadius: '14px',
                          border: '1px solid #e8eaed',
                          background: '#fff',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                          opacity: c.activo ? 1 : 0.6,
                          transition: 'transform 0.15s, box-shadow 0.15s',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.10)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
                        }}
                      >
                        <div
                          style={{
                            height: '104px',
                            background: c.imagen_url ? '#f1f3f4' : `linear-gradient(135deg, ${color}18, ${color}08)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            borderBottom: `3px solid ${color}`,
                            overflow: 'hidden',
                          }}
                        >
                          {c.imagen_url ? (
                            <img
                              src={getImagenUrl(c.imagen_url)}
                              alt=""
                              onError={(e) => (e.currentTarget.style.display = 'none')}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              style={{
                                width: '52px',
                                height: '52px',
                                borderRadius: '14px',
                                background: `${color}20`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <FiLayers size={26} color={color} />
                            </div>
                          )}
                          {!c.activo && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 8,
                                left: 8,
                                ...BS.amber,
                              }}
                            >
                              Inactivo
                            </span>
                          )}
                        </div>

                        <div style={{ padding: '14px 16px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <div
                            style={{
                              fontSize: '14px',
                              fontWeight: 600,
                              color: '#202124',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {c.nombre}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <span style={{ fontSize: '20px', fontWeight: 700, color: '#202124' }}>
                              ${fmtMonto(c.precio || 0)}
                            </span>
                            {c.ahorro > 0 && (
                              <span
                                style={{
                                  ...BS.green,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                }}
                              >
                                <FiTrendingDown size={12} /> Ahorras ${fmtMonto(c.ahorro)}
                                {pctAhorro > 0 ? ` (${pctAhorro}%)` : ''}
                              </span>
                            )}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#5f6368' }}>
                            <FiBox size={12} />
                            {c.items.length} componente{c.items.length === 1 ? '' : 's'}
                          </div>
                          {c.descripcion && (
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#5f6368',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {c.descripcion}
                            </div>
                          )}
                        </div>

                        <div
                          style={{
                            padding: '10px 16px',
                            marginTop: 'auto',
                            borderTop: '1px solid #f1f3f4',
                            display: 'flex',
                            gap: '6px',
                          }}
                        >
                          {puedeGestionarCombos() && (
                            <>
                              <button
                                onClick={(e) => { e.stopPropagation(); abrirComboEditor(c); }}
                                style={{
                                  flex: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  padding: '8px 10px',
                                  borderRadius: '8px',
                                  border: `1px solid ${color}`,
                                  background: `${color}08`,
                                  color,
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  cursor: 'pointer',
                                  fontFamily: 'inherit',
                                }}
                              >
                                <FiEdit2 size={13} /> Editar
                              </button>
                              <button
                                onClick={(e) => { e.stopPropagation(); toggleCombo(c); }}
                                title={c.activo ? 'Desactivar' : 'Activar'}
                                style={{
                                  padding: '8px 10px',
                                  borderRadius: '8px',
                                  border: '1px solid #dadce0',
                                  background: '#fff',
                                  color: '#5f6368',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {c.activo ? <FiEyeOff size={13} /> : <FiEye size={13} />}
                              </button>
                              <button
                                onClick={(e) => { e.stopPropagation(); eliminarCombo(c); }}
                                title="Eliminar"
                                style={{
                                  padding: '8px 10px',
                                  borderRadius: '8px',
                                  border: '1px solid #dadce0',
                                  background: '#fff',
                                  color: '#ea4335',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <FiTrash2 size={13} />
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {tab === 'depositos' && <DepositosTab />}

          {tab === 'extras' && <ExtrasTab />}

          {tab === 'tags' && (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}
              >
                <div style={{ color: 'var(--agx-muted)', fontSize: '12px', maxWidth: '560px' }}>
                  Las etiquetas son badges visuales que resaltan productos en el catálogo del cliente
                  y en esta tabla. Crea una etiqueta (ej. "Recién llegado") y asígnala a los productos
                  que quieras destacar.
                </div>
                <button
                  onClick={abrirNuevoTag}
                  style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <FiPlus size={14} /> Nueva etiqueta
                </button>
              </div>

              {cargandoTags ? (
                <Spinner />
              ) : tagsDisponibles.length === 0 ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    padding: '56px 20px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '18px',
                      background: '#0d904f12',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FiStar size={30} color="#0d904f" />
                  </div>
                  <div style={{ fontSize: '15px', fontWeight: 600, color: '#202124' }}>
                    Aún no hay etiquetas
                  </div>
                  <div style={{ fontSize: '12px', color: '#5f6368', maxWidth: '380px', lineHeight: '1.5' }}>
                    Crea tu primera etiqueta para resaltar productos, como "Recién llegado", "Destacado"
                    o "De temporada".
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {tagsDisponibles.map((t) => (
                    <div
                      key={t.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 16px',
                        borderRadius: '10px',
                        border: '1px solid var(--agx-border, #e8eaef)',
                        background: '#fff',
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '3px 10px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: 700,
                          background: t.color,
                          color: '#fff',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {t.icono && <span>{t.icono}</span>}
                        {t.nombre}
                      </span>
                      <div style={{ fontSize: '12px', color: '#5f6368', flex: 1 }}>
                        {t.total_productos ?? 0} producto(s)
                      </div>
                      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <button
                          onClick={() => toggleTagPrioridad(t)}
                          title={t.prioridad ? 'Quitar de prioridad (destacada en el catálogo)' : 'Marcar como prioridad (destacada en el catálogo)'}
                          style={{
                            padding: '8px 10px',
                            borderRadius: '8px',
                            border: t.prioridad ? '1px solid #f0b400' : '1px solid #dadce0',
                            background: t.prioridad ? '#fffbe6' : '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: t.prioridad ? '#f0b400' : '#9aa0a6',
                          }}
                        >
                          <FiStar size={14} />
                        </button>
                        <button
                          onClick={() => moverTag(t, -1)}
                          title="Subir"
                          style={{
                            padding: '8px 8px',
                            borderRadius: '8px',
                            border: '1px solid #dadce0',
                            background: '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#5f6368',
                          }}
                        >
                          <FiArrowUp size={14} />
                        </button>
                        <button
                          onClick={() => moverTag(t, 1)}
                          title="Bajar"
                          style={{
                            padding: '8px 8px',
                            borderRadius: '8px',
                            border: '1px solid #dadce0',
                            background: '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#5f6368',
                          }}
                        >
                          <FiArrowDown size={14} />
                        </button>
                      </div>
                      <button
                        onClick={() => verProductosDeTag(t)}
                        title="Ver y editar productos de esta etiqueta"
                        style={{
                          padding: '8px 12px',
                          borderRadius: '8px',
                          border: '1px solid #dadce0',
                          background: '#fff',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '4px',
                          fontSize: '12px',
                          fontWeight: 600,
                          color: '#1a73e8',
                        }}
                      >
                        <FiPackage size={14} /> Ver productos
                      </button>
                      <button
                        onClick={() => toggleTagActivo(t)}
                        title={t.activo ? 'Desactivar' : 'Activar'}
                        style={{
                          padding: '8px 10px',
                          borderRadius: '8px',
                          border: '1px solid #dadce0',
                          background: '#fff',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: t.activo ? '#0d904f' : '#9aa0a6',
                        }}
                      >
                        {t.activo ? <FiEye size={14} /> : <FiEyeOff size={14} />}
                      </button>
                      <button
                        onClick={() => abrirEditarTag(t)}
                        title="Editar"
                        style={{
                          padding: '8px 10px',
                          borderRadius: '8px',
                          border: '1px solid #dadce0',
                          background: '#fff',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#5f6368',
                        }}
                      >
                        <FiEdit2 size={14} />
                      </button>
                      <button
                        onClick={() => eliminarTag(t)}
                        title="Eliminar"
                        style={{
                          padding: '8px 10px',
                          borderRadius: '8px',
                          border: '1px solid #dadce0',
                          background: '#fff',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ea4335',
                        }}
                      >
                        <FiTrash2 size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {productoDetalle && (
            <div style={M.overlay} onClick={() => setProductoDetalle(null)}>
              <div className="inv-modal" style={M.modalWide} onClick={(e) => e.stopPropagation()}>
                <button onClick={() => setProductoDetalle(null)} style={M.closeBtn}>
                  <FiX size={20} />
                </button>
                <button
                  onClick={() => compartirProducto(productoDetalle)}
                  title="Compartir por WhatsApp"
                  aria-label="Compartir por WhatsApp"
                  style={M.shareBtn}
                >
                  <FiShare2 size={18} />
                </button>
                <div style={M.detHero} className="inv-det-hero">
                  {v('vis.inventario.imagenes') && (
                    <div style={M.detHeroImg} className="inv-det-hero-img">
                      {productoDetalle.imagenes?.length > 0 ? (
                        <>
                          <div
                            style={M.detHeroViewer}
                            className="inv-det-hero-viewer"
                            onClick={() =>
                              setVisorOpen({
                                images:
                                  productoDetalle.imagenes?.length > 0
                                    ? productoDetalle.imagenes
                                    : [{ url: productoDetalle.imagen_url }],
                                currentIndex: detGalIdx,
                              })
                            }
                          >
                            {productoDetalle.imagenes[detGalIdx]?.tipo === 'video' ? (
                              <video
                                src={getImagenUrl(productoDetalle.imagenes[detGalIdx].url)}
                                controls
                                playsInline
                                loop
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                  background: '#000',
                                }}
                              />
                            ) : (
                              <img
                                src={
                                  getImagenUrl(
                                    productoDetalle.imagenes[detGalIdx]?.url ||
                                      productoDetalle.imagen_url
                                  )
                                }
                                alt=""
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                  cursor: 'pointer',
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                          </div>
                          {productoDetalle.imagenes.length > 1 && (
                            <div style={M.detThumbs}>
                              {productoDetalle.imagenes.map((img, i) => (
                                <div
                                  key={img.url || i}
                                  onClick={() => setDetGalIdx(i)}
                                  style={{
                                    ...M.detThumb,
                                    borderColor: detGalIdx === i ? '#1a73e8' : 'transparent',
                                  }}
                                >
                                  {img.tipo === 'video' ? (
                                    <div
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: '#1a1a1a',
                                      }}
                                    >
                                      <span style={{ color: '#fff', fontSize: '12px' }}>
                                        &#9654;
                                      </span>
                                    </div>
                                  ) : (
                                    <img
                                      src={getImagenUrl(img.url)}
                                      alt=""
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                      }}
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      ) : v('vis.inventario.imagenes') ? (
                        <div
                          onClick={() =>
                            setVisorOpen({
                              images: [{ url: productoDetalle.imagen_url }],
                              currentIndex: 0,
                            })
                          }
                          style={{ cursor: 'pointer' }}
                        >
                          <ImagenProducto imagen_url={productoDetalle.imagen_url} size={160} />
                        </div>
                      ) : null}
                    </div>
                  )}
                  <div style={M.detHeroInfo} className="inv-det-hero-info">
                    <h2 style={M.detHeroName}>{productoDetalle.descripcion}</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <div style={M.detHeroCode}>Código: {productoDetalle.codigo}</div>
                      {productoDetalle.tipo_producto === 'compuesto' && (
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '2px 9px',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 700,
                            background: '#fef7e0',
                            color: '#b45309',
                          }}
                        >
                          <FiLayers size={12} /> Compuesto
                        </span>
                      )}
                      {tp('inventario.editar_basico') && !isPlanExterno() && (
                        <button
                          onClick={() => {
                            setProductoDetalle(null);
                            abrirEditarProducto(productoDetalle.codigo);
                          }}
                          style={{
                            padding: '4px 12px',
                            borderRadius: '6px',
                            border: '1px solid #1a73e8',
                            background: '#e8f0fe',
                            color: '#1a73e8',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 600,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                          }}
                        >
                          <FiEdit2 size={12} /> Editar
                        </button>
                      )}
                      {isPlanExterno() && (
                        <button
                          onClick={() => {
                            setProductoDetalle(null);
                            abrirEditarExterno(productoDetalle.codigo);
                          }}
                          style={{
                            padding: '4px 12px',
                            borderRadius: '6px',
                            border: '1px solid #1a73e8',
                            background: '#e8f0fe',
                            color: '#1a73e8',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 600,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                          }}
                        >
                          <FiEdit2 size={12} /> Editar info
                        </button>
                      )}
                    </div>
                    <div style={M.detInfoGrid} className="inv-det-info-grid">
                      {v('vis.inventario.precio') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Precio</span>
                          <span style={M.detInfoVal}>${fmtMonto(productoDetalle.precio)}</span>
                        </div>
                      )}
                      {v('vis.inventario.costo') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Costo</span>
                          <span style={M.detInfoVal}>
                            {productoDetalle.costo != null
                              ? `$${fmtMonto(productoDetalle.costo)}`
                              : 'N/D'}
                          </span>
                        </div>
                      )}
                      {productoDetalle.tipo_producto === 'compuesto' && productoDetalle.receta && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Receta</span>
                          <span style={{ ...M.detInfoVal, color: '#b45309', fontWeight: 600 }}>
                            {productoDetalle.receta.nombre}
                          </span>
                        </div>
                      )}
                      {v('vis.inventario.stock') && productoDetalle.tipo_producto !== 'servicio' && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Stock</span>
                          <span style={M.detInfoVal}>
                            {productoDetalle.tipo_producto === 'compuesto' ? (
                              <span style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                <span style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                                  Real <StockBadge stock={productoDetalle.stock_fisico ?? 0} />
                                </span>
                                <span style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                                  Prod. <StockBadge stock={productoDetalle.stock_produccion ?? 0} />
                                </span>
                              </span>
                            ) : (
                              <StockBadge stock={productoDetalle.stock} />
                            )}
                          </span>
                        </div>
                      )}
                      {v('vis.inventario.depto') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Subgrupo</span>
                          <span style={M.detInfoVal}>{productoDetalle.departamento || '-'}</span>
                        </div>
                      )}
                      {v('vis.inventario.grupo') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Grupo</span>
                          <span style={M.detInfoVal}>{productoDetalle.grupo || '-'}</span>
                        </div>
                      )}
                      <div style={M.detInfoCell}>
                        <span style={M.detInfoLbl}>Código subgrupo</span>
                        <span style={M.detInfoVal}>{productoDetalle.subgrupo || '-'}</span>
                      </div>
                      {v('vis.inventario.marca') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Marca</span>
                          <span style={M.detInfoVal}>{productoDetalle.marca || '-'}</span>
                        </div>
                      )}
                      {v('vis.inventario.modelo') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Modelo</span>
                          <span style={M.detInfoVal}>
                            {productoDetalle.modelos?.length
                              ? productoDetalle.modelos.join(', ')
                              : productoDetalle.modelo || '-'}
                          </span>
                        </div>
                      )}
                      <div style={M.detInfoCell}>
                        <span style={M.detInfoLbl}>Pesable</span>
                        <span style={M.detInfoVal}>{productoDetalle.pesable ? 'Sí' : 'No'}</span>
                      </div>
                      {v('vis.inventario.proveedor') && (
                        <div style={M.detInfoCell}>
                          <span style={M.detInfoLbl}>Procede</span>
                          <span style={M.detInfoVal}>{productoDetalle.procede || '-'}</span>
                        </div>
                      )}
                      <div style={M.detInfoCell}>
                        <span style={M.detInfoLbl}>Referencia</span>
                        <span style={M.detInfoVal}>{productoDetalle.referencia || '-'}</span>
                      </div>
                    </div>
                    {v('vis.inventario.descripcion') && productoDetalle.descripcion_corta && (
                      <div
                        style={{
                          fontSize: '12px',
                          color: 'var(--agx-muted)',
                          marginTop: '6px',
                          lineHeight: 1.4,
                        }}
                      >
                        {productoDetalle.descripcion_corta}
                      </div>
                    )}
                    {v('vis.inventario.clasificacion') && productoDetalle.clasificacion && (
                      <div
                        style={{
                          marginTop: '8px',
                          display: 'flex',
                          gap: '8px',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '11px',
                            padding: '3px 10px',
                            borderRadius: '10px',
                            fontWeight: 600,
                            background:
                              productoDetalle.clasificacion.volumen === 'alto'
                                ? '#e6f4ea'
                                : productoDetalle.clasificacion.volumen === 'medio'
                                  ? '#fef7e0'
                                  : '#fce8e6',
                            color:
                              productoDetalle.clasificacion.volumen === 'alto'
                                ? '#137333'
                                : productoDetalle.clasificacion.volumen === 'medio'
                                  ? '#ea8600'
                                  : '#c5221f',
                          }}
                        >
                          Vol: {productoDetalle.clasificacion.volumen}
                        </span>
                        <span style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>
                          Stock obj: {productoDetalle.clasificacion.stock_objetivo}
                        </span>
                        <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                          ({productoDetalle.clasificacion.actualizado_por})
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {productoDetalle.departamento_override && (
                  <div style={M.detSectionBox} className="inv-det-section-box">
                    <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--agx-muted)' }}>
                      Depto. reasignado:
                    </span>{' '}
                    <span style={{ fontSize: '12px' }}>
                      <strong>{productoDetalle.departamento_override.original}</strong> →{' '}
                      <strong>{productoDetalle.departamento_override.nuevo}</strong>
                    </span>
                  </div>
                )}

                {v('vis.inventario.stock_por_sede') &&
                  (productoDetalle.tipo_producto !== 'compuesto' ||
                    productoDetalle.stock_cliente === 'real') &&
                  productoDetalle.stock_por_sede &&
                  Object.keys(productoDetalle.stock_por_sede).length > 0 && (
                    <div style={M.detSectionBox} className="inv-det-section-box">
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: 600,
                          color: 'var(--agx-muted)',
                          marginBottom: '8px',
                        }}
                      >
                        Stock por sede
                      </div>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {Object.entries(productoDetalle.stock_por_sede).map(([cod, st]) => {
                          const c = sedeStockColor(st);
                          return (
                            <div
                              key={cod}
                              style={{
                                backgroundColor: c.bg,
                                color: c.fg,
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 600,
                              }}
                            >
                              {getSedeNombre(cod)}: {st}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                <div style={M.detTabs} className="inv-det-tabs">
                  {[
                    { k: 'rendimiento', l: 'Rendimiento', i: <FiTrendingUp size={14} /> },
                    { k: 'ventas', l: 'Últ. ventas', i: <FiDollarSign size={14} /> },
                    { k: 'clientes', l: 'Clientes top', i: <FiStar size={14} /> },
                    { k: 'pedidos', l: 'Pedidos pend.', i: <FiClipboard size={14} /> },
                    { k: 'precios', l: 'Historial precios', i: <FiRefreshCw size={14} /> },
                  ].map((t) => (
                    <button
                      key={t.k}
                      onClick={() => setDetSection(t.k)}
                      style={{
                        ...M.detTab,
                        color: detSection === t.k ? '#1a73e8' : '#5f6368',
                        borderBottomColor: detSection === t.k ? '#1a73e8' : 'transparent',
                        fontWeight: detSection === t.k ? 600 : 400,
                      }}
                    >
                      {t.i} <span style={{ marginLeft: '4px' }}>{t.l}</span>
                    </button>
                  ))}
                </div>

                <div style={M.detTabContent} className="inv-det-tab-content">
                  {detSection === 'rendimiento' && v('vis.inventario.estadisticas') && (
                    <div>
                      {cargandoEstadisticas ? (
                        <Spinner size={28} />
                      ) : estadisticas ? (
                        <>
                          <div style={M.detKpiGrid} className="inv-det-kpi-grid">
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                {estadisticas.total_vendido?.toLocaleString('es') || 0} u
                              </div>
                              <div style={M.detKpiLbl}>Total vendido</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                ${fmtMonto(estadisticas.ingresos)}
                              </div>
                              <div style={M.detKpiLbl}>Ingresos</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              {v('vis.inventario.margen') ? (
                                <>
                                  <div style={M.detKpiVal} className="inv-det-kpi-val">
                                    <span
                                      style={{
                                        color:
                                          (estadisticas.margen_pct || 0) >= 30
                                            ? '#137333'
                                            : (estadisticas.margen_pct || 0) >= 10
                                              ? '#ea8600'
                                              : '#c5221f',
                                      }}
                                    >
                                      {estadisticas.margen_pct || 0}%
                                    </span>
                                  </div>
                                  <div style={M.detKpiLbl}>Margen %</div>
                                </>
                              ) : (
                                <div style={M.detKpiLbl}>Margen %</div>
                              )}
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              {v('vis.inventario.margen') ? (
                                <>
                                  <div style={M.detKpiVal} className="inv-det-kpi-val">
                                    ${fmtMonto(estadisticas.margen)}
                                  </div>
                                  <div style={M.detKpiLbl}>Margen neto</div>
                                </>
                              ) : (
                                <div style={M.detKpiLbl}>Margen neto</div>
                              )}
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                {estadisticas.rotacion_diaria?.toFixed(2) || '0'} u/día
                              </div>
                              <div style={M.detKpiLbl}>Rotación diaria</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                ${fmtMonto(estadisticas.precio_promedio)}
                              </div>
                              <div style={M.detKpiLbl}>Precio promedio</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                {estadisticas.ventas_totales || 0}
                              </div>
                              <div style={M.detKpiLbl}>Nº de ventas</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div style={M.detKpiVal} className="inv-det-kpi-val">
                                {estadisticas.rotacion_dias
                                  ? `${estadisticas.rotacion_dias}d`
                                  : '-'}
                              </div>
                              <div style={M.detKpiLbl}>Período evaluado</div>
                            </div>
                            <div style={M.detKpiCard} className="inv-det-kpi-card">
                              <div
                                style={M.detKpiVal}
                                className="inv-det-kpi-val"
                                title={estadisticas.ultima_venta}
                              >
                                {estadisticas.ultima_venta
                                  ? new Date(estadisticas.ultima_venta).toLocaleDateString('es', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: '2-digit',
                                    })
                                  : '-'}
                              </div>
                              <div style={M.detKpiLbl}>Última venta</div>
                            </div>
                            {productoDetalle.clasificacion?.stock_objetivo > 0 && (
                              <div
                                style={{
                                  ...M.detKpiCard,
                                  ...(productoDetalle.stock <=
                                  productoDetalle.clasificacion.stock_objetivo
                                    ? { background: '#fce8e6', border: '1px solid #f5cac7' }
                                    : { background: '#e6f4ea' }),
                                }}
                                className="inv-det-kpi-card"
                              >
                                <div
                                  style={{
                                    ...M.detKpiVal,
                                    ...(productoDetalle.stock <=
                                    productoDetalle.clasificacion.stock_objetivo
                                      ? { color: '#c5221f' }
                                      : { color: '#137333' }),
                                  }}
                                  className="inv-det-kpi-val"
                                >
                                  {productoDetalle.stock <=
                                  productoDetalle.clasificacion.stock_objetivo
                                    ? '⚠️ Reponer'
                                    : '✓ Stock OK'}
                                </div>
                                <div style={M.detKpiLbl}>
                                  {productoDetalle.stock} / obj:{' '}
                                  {productoDetalle.clasificacion.stock_objetivo}
                                </div>
                              </div>
                            )}
                          </div>

                          {estadisticas.tendencia_mensual?.length > 1 && (
                            <div style={{ marginTop: '16px' }}>
                              <div
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  color: 'var(--agx-muted)',
                                  marginBottom: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                }}
                              >
                                <FiTrendingUp size={14} /> Tendencia mensual
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-end',
                                  gap: '4px',
                                  height: '120px',
                                  paddingBottom: '20px',
                                  borderBottom: '1px solid #e0e0e0',
                                }}
                              >
                                {(() => {
                                  const maxV = Math.max(
                                    ...estadisticas.tendencia_mensual.map((t) => t.vendido || 0),
                                    1
                                  );
                                  return estadisticas.tendencia_mensual.map((t, i) => {
                                    const h = Math.max(((t.vendido || 0) / maxV) * 96, 2);
                                    const mes = t.mes
                                      ? new Date(t.mes + '-01').toLocaleDateString('es', {
                                          month: 'short',
                                        })
                                      : '?';
                                    const isLast = i === estadisticas.tendencia_mensual.length - 1;
                                    return (
                                      <div
                                        key={t.mes}
                                        style={{
                                          flex: 1,
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          gap: '3px',
                                          minWidth: '20px',
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: '10px',
                                            color: '#202124',
                                            fontWeight: 600,
                                          }}
                                        >
                                          {t.vendido || 0}
                                        </div>
                                        <div
                                          style={{
                                            width: '100%',
                                            maxWidth: '36px',
                                            height: `${h}px`,
                                            borderRadius: '4px 4px 0 0',
                                            background: isLast
                                              ? 'linear-gradient(180deg, #1a73e8, #1557b0)'
                                              : '#90c2f7',
                                            minHeight: '2px',
                                            transition: 'height 0.3s',
                                          }}
                                        />
                                        <div
                                          style={{
                                            fontSize: '9px',
                                            color: 'var(--agx-muted)',
                                            position: 'absolute',
                                            bottom: '2px',
                                            fontWeight: isLast ? 600 : 400,
                                          }}
                                        >
                                          {mes}
                                        </div>
                                      </div>
                                    );
                                  });
                                })()}
                              </div>
                            </div>
                          )}

                          {estadisticas.por_sede?.length > 1 && (
                            <div style={{ marginTop: '14px' }}>
                              <div
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  color: 'var(--agx-muted)',
                                  marginBottom: '6px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                }}
                              >
                                <FiPackage size={14} /> Ventas por sede
                              </div>
                              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {(() => {
                                  const maxS = Math.max(
                                    ...estadisticas.por_sede.map((x) => x.vendido || 0),
                                    1
                                  );
                                  return estadisticas.por_sede.map((s) => {
                                    const barW = Math.max(((s.vendido || 0) / maxS) * 100, 4);
                                    const sedeNombre = getSedeNombre(s.sede);
                                    return (
                                    <div
                                      key={s.sede}
                                      style={{
                                        flex: '1 1 140px',
                                        minWidth: '140px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: '12px',
                                          fontWeight: 600,
                                          color: '#202124',
                                          marginBottom: '4px',
                                        }}
                                      >
                                        {sedeNombre}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: '11px',
                                          color: 'var(--agx-muted)',
                                          marginBottom: '4px',
                                        }}
                                      >
                                        {s.ventas} ventas
                                      </div>
                                      <div
                                        style={{
                                          height: '6px',
                                          borderRadius: '3px',
                                          background: '#e8e8e8',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: `${barW}%`,
                                            height: '100%',
                                            borderRadius: '3px',
                                            background: 'linear-gradient(90deg, #1a73e8, #4285f4)',
                                          }}
                                        />
                                      </div>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          marginTop: '4px',
                                          fontSize: '10px',
                                        }}
                                      >
                                        <span style={{ color: '#202124', fontWeight: 600 }}>
                                          {s.vendido || 0} u
                                        </span>
                                        <span style={{ color: '#137333' }}>
                                          ${fmtMonto(s.ingresos || 0)}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                  });
                                })()}
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            fontSize: '12px',
                            color: 'var(--agx-faint)',
                            fontStyle: 'italic',
                            padding: '4px 0',
                          }}
                        >
                          Sin datos de ventas
                        </div>
                      )}
                    </div>
                  )}

                  {detSection === 'ventas' && v('vis.inventario.ultimas_ventas') && (
                    <div>
                      {cargandoEstadisticas ? (
                        <Spinner size={28} />
                      ) : estadisticas?.ultimas_ventas?.length > 0 ? (
                        <div style={M.detTableWrap}>
                          <table
                            style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}
                          >
                            <thead>
                              <tr>
                                <th style={M.detTh}>Fecha</th>
                                <th style={M.detTh}>Cliente</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Cant</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Prec. u.</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Subtotal</th>
                                <th style={M.detTh}>Vendedor</th>
                              </tr>
                            </thead>
                            <tbody>
                              {estadisticas.ultimas_ventas.map((v) => (
                                <tr key={v.venta_id} style={{ borderBottom: '1px solid #f1f3f4' }}>
                                  <td style={M.detTd}>
                                    {new Date(v.fecha).toLocaleDateString('es', {
                                      day: '2-digit',
                                      month: '2-digit',
                                      year: '2-digit',
                                    })}
                                  </td>
                                  <td style={M.detTd}>
                                    <div style={{ fontWeight: 500 }}>{v.cliente_nombre}</div>
                                    {v.cliente_cedula && (
                                      <div style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                        CI: {v.cliente_cedula}
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ ...M.detTd, textAlign: 'right' }}>{v.cantidad}</td>
                                  <td style={{ ...M.detTd, textAlign: 'right' }}>
                                    ${fmtMonto(v.precio_unitario)}
                                  </td>
                                  <td style={{ ...M.detTd, textAlign: 'right', fontWeight: 600 }}>
                                    ${fmtMonto(v.subtotal)}
                                  </td>
                                  <td
                                    style={{
                                      ...M.detTd,
                                      fontSize: '11px',
                                      color: 'var(--agx-muted)',
                                    }}
                                  >
                                    {v.usuario_nombre}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: '12px',
                            color: 'var(--agx-faint)',
                            fontStyle: 'italic',
                            padding: '4px 0',
                          }}
                        >
                          Sin ventas registradas
                        </div>
                      )}
                    </div>
                  )}

                  {detSection === 'clientes' && v('vis.inventario.clientes_top') && (
                    <div>
                      {cargandoEstadisticas ? (
                        <Spinner size={28} />
                      ) : estadisticas?.top_clientes?.length > 0 ? (
                        <div style={M.detTableWrap}>
                          <table
                            style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}
                          >
                            <thead>
                              <tr>
                                <th style={M.detTh}>Cliente</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Compras</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Cant. total</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Total gastado</th>
                                <th style={M.detTh}>Últ. compra</th>
                              </tr>
                            </thead>
                            <tbody>
                              {estadisticas.top_clientes.map((c) => (
                                <tr key={c.cedula || c.nombre} style={{ borderBottom: '1px solid #f1f3f4' }}>
                                  <td style={M.detTd}>
                                    <div style={{ fontWeight: 500 }}>{c.nombre}</div>
                                    {c.cedula && (
                                      <div style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                        CI: {c.cedula}
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ ...M.detTd, textAlign: 'right', fontWeight: 600 }}>
                                    {c.compras}
                                  </td>
                                  <td style={{ ...M.detTd, textAlign: 'right' }}>
                                    {c.total_comprado?.toLocaleString('es')} u
                                  </td>
                                  <td
                                    style={{
                                      ...M.detTd,
                                      textAlign: 'right',
                                      fontWeight: 600,
                                      color: '#137333',
                                    }}
                                  >
                                    ${fmtMonto(c.total_gastado)}
                                  </td>
                                  <td style={M.detTd}>
                                    {c.ultima_compra
                                      ? new Date(c.ultima_compra).toLocaleDateString('es', {
                                          day: '2-digit',
                                          month: '2-digit',
                                          year: '2-digit',
                                        })
                                      : '-'}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: '12px',
                            color: 'var(--agx-faint)',
                            fontStyle: 'italic',
                            padding: '4px 0',
                          }}
                        >
                          Sin datos de clientes
                        </div>
                      )}
                    </div>
                  )}

                  {detSection === 'pedidos' && v('vis.inventario.pedidos_pendientes') && (
                    <div>
                      {cargandoEstadisticas ? (
                        <Spinner size={28} />
                      ) : estadisticas?.pedidos_pendientes?.length > 0 ? (
                        <div style={M.detTableWrap}>
                          <table
                            style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}
                          >
                            <thead>
                              <tr>
                                <th style={M.detTh}>Pedido #</th>
                                <th style={M.detTh}>Cliente</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Cant</th>
                                <th style={M.detTh}>Estado</th>
                                <th style={M.detTh}>Fecha</th>
                              </tr>
                            </thead>
                            <tbody>
                              {estadisticas.pedidos_pendientes.map((p) => (
                                <tr key={p.pedido_id} style={{ borderBottom: '1px solid #f1f3f4' }}>
                                  <td style={{ ...M.detTd, fontWeight: 600, color: '#1a73e8' }}>
                                    #{p.pedido_id}
                                  </td>
                                  <td style={M.detTd}>
                                    <div style={{ fontWeight: 500 }}>{p.cliente_nombre}</div>
                                    {p.cliente_telefono && (
                                      <div style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                        {p.cliente_telefono}
                                      </div>
                                    )}
                                    {p.cliente_direccion && (
                                      <div
                                        style={{
                                          fontSize: '9px',
                                          color: 'var(--agx-faint)',
                                          maxWidth: '140px',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                        title={p.cliente_direccion}
                                      >
                                        {p.cliente_direccion}
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ ...M.detTd, textAlign: 'right', fontWeight: 600 }}>
                                    {p.cantidad_pedida || 0} u
                                  </td>
                                  <td style={M.detTd}>
                                    <span
                                      style={{
                                        padding: '2px 8px',
                                        borderRadius: '10px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background:
                                          p.estado === 'pendiente'
                                            ? '#fef7e0'
                                            : p.estado === 'confirmado'
                                              ? '#e8f0fe'
                                              : p.estado === 'armando'
                                                ? '#fce8e6'
                                                : p.estado === 'enviado'
                                                  ? '#e6f4ea'
                                                  : '#f3e8fd',
                                        color:
                                          p.estado === 'pendiente'
                                            ? '#ea8600'
                                            : p.estado === 'confirmado'
                                              ? '#1967d2'
                                              : p.estado === 'armando'
                                                ? '#c5221f'
                                                : p.estado === 'enviado'
                                                  ? '#137333'
                                                  : '#7b1fa2',
                                      }}
                                    >
                                      {p.estado}
                                    </span>
                                  </td>
                                  <td style={M.detTd}>
                                    {p.fecha
                                      ? new Date(p.fecha).toLocaleDateString('es', {
                                          day: '2-digit',
                                          month: '2-digit',
                                          year: '2-digit',
                                        })
                                      : '-'}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: '12px',
                            color: 'var(--agx-faint)',
                            fontStyle: 'italic',
                            padding: '4px 0',
                          }}
                        >
                          Sin pedidos pendientes con este producto
                        </div>
                      )}
                    </div>
                  )}

                  {detSection === 'precios' && v('vis.inventario.historial_precios') && (
                    <div>
                      {cargandoHistorial ? (
                        <Spinner size={28} />
                      ) : historial.length > 0 ? (
                        <div style={M.detTableWrap}>
                          <table
                            style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}
                          >
                            <thead>
                              <tr>
                                <th style={M.detTh}>Fecha</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Precio ant.</th>
                                <th style={{ ...M.detTh, textAlign: 'right' }}>Precio nuevo</th>
                                <th style={M.detTh}>Usuario</th>
                              </tr>
                            </thead>
                            <tbody>
                              {historial.map((h) => {
                                const diff = (h.precio_nuevo || 0) - (h.precio_anterior || 0);
                                return (
                                  <tr key={h.id} style={{ borderBottom: '1px solid #f1f3f4' }}>
                                    <td style={M.detTd}>
                                      {h.fecha
                                        ? new Date(h.fecha).toLocaleDateString('es', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: '2-digit',
                                          })
                                        : '-'}
                                    </td>
                                    <td style={{ ...M.detTd, textAlign: 'right' }}>
                                      ${fmtMonto(h.precio_anterior || 0)}
                                    </td>
                                    <td
                                      style={{
                                        ...M.detTd,
                                        textAlign: 'right',
                                        fontWeight: 600,
                                        color:
                                          diff > 0 ? '#c5221f' : diff < 0 ? '#137333' : '#202124',
                                      }}
                                    >
                                      ${fmtMonto(h.precio_nuevo || 0)}
                                      {diff !== 0 && (
                                        <span style={{ fontSize: '10px', marginLeft: '4px' }}>
                                          {diff > 0 ? '+' : ''}
                                          {fmtMonto(diff)}
                                        </span>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        ...M.detTd,
                                        fontSize: '11px',
                                        color: 'var(--agx-muted)',
                                      }}
                                    >
                                      {h.usuario_nombre || h.usuario_cedula || '-'}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: '12px',
                            color: 'var(--agx-faint)',
                            fontStyle: 'italic',
                            padding: '4px 0',
                          }}
                        >
                          Sin cambios de precio registrados
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {cargandoDetalle && (
            <div style={M.overlay} onClick={() => setCargandoDetalle(false)}>
              <div className="inv-modal" style={M.modal} onClick={(e) => e.stopPropagation()}>
                <div style={{ padding: '60px', textAlign: 'center' }}>
                  <Spinner />
                </div>
              </div>
            </div>
          )}

          {showExportModal && (
            <div style={M.overlay} onClick={() => setShowExportModal(false)}>
              <div
                style={{ ...M.modal, maxWidth: '420px', padding: '24px' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                    Exportar inventario
                  </h3>
                  <button
                    onClick={() => setShowExportModal(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '20px',
                      cursor: 'pointer',
                      color: 'var(--agx-faint)',
                      lineHeight: 1,
                    }}
                  >
                    &times;
                  </button>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'var(--agx-muted)',
                      marginBottom: '4px',
                    }}
                  >
                    Sede
                  </label>
                  <select
                    value={exportSede}
                    onChange={(e) => setExportSede(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: '1px solid #dadce0',
                      fontSize: '13px',
                      fontFamily: 'inherit',
                      backgroundColor: '#fff',
                    }}
                  >
                    <option value="todas">Todas las sedes</option>
                    {sedes
                      .filter((s) => s.activa)
                      .map((s) => (
                        <option key={s.codigo} value={s.codigo}>
                          {s.codigo} - {s.nombre}
                        </option>
                      ))}
                  </select>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      fontSize: '13px',
                      cursor: 'pointer',
                      padding: '4px 0',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={exportSoloConStock}
                      onChange={(e) => setExportSoloConStock(e.target.checked)}
                      style={{ accentColor: '#1a73e8' }}
                    />
                    <span style={{ color: '#202124' }}>Solo productos con stock</span>
                  </label>
                </div>

                {exportMonedas.length > 0 && (
                  <div style={{ marginBottom: '16px' }}>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: '#5f6368',
                        marginBottom: '6px',
                      }}
                    >
                      Moneda del precio
                    </label>
                    <select
                      value={exportMoneda}
                      onChange={(e) => setExportMoneda(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid #dadce0',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                        backgroundColor: '#fff',
                      }}
                    >
                      {exportMonedas.map((m) => (
                        <option key={m.id} value={m.codigo}>
                          {m.nombre} ({m.simbolo})
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div style={{ marginBottom: '16px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'var(--agx-muted)',
                      marginBottom: '6px',
                    }}
                  >
                    Columnas
                  </label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {[
                      { key: 'descripcion', label: 'Nombre del producto' },
                      { key: 'codigo', label: 'Código' },
                      { key: 'referencia', label: 'Referencia' },
                      { key: 'precio', label: 'Precio' },
                      { key: 'stock', label: 'Stock' },
                      { key: 'departamento', label: 'Subgrupo' },
                      { key: 'marca', label: 'Marca' },
                      { key: 'modelo', label: 'Modelo' },
                      { key: 'pesable', label: 'Pesable' },
                      { key: 'stock_sedes', label: 'Stock por sede (solo si aplica)' },
                    ].map((col) => (
                      <label
                        key={col.key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontSize: '13px',
                          cursor: 'pointer',
                          padding: '4px 0',
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={exportCols.includes(col.key)}
                          disabled={col.key === 'descripcion'}
                          onChange={(e) => {
                            if (col.key === 'descripcion') return;
                            setExportCols((prev) =>
                              e.target.checked
                                ? [...prev, col.key]
                                : prev.filter((c) => c !== col.key)
                            );
                          }}
                          style={{ accentColor: '#1a73e8' }}
                        />
                        <span
                          style={{
                            color: col.key === 'descripcion' ? '#1a73e8' : '#202124',
                            fontWeight: col.key === 'descripcion' ? 600 : 400,
                          }}
                        >
                          {col.label}{' '}
                          {col.key === 'descripcion' && (
                            <span
                              style={{
                                fontSize: '10px',
                                color: 'var(--agx-muted)',
                                fontWeight: 400,
                              }}
                            >
                              (obligatorio)
                            </span>
                          )}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'flex-end',
                    borderTop: '1px solid #f1f3f4',
                    paddingTop: '16px',
                  }}
                >
                  <button
                    onClick={() => setShowExportModal(false)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: '1px solid #dadce0',
                      backgroundColor: '#fff',
                      color: 'var(--agx-muted)',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontFamily: 'inherit',
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={confirmExport}
                    disabled={exportando}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: exportando ? '#9aa0a6' : '#1a73e8',
                      color: '#fff',
                      cursor: exportando ? 'default' : 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    {exportando ? 'Exportando...' : 'Exportar'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {showImgModal && (
        <div style={M.overlay} onClick={() => setShowImgModal(false)}>
          <div
            style={{ ...M.modal, maxWidth: '440px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                Publicar imagenes en masa
              </h3>
              <button
                onClick={() => setShowImgModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                  lineHeight: 1,
                }}
              >
                &times;
              </button>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label
                style={{
                  display: 'block',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: 'var(--agx-muted)',
                  marginBottom: '4px',
                }}
              >
                Sede
              </label>
              <select
                value={imgSede}
                onChange={(e) => setImgSede(e.target.value)}
                style={IMG.select}
              >
                {sedes
                  .filter((s) => s.activa)
                  .map((s) => (
                    <option key={s.codigo} value={s.codigo}>
                      {s.codigo} - {s.nombre}
                    </option>
                  ))}
              </select>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label
                style={{
                  display: 'block',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: 'var(--agx-muted)',
                  marginBottom: '4px',
                }}
              >
                Archivo ZIP{' '}
                <span style={{ fontWeight: 400, color: 'var(--agx-faint)' }}>
                  (las imagenes deben llamarse como el codigo del producto)
                </span>
              </label>
              <input
                type="file"
                accept=".zip"
                onChange={(e) => setImgFile(e.target.files[0])}
                style={IMG.fileInput}
              />
              {imgFile && (
                <div style={{ fontSize: '12px', color: 'var(--agx-muted)', marginTop: '4px' }}>
                  {imgFile.name} ({(imgFile.size / 1024 / 1024).toFixed(1)} MB)
                </div>
              )}
            </div>

            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                borderTop: '1px solid #f1f3f4',
                paddingTop: '16px',
              }}
            >
              <button
                onClick={() => setShowImgModal(false)}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: '1px solid #dadce0',
                  backgroundColor: '#fff',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontFamily: 'inherit',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handlePublicarImagenes}
                disabled={subiendoImg || !imgFile || !imgSede}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: subiendoImg || !imgFile || !imgSede ? '#9aa0a6' : '#1a73e8',
                  color: '#fff',
                  cursor: subiendoImg || !imgFile || !imgSede ? 'default' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                {subiendoImg ? 'Publicando...' : 'Publicar'}
              </button>
            </div>

            {imgResult && (
              <div
                style={{
                  marginTop: '16px',
                  padding: '12px',
                  borderRadius: '8px',
                  backgroundColor: imgResult.status === 'success' ? '#e6f4ea' : '#fce8e6',
                }}
              >
                {imgResult.status === 'success' ? (
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: '#137333',
                        marginBottom: '6px',
                        fontSize: '14px',
                      }}
                    >
                      {imgResult.data.total_procesadas} imagenes publicadas
                    </div>
                    <div style={{ fontSize: '13px', color: '#202124', lineHeight: 1.8 }}>
                      <div>
                        {imgResult.data.coinciden_productos} coinciden con productos existentes
                      </div>
                      <div>{imgResult.data.sin_coincidencia} no coinciden con ningun producto</div>
                      {imgResult.data.errores > 0 && (
                        <div style={{ color: '#c5221f' }}>{imgResult.data.errores} errores</div>
                      )}
                    </div>
                    {imgResult.data.detalle_errores?.length > 0 && (
                      <div style={{ marginTop: '8px', fontSize: '11px', color: '#c5221f' }}>
                        {imgResult.data.detalle_errores.map((e, i) => (
                          <div key={`${e.archivo}-${i}`}>
                            {e.archivo}: {e.error}
                          </div>
                        ))}
                      </div>
                    )}
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      style={{
                        marginTop: '10px',
                        padding: '6px 14px',
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: '#1a73e8',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'inherit',
                      }}
                    >
                      Recargar página
                    </button>
                  </div>
                ) : (
                  <div style={{ fontWeight: 600, color: '#c5221f', fontSize: '14px' }}>
                    Error: {imgResult.message}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {showProductoModal && (
        <div style={M.overlay} onClick={cerrarProductoModal}>
          <div
            className="inv-modal"
            style={{
              ...M.modal,
              maxWidth: '700px',
              padding: 0,
              borderRadius: '16px',
              overflow: 'hidden',
              maxHeight: '95vh',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #1a73e8, #1557b0)',
                color: '#fff',
                padding: '18px 24px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexShrink: 0,
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>
                  {editandoProducto ? 'Editar producto' : 'Nuevo producto'}
                </h3>
                {editandoProducto && (
                  <div
                    style={{
                      fontSize: '11px',
                      opacity: 0.85,
                      marginTop: '2px',
                      fontFamily: 'monospace',
                    }}
                  >
                    {editandoProducto}
                  </div>
                )}
              </div>
              <button
                onClick={cerrarProductoModal}
                style={{
                  background: 'rgba(255,255,255,0.15)',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                &times;
              </button>
            </div>
            <div
              style={{
                padding: 'clamp(14px, 3.5vw, 24px)',
                overflowY: 'auto',
                flex: 1,
                WebkitOverflowScrolling: 'touch',
              }}
            >
              {errorProducto && (
                <div
                  style={{
                    marginBottom: '14px',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    backgroundColor: '#fce8e6',
                    color: '#c5221f',
                    fontSize: '13px',
                  }}
                >
                  {errorProducto}
                </div>
              )}

              <div style={{ marginBottom: '18px' }}>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    color: 'var(--agx-muted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Tipo de producto
                </span>
                  <div style={{ display: 'flex', gap: '8px', marginTop: '8px', flexWrap: 'wrap' }}>
                    <button
                      type="button"
                      onClick={() => setProductoTipo('simple')}
                      style={{
                        flex: '1 1 180px',
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: productoTipo === 'simple' ? '2px solid #1a73e8' : '1px solid #e8eaed',
                        background: productoTipo === 'simple' ? '#e8f0fe' : '#fff',
                        color: productoTipo === 'simple' ? '#1a73e8' : '#4a4d59',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: productoTipo === 'simple' ? 700 : 500,
                        fontFamily: 'inherit',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '3px',
                      }}
                    >
                      <FiPackage size={16} />
                      <span>Simple</span>
                      <span style={{ fontSize: '10.5px', fontWeight: 400, opacity: 0.8 }}>
                        Producto normal, se vende directamente
                      </span>
                    </button>
                    {isTipoEmpresa('restaurante') && (
                      <button
                        type="button"
                        onClick={() => setProductoTipo('compuesto')}
                        style={{
                          flex: '1 1 180px',
                          padding: '10px 14px',
                          borderRadius: '10px',
                          border: productoTipo === 'compuesto' ? '2px solid #1a73e8' : '1px solid #e8eaed',
                          background: productoTipo === 'compuesto' ? '#e8f0fe' : '#fff',
                          color: productoTipo === 'compuesto' ? '#1a73e8' : '#4a4d59',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: productoTipo === 'compuesto' ? 700 : 500,
                          fontFamily: 'inherit',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: '3px',
                        }}
                      >
                        <FiLayers size={16} />
                        <span>Compuesto</span>
                        <span style={{ fontSize: '10.5px', fontWeight: 400, opacity: 0.8 }}>
                          Se produce a partir de una receta
                        </span>
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() => setProductoTipo('servicio')}
                      style={{
                        flex: '1 1 180px',
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: productoTipo === 'servicio' ? '2px solid #1a73e8' : '1px solid #e8eaed',
                        background: productoTipo === 'servicio' ? '#e8f0fe' : '#fff',
                        color: productoTipo === 'servicio' ? '#1a73e8' : '#4a4d59',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: productoTipo === 'servicio' ? 700 : 500,
                        fontFamily: 'inherit',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '3px',
                      }}
                    >
                      <FiBriefcase size={16} />
                      <span>Servicio</span>
                      <span style={{ fontSize: '10.5px', fontWeight: 400, opacity: 0.8 }}>
                        No maneja inventario ni stock
                      </span>
                    </button>
                  </div>

                  {productoTipo === 'servicio' && (
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginTop: '14px',
                        padding: '10px 12px',
                        borderRadius: '10px',
                        border: '1px solid #e8eaed',
                        background: '#fafafa',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={productoPrecioManual}
                        onChange={(e) => setProductoPrecioManual(e.target.checked)}
                        style={{ accentColor: '#1a73e8', width: 16, height: 16, flexShrink: 0 }}
                      />
                      <span style={{ fontSize: '13px', color: '#4a4d59' }}>
                        <strong>Permitir precio manual al cobrar</strong>
                        <span style={{ display: 'block', fontSize: '11.5px', color: '#5f6368', marginTop: '2px' }}>
                          Al cobrar este servicio se podrá escribir el precio libremente.
                        </span>
                      </span>
                    </label>
                  )}

                  {productoTipo === 'compuesto' && (
                    <div style={{ marginTop: '12px' }}>
                      <label style={{ fontSize: '12px', fontWeight: 600, color: '#4a4d59' }}>
                        Receta vinculada
                      </label>
                      <select
                        value={productoRecetaId}
                        onChange={(e) => setProductoRecetaId(e.target.value)}
                        style={{
                          ...SY.select,
                          marginTop: '6px',
                        }}
                      >
                        <option value="">Seleccionar receta…</option>
                        {recetasDisponibles.map((r) => (
                          <option key={r.id} value={r.id}>
                            {r.nombre}
                          </option>
                        ))}
                      </select>
                      {!cargandoRecetas && recetasDisponibles.length === 0 && (
                        <div
                          style={{
                            fontSize: '12px',
                            color: '#ea8600',
                            marginTop: '6px',
                          }}
                        >
                          No hay recetas activas. Crea una receta en el módulo Producción primero.
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: '11.5px',
                          color: 'var(--agx-muted)',
                          marginTop: '6px',
                          lineHeight: 1.4,
                        }}
                      >
                        Al vender este producto se descuentan automáticamente los insumos de la receta.
                      </div>

                      <div style={{ marginTop: '14px' }}>
                        <label style={{ fontSize: '12px', fontWeight: 600, color: '#4a4d59' }}>
                          Stock mostrado al cliente
                        </label>
                        <select
                          value={productoStockCliente}
                          onChange={(e) => setProductoStockCliente(e.target.value)}
                          style={{
                            ...SY.select,
                            marginTop: '6px',
                          }}
                        >
                          <option value="produccion">
                            Capacidad de producción (según insumos de la receta)
                          </option>
                          <option value="real">Stock real (ya producido)</option>
                        </select>
                        <div
                          style={{
                            fontSize: '11.5px',
                            color: 'var(--agx-muted)',
                            marginTop: '6px',
                            lineHeight: 1.4,
                          }}
                        >
                          Define si el cliente ve cuántas unidades se pueden producir o el stock físico
                          real que ya tienes producido.
                        </div>
                      </div>
                    </div>
                  )}
                </div>

              <div style={{ marginBottom: '18px' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    {v('vis.inventario.imagenes') ? (
                      <>
                        <span
                          style={{
                            fontSize: '12px',
                            fontWeight: 700,
                            color: 'var(--agx-muted)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}
                        >
                          Imagenes (
                          {productoImagenes.filter(
                            (img) => !productoDeletePendientes.includes(img.prioridad)
                          ).length + productoFilesPendientes.length}
                          )
                          {(productoDeletePendientes.length > 0 ||
                            productoFilesPendientes.length > 0) && (
                            <span
                              style={{
                                color: '#ea8600',
                                fontWeight: 400,
                                textTransform: 'none',
                                letterSpacing: 0,
                                marginLeft: '6px',
                              }}
                            >
                              cambios sin guardar
                            </span>
                          )}
                        </span>
                        <button
                          onClick={subirImagenProducto}
                          disabled={productoSubiendoImg}
                          style={{
                            padding: '6px 14px',
                            borderRadius: '8px',
                            border: '1px solid #1a73e8',
                            background: '#e8f0fe',
                            color: '#1a73e8',
                            cursor: productoSubiendoImg ? 'default' : 'pointer',
                            fontSize: '12px',
                            fontWeight: 600,
                            fontFamily: 'inherit',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            opacity: productoSubiendoImg ? 0.5 : 1,
                          }}
                        >
                          <FiPlus size={14} /> {productoSubiendoImg ? 'Procesando...' : 'Agregar'}
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={subirImagenProducto}
                        disabled={productoSubiendoImg}
                        style={{
                          padding: '6px 14px',
                          borderRadius: '8px',
                          border: '1px solid #1a73e8',
                          background: '#e8f0fe',
                          color: '#1a73e8',
                          cursor: productoSubiendoImg ? 'default' : 'pointer',
                          fontSize: '12px',
                          fontWeight: 600,
                          fontFamily: 'inherit',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          opacity: productoSubiendoImg ? 0.5 : 1,
                        }}
                      >
                        <FiPlus size={14} /> {productoSubiendoImg ? 'Procesando...' : 'Agregar'}
                      </button>
                    )}
                  </div>
                  {(() => {
                    const imagenesDisplay = buildImageDisplay(
                      productoImagenes,
                      productoFilesPendientes,
                      productoDeletePendientes
                    );
                    return imagenesDisplay.length > 0 ? (
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                          gap: '8px',
                        }}
                      >
                        {imagenesDisplay.map((img, idx) => (
                          <div
                            key={img.prioridad || idx}
                            draggable
                            onDragStart={(e) => handleDragStartProd(e, idx)}
                            onDragOver={handleDragOverProd}
                            onDrop={(e) => handleDropProd(e, idx)}
                            onDragEnd={handleDragEndProd}
                            style={{
                              position: 'relative',
                              borderRadius: '10px',
                              overflow: 'hidden',
                              background: '#f8f9fa',
                              border:
                                idx === 0
                                  ? '2px solid #1a73e8'
                                  : productoDragIdx === idx
                                    ? '2px dashed #1a73e8'
                                    : '1px solid #e8eaed',
                              aspectRatio: '1',
                              cursor: img._esPendiente ? 'default' : 'pointer',
                              opacity: productoDragIdx === idx ? 0.5 : img._esPendiente ? 0.85 : 1,
                              transition: 'border 0.15s, opacity 0.15s',
                            }}
                            onClick={() =>
                              !img._esPendiente &&
                              setVisorOpen({
                                images: [{ url: img.url, tipo: img.tipo }],
                                currentIndex: 0,
                              })
                            }
                          >
                            {img.tipo === 'video' ? (
                              <video
                                src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                                autoPlay
                                muted
                                loop
                                playsInline
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              />
                            ) : (
                              <img
                                src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                            {!img._esPendiente && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  eliminarImagenProducto(img.prioridad);
                                }}
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  width: '22px',
                                  height: '22px',
                                  borderRadius: '50%',
                                  background: 'rgba(0,0,0,0.5)',
                                  border: 'none',
                                  color: '#fff',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                }}
                              >
                                <FiX size={12} />
                              </button>
                            )}
                            {img._esPendiente && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  eliminarFilePendienteProducto(-img.prioridad - 1);
                                }}
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  width: '22px',
                                  height: '22px',
                                  borderRadius: '50%',
                                  background: 'rgba(0,0,0,0.6)',
                                  border: 'none',
                                  color: '#fff',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                }}
                              >
                                <FiX size={12} />
                              </button>
                            )}
                            {productoDeletePendientes.includes(img.prioridad) && (
                              <div
                                style={{
                                  position: 'absolute',
                                  inset: 0,
                                  background: 'rgba(234,67,53,0.3)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <span
                                  style={{
                                    background: '#ea4335',
                                    color: '#fff',
                                    fontSize: '9px',
                                    fontWeight: 700,
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  ELIMINADO
                                </span>
                              </div>
                            )}
                            {img._esPendiente && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  left: '4px',
                                  background: '#34a853',
                                  color: '#fff',
                                  fontSize: '9px',
                                  fontWeight: 700,
                                  padding: '1px 6px',
                                  borderRadius: '4px',
                                }}
                              >
                                NUEVO
                              </div>
                            )}
                            {idx === 0 &&
                              !productoDeletePendientes.includes(img.prioridad) &&
                              !img._esPendiente && (
                                <span
                                  style={{
                                    position: 'absolute',
                                    top: '4px',
                                    left: '4px',
                                    background: '#1a73e8',
                                    color: '#fff',
                                    fontSize: '9px',
                                    fontWeight: 700,
                                    padding: '1px 6px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  PRINCIPAL
                                </span>
                              )}
                            {idx === 1 &&
                              !img._esPendiente &&
                              imagenesDisplay.length > 1 &&
                              !productoDeletePendientes.includes(img.prioridad) && (
                                <span
                                  style={{
                                    position: 'absolute',
                                    top: '4px',
                                    left: '4px',
                                    background: '#5f6368',
                                    color: '#fff',
                                    fontSize: '9px',
                                    fontWeight: 700,
                                    padding: '1px 6px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  HOVER
                                </span>
                              )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          padding: '24px',
                          textAlign: 'center',
                          color: 'var(--agx-faint)',
                          fontSize: '13px',
                          background: '#f8f9fa',
                          borderRadius: '10px',
                        }}
                      >
                        <FiImage
                          size={28}
                          style={{ marginBottom: '6px', display: 'block', margin: '0 auto 6px' }}
                        />
                        Sin imagenes. Arrastra fotos o videos del producto.
                      </div>
                    );
                  })()}
                </div>

              <div style={{ marginBottom: '14px' }}>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    color: 'var(--agx-muted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Informacion basica
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div>
                  <label style={SY.label}>
                    Codigo <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <input
                    value={productoForm.codigo || ''}
                    onChange={(e) => setProductoForm((f) => ({ ...f, codigo: e.target.value }))}
                    style={SY.input}
                    placeholder="Ej: PROD-001"
                  />
                </div>
                <div>
                  <label style={SY.label}>
                    Descripcion <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <input
                    value={productoForm.descripcion || ''}
                    onChange={(e) =>
                      setProductoForm((f) => ({ ...f, descripcion: e.target.value }))
                    }
                    style={SY.input}
                  />
                </div>
                <div>
                  <label style={SY.label}>Referencia</label>
                  <input
                    value={productoForm.referencia || ''}
                    onChange={(e) => setProductoForm((f) => ({ ...f, referencia: e.target.value }))}
                    style={SY.input}
                    placeholder="Ej: REF-001"
                  />
                </div>
                <div>
                  {v('vis.inventario.descripcion') ? (
                    <>
                      <label style={SY.label}>Descripcion corta</label>
                      <input
                        value={productoForm.descripcion_corta || ''}
                        onChange={(e) =>
                          setProductoForm((f) => ({ ...f, descripcion_corta: e.target.value }))
                        }
                        style={SY.input}
                      />
                    </>
                  ) : null}
                </div>
              </div>

              <div style={{ marginBottom: '14px', marginTop: '20px' }}>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    color: 'var(--agx-muted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Clasificación y atributos
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '10px' }}>
                  <div>
                    <label style={SY.label}>Categoría / Departamento</label>
                    <select
                      value={productoForm.departamento || ''}
                      onChange={(e) => onChangeDepartamento(e.target.value)}
                      style={SY.select}
                    >
                      <option value="">Sin categoría</option>
                      {(function () {
                        const grouped = {};
                        departamentos.forEach((d) => {
                          const g = d.grupo_nombre || d.grupo || 'Sin categoría';
                          if (!grouped[g]) grouped[g] = [];
                          grouped[g].push(d);
                        });
                        return Object.entries(grouped).map(([grupo, depts]) => (
                          <optgroup key={grupo} label={grupo}>
                            {depts.map((d) => (
                              <option key={d.codigo} value={d.codigo}>
                                {d.nombre}
                              </option>
                            ))}
                          </optgroup>
                        ));
                      })()}
                    </select>
                    {(productoForm.grupo || productoForm.subgrupo) && (
                      <div style={{ fontSize: '11px', color: 'var(--agx-muted)', marginTop: '4px' }}>
                        Grupo: {productoForm.grupo || '—'} · Subgrupo: {productoForm.subgrupo || '—'}
                      </div>
                    )}
                  </div>
                  <div>
                    {v('vis.inventario.marca') && (
                      <>
                        <label style={SY.label}>Marca</label>
                        {nuevaMarca ? (
                          <>
                            <input
                              value={productoForm.marca || ''}
                              onChange={(e) =>
                                setProductoForm((f) => ({ ...f, marca: e.target.value }))
                              }
                              style={SY.input}
                              placeholder="Nombre de la nueva marca"
                              autoFocus
                            />
                            <button
                              onClick={() => setNuevaMarca(false)}
                              style={{ ...C.btnDetalleSm, marginTop: '6px' }}
                            >
                              Usar lista
                            </button>
                          </>
                        ) : (
                          <select
                            value={productoForm.marca || ''}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === '__nueva__') {
                                setNuevaMarca(true);
                                setProductoForm((f) => ({ ...f, marca: '' }));
                              } else {
                                setProductoForm((f) => ({ ...f, marca: val }));
                              }
                            }}
                            style={SY.select}
                          >
                            <option value="">Sin marca</option>
                            {marcas.map((m) => (
                              <option key={m.marca} value={m.marca}>
                                {m.marca}
                              </option>
                            ))}
                            <option value="__nueva__">+ Nueva marca…</option>
                          </select>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {v('vis.inventario.modelo') && (
                  <div>
                    <label style={SY.label}>Modelos</label>
                    <div style={{ fontSize: '11px', color: 'var(--agx-faint)', marginBottom: '6px' }}>
                      Selecciona los modelos a los que pertenece este producto (pestaña Modelos)
                    </div>
                    {modelos.length === 0 ? (
                      <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                        No hay modelos definidos. Créalos en la pestaña "Modelos".
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {modelos.map((m) => {
                          const cat = m.categoria;
                          const sel = productoModelos.includes(cat);
                          return (
                            <button
                              key={cat}
                              onClick={() => toggleProductoModelo(cat)}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '4px 10px',
                                borderRadius: '10px',
                                fontSize: '12px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                fontFamily: 'inherit',
                                border: `1.5px solid ${sel ? '#0d8043' : 'var(--agx-border)'}`,
                                background: sel ? '#0d804318' : '#fff',
                                color: sel ? '#0d8043' : 'var(--agx-muted)',
                              }}
                            >
                              {sel && <FiCheck size={12} />} {cat}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                {editandoProducto && (
                  <div>
                    <label style={SY.label}>Etiquetas (badges)</label>
                    <div style={{ fontSize: '11px', color: 'var(--agx-faint)', marginBottom: '8px' }}>
                      Badges visuales que resaltan este producto en el catálogo del cliente
                    </div>
                    {tagsDisponibles.length === 0 ? (
                      <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                        No hay etiquetas creadas. Créalas en la pestaña "Etiquetas".
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {tagsDisponibles.map((t) => {
                          const sel = productoTags.includes(t.id);
                          return (
                            <button
                              key={t.id}
                              onClick={() => toggleProductoTag(t.id)}
                              disabled={guardandoProductoTags}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '4px 10px',
                                borderRadius: '10px',
                                fontSize: '12px',
                                fontWeight: 600,
                                cursor: guardandoProductoTags ? 'default' : 'pointer',
                                opacity: guardandoProductoTags ? 0.6 : 1,
                                border: `1.5px solid ${sel ? t.color : 'var(--agx-border)'}`,
                                background: sel ? `${t.color}18` : '#fff',
                                color: sel ? t.color : 'var(--agx-muted)',
                              }}
                            >
                              {t.icono && <span>{t.icono}</span>}
                              {t.nombre}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '14px', marginTop: '20px' }}>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    color: 'var(--agx-muted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Precios y costos
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '10px' }}>
                  {v('vis.inventario.precio') && (
                    <div>
                      <label style={SY.label}>
                        Precio de venta <span style={{ color: '#ea4335' }}>*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        value={productoForm.precio1 ?? ''}
                        onChange={(e) =>
                          setProductoForm((f) => ({ ...f, precio1: e.target.value }))
                        }
                        style={SY.input}
                      />
                    </div>
                  )}
                  {v('vis.inventario.costo') && productoTipo !== 'compuesto' && productoTipo !== 'servicio' && (
                    <div>
                      <label style={SY.label}>Costo</label>
                      <input
                        type="number"
                        step="0.01"
                        value={productoForm.costo ?? ''}
                        onChange={(e) =>
                          setProductoForm((f) => ({ ...f, costo: e.target.value }))
                        }
                        style={SY.input}
                      />
                    </div>
                  )}
                  {v('vis.inventario.impuesto') && (
                    <div>
                      <label style={SY.label}>Impuesto (%)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={productoForm.impuesto1 ?? ''}
                        onChange={(e) =>
                          setProductoForm((f) => ({ ...f, impuesto1: e.target.value }))
                        }
                        style={SY.input}
                      />
                    </div>
                  )}
                </div>
                {productoTipo === 'compuesto' && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '8px',
                      padding: '10px 12px',
                      borderRadius: '8px',
                      background: '#fef7e0',
                      border: '1px solid #f0c36d',
                      fontSize: '12px',
                      color: '#b45309',
                      lineHeight: 1.4,
                    }}
                  >
                    <FiInfo size={14} style={{ flexShrink: 0, marginTop: '1px' }} />
                    <span>El costo de un producto compuesto se calcula automáticamente a partir de su receta.</span>
                  </div>
                )}
                {v('vis.inventario.precio') && (
                  <div
                    style={{
                      border: '1px solid #f0c36d',
                      background: '#fff8e1',
                      borderRadius: '8px',
                      padding: '10px 12px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                    }}
                  >
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                        gap: '10px',
                        alignItems: 'end',
                      }}
                    >
                      <div>
                        <label style={SY.label}>Descuento</label>
                        <select
                          value={productoForm.descuento_tipo || ''}
                          onChange={(e) =>
                            setProductoForm((f) => ({
                              ...f,
                              descuento_tipo: e.target.value,
                              descuento_valor: e.target.value ? f.descuento_valor : '',
                            }))
                          }
                          style={{ ...SY.input, height: '34px' }}
                        >
                          <option value="">Sin descuento</option>
                          <option value="monto">Monto ($)</option>
                          <option value="porcentaje">Porcentaje (%)</option>
                        </select>
                      </div>
                      {productoForm.descuento_tipo && (
                        <div>
                          <label style={SY.label}>
                            {productoForm.descuento_tipo === 'monto' ? 'Monto ($)' : 'Porcentaje (%)'}
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={productoForm.descuento_valor ?? ''}
                            onChange={(e) =>
                              setProductoForm((f) => ({ ...f, descuento_valor: e.target.value }))
                            }
                            style={SY.input}
                          />
                        </div>
                      )}
                    </div>
                    {productoForm.descuento_tipo && productoForm.descuento_valor !== '' && (
                      <div style={{ fontSize: '12px', color: '#5f6368' }}>
                        Precio con descuento:{' '}
                        <strong style={{ color: '#c5221f' }}>
                          $
                          {fmtMonto(
                            (parseFloat(productoForm.precio1) || 0) *
                            (productoForm.descuento_tipo === 'porcentaje'
                              ? 1 - (parseFloat(productoForm.descuento_valor) || 0) / 100
                              : 1) -
                            (productoForm.descuento_tipo === 'monto'
                              ? parseFloat(productoForm.descuento_valor) || 0
                              : 0)
                          )}
                        </strong>
                      </div>
                    )}
                  </div>
                )}
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    cursor: 'pointer',
                    padding: '4px 0',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={productoForm.pesable || false}
                    onChange={(e) => setProductoForm((f) => ({ ...f, pesable: e.target.checked }))}
                    style={{ accentColor: '#1a73e8' }}
                  />
                  Producto pesable (se vende por Kg)
                </label>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    cursor: 'pointer',
                    padding: '4px 0',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={productoForm.es_cocina || false}
                    onChange={(e) =>
                      setProductoForm((f) => ({ ...f, es_cocina: e.target.checked }))
                    }
                    style={{ accentColor: '#e37400' }}
                  />
                  Es cocina (se envia a comanda)
                </label>
                {productoForm.es_cocina && (
                  <div style={{ marginTop: '4px' }}>
                    <label style={SY.label}>Tiempo preparacion (min)</label>
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={productoForm.tiempo_preparacion_min || 0}
                      onChange={(e) =>
                        setProductoForm((f) => ({
                          ...f,
                          tiempo_preparacion_min: parseInt(e.target.value) || 0,
                        }))
                      }
                      style={{ ...SY.input, width: '120px' }}
                    />
                  </div>
                )}
                {!editandoProducto && productoTipo !== 'servicio' && productoForm.sedes_stock?.length > 0 && (
                  <div>
                    <label style={SY.label}>Stock inicial por sede</label>
                    {productoForm.sedes_stock.map((ss, i) => (
                      <div
                        key={ss.sede}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '4px',
                        }}
                      >
                        <span style={{ fontSize: '12px', fontWeight: 500, minWidth: '60px' }}>
                          {getSedeNombre(ss.sede)}
                        </span>
                        <input
                          type="number"
                          step="1"
                          min="0"
                          value={ss.cantidad}
                          onChange={(e) => {
                            const arr = [...productoForm.sedes_stock];
                            arr[i] = { ...arr[i], cantidad: parseFloat(e.target.value) || 0 };
                            setProductoForm((f) => ({ ...f, sedes_stock: arr }));
                          }}
                          style={{ ...SY.input, width: '100px' }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              {editandoProducto && (
                <div>
                  <label style={{ ...SY.label }}>Adicionales / Extras</label>
                  <div style={{ fontSize: '12px', color: 'var(--agx-faint)', marginBottom: '8px' }}>
                    Estos extras se administran desde la pestaña "Extras" del inventario.
                  </div>
                  {productoEtiquetas.length === 0 ? (
                    <div style={{ fontSize: '12px', color: 'var(--agx-muted)', padding: '8px 0' }}>
                      Este producto no tiene extras.
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {productoEtiquetas.map((et) => (
                        <span
                          key={et.id}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '5px 10px',
                            borderRadius: '8px',
                            background: '#f1f3f4',
                            fontSize: '12px',
                            color: 'var(--agx-text)',
                          }}
                        >
                          {et.nombre}
                          <span style={{ color: 'var(--agx-muted)' }}>
                            {et.precio > 0 ? '$' + fmtMonto(et.precio) : 'Gratis'}
                          </span>
                        </span>
                      ))}
                    </div>
                  )}
                  <button
                    onClick={() => {
                      setShowProductoModal(false);
                      setTab('extras');
                    }}
                    style={{
                      marginTop: '10px',
                      padding: '8px 14px',
                      borderRadius: '8px',
                      border: '1px solid #2563eb',
                      background: '#e8f0fe',
                      color: '#2563eb',
                      fontSize: '12px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                    }}
                  >
                    Gestionar extras
                  </button>
                </div>
              )}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'space-between',
                padding: '16px 24px',
                borderTop: '1px solid #f1f3f4',
                background: '#fafafa',
                flexShrink: 0,
                flexWrap: 'wrap',
              }}
            >
              {editandoProducto ? (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button
                    onClick={() => editandoProducto && toggleProducto(editandoProducto)}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '10px',
                      border: productoNactivo === '1' ? '1px solid #ea4335' : '1px solid #34a853',
                      backgroundColor: productoNactivo === '1' ? '#fff' : '#e8f5e9',
                      color: productoNactivo === '1' ? '#ea4335' : '#34a853',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                      minWidth: '44px',
                      minHeight: '44px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    {productoNactivo === '1' ? <><FiEyeOff size={14} /> Desactivar</> : <><FiEye size={14} /> Activar</>}
                  </button>
                  <button
                    onClick={() => editandoProducto && eliminarProducto(editandoProducto)}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '10px',
                      border: '1px solid #ea4335',
                      backgroundColor: '#fff',
                      color: '#ea4335',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                      minWidth: '44px',
                      minHeight: '44px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    <FiTrash2 size={14} /> Eliminar
                  </button>
                </div>
              ) : (
                <div></div>
              )}
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={cerrarProductoModal}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '10px',
                    border: '1px solid #dadce0',
                    backgroundColor: '#fff',
                    color: 'var(--agx-muted)',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    minWidth: '44px',
                    minHeight: '44px',
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={guardarProducto}
                  disabled={guardandoProducto}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '10px',
                    border: 'none',
                    backgroundColor: guardandoProducto ? '#9aa0a6' : '#1a73e8',
                    color: '#fff',
                    cursor: guardandoProducto ? 'default' : 'pointer',
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    minWidth: '44px',
                    minHeight: '44px',
                  }}
                >
                  {guardandoProducto ? 'Guardando...' : editandoProducto ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showStockModal && (
        <div style={M.overlay} onClick={() => !procesandoStock && setShowStockModal(false)}>
          <div
            className="inv-modal"
            style={{
              ...M.modal,
              maxWidth: '700px',
              padding: '0',
              borderRadius: '14px',
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                background:
                  stockTipo === 'carga'
                    ? 'linear-gradient(135deg, #137333 0%, #34a853 100%)'
                    : 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                color: '#fff',
                padding: '16px 24px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>
                  {stockTipo === 'carga' ? 'Carga de Inventario' : 'Descarga de Inventario'}
                </h3>
                <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '2px' }}>
                  Agregar o retirar stock de multiples productos
                </div>
              </div>
              <button
                onClick={() => !procesandoStock && setShowStockModal(false)}
                style={{
                  background: 'rgba(255,255,255,0.15)',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ padding: '16px 24px' }}>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => setStockTipo('carga')}
                    style={{
                      padding: '6px 14px',
                      borderRadius: '8px',
                      border: stockTipo === 'carga' ? '2px solid #34a853' : '1px solid #dadce0',
                      backgroundColor: stockTipo === 'carga' ? '#e6f4ea' : '#fff',
                      color: stockTipo === 'carga' ? '#137333' : '#5f6368',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <FiArrowUp size={14} /> Carga
                  </button>
                  <button
                    onClick={() => setStockTipo('descarga')}
                    style={{
                      padding: '6px 14px',
                      borderRadius: '8px',
                      border: stockTipo === 'descarga' ? '2px solid #ea4335' : '1px solid #dadce0',
                      backgroundColor: stockTipo === 'descarga' ? '#fce8e6' : '#fff',
                      color: stockTipo === 'descarga' ? '#c5221f' : '#5f6368',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <FiArrowDown size={14} /> Descarga
                  </button>
                </div>
                <select
                  value={stockSede}
                  onChange={(e) => setStockSede(e.target.value)}
                  style={{ ...SY.select, flex: 1, minWidth: '150px' }}
                >
                  <option value="">Seleccionar sede...</option>
                  {sedes
                    .filter((s) => s.activa)
                    .map((s) => (
                      <option key={s.codigo} value={s.codigo}>
                        {s.codigo} - {s.nombre}
                      </option>
                    ))}
                </select>
              </div>
              {!stockResultado && (
                <>
                  <div style={{ position: 'relative', marginBottom: '12px' }}>
                    <div style={{ ...C.searchWrap, minWidth: 'auto' }}>
                      <FiSearch size={16} color="#9aa0a6" />
                      <input
                        placeholder="Buscar producto para agregar..."
                        value={stockBusqueda}
                        onChange={(e) => {
                          setStockBusqueda(e.target.value);
                          buscarProductoStock(e.target.value);
                        }}
                        style={C.searchInput}
                      />
                    </div>
                    {stockResultados.length > 0 && (
                      <div style={{ ...C.searchDropdown, zIndex: 20 }}>
                        {stockResultados.map((p) => (
                          <div
                            key={p.codigo}
                            style={C.searchItem}
                            onClick={() => agregarItemStock(p)}
                          >
                            {v('vis.inventario.imagenes') && (
                              <ImagenProducto
                                imagen_url={p.imagen_url}
                                thumb_url={p.thumb_url}
                                size={28}
                              />
                            )}
                            <span style={{ flex: 1, fontSize: '13px' }}>
                              {p.codigo} - {p.descripcion}
                            </span>
                            {v('vis.inventario.stock') && p.tipo_producto !== 'servicio' &&
                              (p.tipo_producto === 'compuesto' ? (
                                <span style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                                  Real: {p.stock_fisico ?? 0} · Prod: {p.stock_produccion ?? 0}
                                </span>
                              ) : (
                                <span style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                                  Stock: {p.stock}
                                </span>
                              ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {stockItems.length > 0 && (
                    <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '12px' }}>
                      <table style={{ ...C.table, minWidth: '500px' }}>
                        <thead>
                          <tr>
                            <th style={C.th}>Producto</th>
                            <th style={{ ...C.th, width: '80px', textAlign: 'center' }}>Stock</th>
                            <th style={{ ...C.th, width: '100px', textAlign: 'center' }}>
                              Cantidad
                            </th>
                            <th style={{ ...C.th, width: '40px' }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {stockItems.map((item, i) => (
                            <tr key={item.codigo} style={C.tr}>
                              <td style={C.td}>
                                <div style={{ fontWeight: 500, fontSize: '13px' }}>
                                  {item.nombre}
                                </div>
                                {v('vis.inventario.codigo') && (
                                  <div
                                    style={{
                                      fontSize: '11px',
                                      color: 'var(--agx-faint)',
                                      fontFamily: 'monospace',
                                    }}
                                  >
                                    {item.codigo}
                                  </div>
                                )}
                              </td>
                              <td style={{ ...C.td, textAlign: 'center' }}>
                                {v('vis.inventario.stock') &&
                                  (item.tipo_producto === 'compuesto' ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                      <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                        Real <StockBadge stock={item.stock_fisico ?? 0} />
                                      </span>
                                      <span style={{ fontSize: '10px', color: 'var(--agx-faint)' }}>
                                        Prod. <StockBadge stock={item.stock_produccion ?? 0} />
                                      </span>
                                    </div>
                                  ) : (
                                    <StockBadge stock={item.stock_actual} />
                                  ))}
                              </td>
                              <td style={{ ...C.td, textAlign: 'center' }}>
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  value={item.cantidad}
                                  onChange={(e) => {
                                    const arr = [...stockItems];
                                    arr[i] = { ...arr[i], cantidad: e.target.value };
                                    setStockItems(arr);
                                  }}
                                  style={{ ...SY.input, width: '80px', textAlign: 'center' }}
                                />
                              </td>
                              <td style={C.td}>
                                <button
                                  onClick={() => quitarItemStock(i)}
                                  style={{ ...C.btnClearSel, padding: '2px' }}
                                >
                                  <FiX size={14} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {stockItems.length === 0 && (
                    <div
                      style={{
                        textAlign: 'center',
                        padding: '30px',
                        color: 'var(--agx-faint)',
                        fontSize: '13px',
                      }}
                    >
                      Busca y agrega productos para {stockTipo === 'carga' ? 'cargar' : 'descargar'}{' '}
                      stock
                    </div>
                  )}
                  <div style={{ marginBottom: '12px' }}>
                    <label style={SY.label}>Notas (opcional)</label>
                    <input
                      value={stockNotas}
                      onChange={(e) => setStockNotas(e.target.value)}
                      style={SY.input}
                      placeholder="Motivo de la carga/descarga..."
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'flex-end',
                      borderTop: '1px solid #f1f3f4',
                      paddingTop: '14px',
                    }}
                  >
                    <button
                      onClick={() => setShowStockModal(false)}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid #dadce0',
                        backgroundColor: '#fff',
                        color: 'var(--agx-muted)',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={procesarStock}
                      disabled={procesandoStock || stockItems.length === 0}
                      style={{
                        padding: '8px 18px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor:
                          procesandoStock || stockItems.length === 0
                            ? '#9aa0a6'
                            : stockTipo === 'carga'
                              ? '#34a853'
                              : '#ea4335',
                        color: '#fff',
                        cursor: procesandoStock || stockItems.length === 0 ? 'default' : 'pointer',
                        fontSize: '13px',
                        fontWeight: 600,
                        fontFamily: 'inherit',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      {procesandoStock
                        ? 'Procesando...'
                        : stockTipo === 'carga'
                          ? 'Cargar stock'
                          : 'Descargar stock'}
                    </button>
                  </div>
                </>
              )}
              {stockResultado && (
                <div>
                  <div style={{ marginBottom: '12px' }}>
                    {stockResultado.map((r) => (
                      <div
                        key={r.codigo || r.nombre}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '8px 12px',
                          borderBottom: '1px solid #f0f0f0',
                          fontSize: '13px',
                        }}
                      >
                        <span style={{ color: r.ok ? '#34a853' : '#ea4335', fontSize: '16px' }}>
                          {r.ok ? '\u2713' : '\u2717'}
                        </span>
                        {v('vis.inventario.codigo') && (
                          <span
                            style={{
                              fontFamily: 'monospace',
                              fontSize: '11px',
                              color: 'var(--agx-muted)',
                            }}
                          >
                            {r.codigo}
                          </span>
                        )}
                        <span style={{ flex: 1 }}>{r.nombre}</span>
                        <span style={{ fontSize: '12px', color: r.ok ? '#137333' : '#c5221f' }}>
                          {r.msg}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <button
                      onClick={() => {
                        setStockResultado(null);
                        setStockItems([]);
                      }}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid #dadce0',
                        backgroundColor: '#fff',
                        color: 'var(--agx-muted)',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                      }}
                    >
                      Nueva operacion
                    </button>
                    <button
                      onClick={() => setShowStockModal(false)}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#1a73e8',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 600,
                        fontFamily: 'inherit',
                      }}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {grupoModal && (
        <div style={M.overlay} onClick={() => setGrupoModal(null)}>
          <div
            style={{ ...M.modal, maxWidth: '440px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {grupoModal === 'lista' ? 'Grupos' : grupoModal === 'crear' ? 'Nuevo grupo' : 'Editar grupo'}
              </h3>
              <button
                onClick={() => setGrupoModal(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>

            {grupoModal === 'lista' ? (
              <div>
                {cargandoGrupos ? (
                  <Spinner />
                ) : grupos.length === 0 ? (
                  <div style={{ fontSize: '13px', color: 'var(--agx-muted)', padding: '16px 0' }}>
                    No hay grupos definidos.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '50vh', overflowY: 'auto' }}>
                    {grupos.map((g) => (
                      <div
                        key={g.codigo}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '10px 12px',
                          borderRadius: '10px',
                          border: '1px solid var(--agx-border)',
                          background: '#fff',
                        }}
                      >
                        <span style={{ fontFamily: 'monospace', fontSize: '12px', color: 'var(--agx-muted)' }}>
                          {g.codigo}
                        </span>
                        <span style={{ flex: 1, fontSize: '13px', fontWeight: 500 }}>{g.descripcion}</span>
                        <span style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                          {g.total_departamentos} deptos
                        </span>
                        <button
                          onClick={() => abrirEditarGrupo(g)}
                          title="Renombrar"
                          style={C.btnIconSm}
                        >
                          <FiEdit2 size={13} />
                        </button>
                        <button
                          onClick={() => eliminarGrupo(g)}
                          title="Eliminar"
                          style={{ ...C.btnIconSm, color: '#ea4335' }}
                        >
                          <FiTrash2 size={13} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
                  <button onClick={() => setGrupoModal(null)} style={C.btnDetalle}>
                    Cerrar
                  </button>
                  <button
                    onClick={abrirNuevoGrupo}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    <FiPlus size={14} /> Nuevo grupo
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={SY.label}>Descripción</label>
                  <input
                    value={grupoForm.descripcion}
                    onChange={(e) => setGrupoForm((f) => ({ ...f, descripcion: e.target.value }))}
                    style={SY.input}
                    placeholder="Ej: MOTOR, FRENOS…"
                    autoFocus
                  />
                </div>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button onClick={() => setGrupoModal('lista')} style={C.btnDetalle}>
                    Cancelar
                  </button>
                  <button
                    onClick={guardarGrupo}
                    disabled={guardandoGrupo}
                    style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    {guardandoGrupo ? <Spinner size={14} /> : null}
                    Guardar
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showDeptoModal && (
        <div style={M.overlay} onClick={() => setShowDeptoModal(false)}>
          <div
            style={{ ...M.modal, maxWidth: '400px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {editandoDepto ? 'Editar subgrupo' : 'Nuevo subgrupo'}
              </h3>
              <button
                onClick={() => setShowDeptoModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={SY.label}>Grupo</label>
                <select
                  value={deptoForm.grupo || ''}
                  onChange={(e) => setDeptoForm((f) => ({ ...f, grupo: e.target.value }))}
                  style={SY.select}
                >
                  <option value="">Sin grupo</option>
                  {grupos.map((g) => (
                    <option key={g.codigo} value={g.codigo}>
                      {g.descripcion} ({g.codigo})
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={SY.label}>
                  Nombre <span style={{ color: '#ea4335' }}>*</span>
                </label>
                <input
                  value={deptoForm.nombre}
                  onChange={(e) => setDeptoForm((f) => ({ ...f, nombre: e.target.value }))}
                  style={SY.input}
                  placeholder="Ej: Alternador, Filtro de aire…"
                  autoFocus
                />
              </div>
              {!editandoDepto && (
                <div style={{ fontSize: '12px', color: 'var(--agx-faint)' }}>
                  El código se genera automáticamente dentro del grupo.
                </div>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                borderTop: '1px solid #f1f3f4',
                paddingTop: '16px',
                marginTop: '12px',
              }}
            >
              <button
                onClick={() => setShowDeptoModal(false)}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: '1px solid #dadce0',
                  backgroundColor: '#fff',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontFamily: 'inherit',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={guardarDepto}
                disabled={guardandoDepto}
                style={{
                  padding: '8px 18px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: guardandoDepto ? '#9aa0a6' : '#1a73e8',
                  color: '#fff',
                  cursor: guardandoDepto ? 'default' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                }}
              >
                {guardandoDepto ? 'Guardando...' : editandoDepto ? 'Actualizar' : 'Crear'}
              </button>
            </div>
          </div>
        </div>
      )}

      {masivoModal && (
        <div style={M.overlay} onClick={() => setMasivoModal(null)}>
          <div
            style={{ ...M.modal, maxWidth: '400px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {masivoModal === 'asignar' ? 'Asignar etiqueta masiva' : 'Quitar etiqueta masiva'}
              </h3>
              <button
                onClick={() => setMasivoModal(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ fontSize: '13px', color: '#5f6368', marginBottom: '14px' }}>
              {codigosSeleccionados.length} producto(s) seleccionado(s). Elige la etiqueta a{' '}
              {masivoModal === 'asignar' ? 'asignar' : 'quitar'}.
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
              {tagsDisponibles.filter((t) => t.activo).length === 0 ? (
                <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                  No hay etiquetas activas. Créalas en la pestaña "Etiquetas".
                </div>
              ) : (
                tagsDisponibles
                  .filter((t) => t.activo)
                  .map((t) => (
                    <button
                      key={t.id}
                      onClick={() => setMasivoTagId(String(t.id))}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: `1.5px solid ${String(t.id) === masivoTagId ? t.color : '#dadce0'}`,
                        background: String(t.id) === masivoTagId ? `${t.color}14` : '#fff',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#202124',
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '3px',
                          padding: '2px 8px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: 700,
                          background: t.color,
                          color: '#fff',
                        }}
                      >
                        {t.icono && <span>{t.icono}</span>}
                        {t.nombre}
                      </span>
                      <span style={{ flex: 1 }} />
                      {String(t.id) === masivoTagId && <FiCheck size={16} color={t.color} />}
                    </button>
                  ))
              )}
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                borderTop: '1px solid #f1f3f4',
                paddingTop: '16px',
              }}
            >
              <button
                onClick={() => setMasivoModal(null)}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: '1px solid #dadce0',
                  background: '#fff',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                  fontSize: '13px',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={ejecutarMasivo}
                disabled={procesandoMasivo || !masivoTagId}
                style={{
                  padding: '8px 18px',
                  borderRadius: '8px',
                  border: 'none',
                  background:
                    procesandoMasivo || !masivoTagId ? '#9aa0a6' : masivoModal === 'asignar' ? '#0d904f' : '#ea4335',
                  color: '#fff',
                  cursor: procesandoMasivo || !masivoTagId ? 'default' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                }}
              >
                {procesandoMasivo ? 'Procesando...' : 'Aplicar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {marcaModal && (
        <div style={M.overlay} onClick={() => setMarcaModal(null)}>
          <div
            style={{ ...M.modal, maxWidth: '420px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {marcaModal.accion === 'crear'
                  ? 'Nueva marca'
                  : marcaModal.accion === 'renombrar'
                    ? 'Renombrar marca'
                    : 'Fusionar marca'}
              </h3>
              <button
                onClick={() => setMarcaModal(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {marcaModal.accion === 'merge' ? (
                <div>
                  <label style={SY.label}>Fusionar hacia</label>
                  <select
                    value={marcaForm}
                    onChange={(e) => setMarcaForm(e.target.value)}
                    style={SY.select}
                  >
                    <option value="">Selecciona una marca destino…</option>
                    {marcas
                      .filter((m) => m.marca !== marcaModal.marca)
                      .map((m) => (
                        <option key={m.marca} value={m.marca}>
                          {m.marca} ({m.total_productos})
                        </option>
                      ))}
                  </select>
                </div>
              ) : (
                <div>
                  <label style={SY.label}>
                    {marcaModal.accion === 'crear' ? 'Nombre de la marca' : 'Nuevo nombre'}
                  </label>
                  <input
                    value={marcaForm}
                    onChange={(e) => setMarcaForm(e.target.value)}
                    style={SY.input}
                    placeholder={
                      marcaModal.accion === 'crear' ? 'Ej: Polar, Nestlé…' : 'Nuevo nombre de la marca'
                    }
                    autoFocus
                  />
                </div>
              )}
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                <button onClick={() => setMarcaModal(null)} style={C.btnDetalle}>
                  Cancelar
                </button>
                <button
                  onClick={guardarMarca}
                  disabled={guardandoMarca}
                  style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  {guardandoMarca ? <Spinner size={14} /> : null}
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {modeloModal && (
        <div style={M.overlay} onClick={() => setModeloModal(null)}>
          <div
            style={{ ...M.modal, maxWidth: '420px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {modeloModal.accion === 'crear' ? 'Nuevo modelo' : 'Renombrar modelo'}
              </h3>
              <button
                onClick={() => setModeloModal(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={SY.label}>Nombre del modelo</label>
                <input
                  value={modeloForm}
                  onChange={(e) => setModeloForm(e.target.value)}
                  style={SY.input}
                  placeholder="Ej: Corolla, Hilux, Civic…"
                  autoFocus
                />
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                <button onClick={() => setModeloModal(null)} style={C.btnDetalle}>
                  Cancelar
                </button>
                <button
                  onClick={guardarModelo}
                  disabled={guardandoModelo}
                  style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  {guardandoModelo ? <Spinner size={14} /> : null}
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {tagQuickCodigo && (
        <div style={M.overlay} onClick={() => setTagQuickCodigo(null)}>
          <div
            style={{ ...M.modal, maxWidth: '420px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                Etiquetas del producto
              </h3>
              <button
                onClick={() => setTagQuickCodigo(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            {tagsDisponibles.length === 0 ? (
              <div style={{ fontSize: '13px', color: 'var(--agx-muted)' }}>
                No hay etiquetas creadas. Créalas en la pestaña "Etiquetas".
              </div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {tagsDisponibles.map((t) => {
                  const sel = (productos.find((p) => p.codigo === tagQuickCodigo)?.tags || []).some(
                    (x) => x.id === t.id
                  );
                  return (
                    <button
                      key={t.id}
                      onClick={() => toggleTagQuick(t.id)}
                      disabled={guardandoTagQuick}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '6px 12px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: guardandoTagQuick ? 'default' : 'pointer',
                        opacity: guardandoTagQuick ? 0.6 : 1,
                        fontFamily: 'inherit',
                        border: `1.5px solid ${sel ? t.color : 'var(--agx-border)'}`,
                        background: sel ? `${t.color}18` : '#fff',
                        color: sel ? t.color : 'var(--agx-muted)',
                      }}
                    >
                      {sel && <FiCheck size={12} />}
                      {t.icono && <span>{t.icono}</span>}
                      {t.nombre}
                    </button>
                  );
                })}
              </div>
            )}
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setTagQuickCodigo(null)} style={C.btnDetalle}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showTagModal && (
        <div style={M.overlay} onClick={() => setShowTagModal(false)}>
          <div
            style={{ ...M.modal, maxWidth: '420px', padding: '24px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                {editandoTag ? 'Editar Etiqueta' : 'Nueva Etiqueta'}
              </h3>
              <button
                onClick={() => setShowTagModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={SY.label}>
                  Nombre <span style={{ color: '#ea4335' }}>*</span>
                </label>
                <input
                  value={tagForm.nombre}
                  onChange={(e) => setTagForm((f) => ({ ...f, nombre: e.target.value }))}
                  style={SY.input}
                  placeholder="Ej: Recién llegado"
                />
              </div>
              <div>
                <label style={SY.label}>Color</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  {[
                    '#0B1A4A', '#1a73e8', '#0d904f', '#c5221f', '#e37400',
                    '#7b1fa2', '#007b83', '#d93025', '#ea8600', '#188038',
                  ].map((c) => (
                    <button
                      key={c}
                      type="button"
                      onClick={() => setTagForm((f) => ({ ...f, color: c }))}
                      style={{
                        width: '26px',
                        height: '26px',
                        borderRadius: '50%',
                        background: c,
                        border: tagForm.color === c ? '2px solid #202124' : '1px solid rgba(0,0,0,0.15)',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                      title={c}
                    />
                  ))}
                  <input
                    type="color"
                    value={tagForm.color}
                    onChange={(e) => setTagForm((f) => ({ ...f, color: e.target.value }))}
                    style={{
                      width: '30px',
                      height: '30px',
                      border: '1px solid var(--agx-border)',
                      borderRadius: '8px',
                      padding: '1px',
                      background: '#fff',
                      cursor: 'pointer',
                    }}
                  />
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '3px',
                      padding: '3px 10px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      fontWeight: 700,
                      background: tagForm.color || '#0B1A4A',
                      color: '#fff',
                    }}
                  >
                    {tagForm.icono && <span>{tagForm.icono}</span>}
                    {tagForm.nombre || 'Vista previa'}
                  </span>
                </div>
              </div>
              <div>
                <label style={SY.label}>Icono (emoji)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                  {['✨', '🔥', '🆕', '⭐', '🏷️', '💥', '👑', '📦', '🎯', ''].map((e) => (
                    <button
                      key={e || 'none'}
                      type="button"
                      onClick={() => setTagForm((f) => ({ ...f, icono: e }))}
                      style={{
                        minWidth: '30px',
                        height: '30px',
                        borderRadius: '8px',
                        border: tagForm.icono === e ? '2px solid #1a73e8' : '1px solid #dadce0',
                        background: '#fff',
                        cursor: 'pointer',
                        fontSize: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 6px',
                      }}
                      title={e || 'Sin icono'}
                    >
                      {e || '—'}
                    </button>
                  ))}
                </div>
              </div>
              <button
                type="button"
                onClick={() => setTagForm((f) => ({ ...f, prioridad: !f.prioridad }))}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 14px',
                  borderRadius: '10px',
                  border: tagForm.prioridad ? '1.5px solid #f0b400' : '1px solid #dadce0',
                  background: tagForm.prioridad ? '#fffbe6' : '#fff',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  textAlign: 'left',
                }}
              >
                <FiStar size={16} color={tagForm.prioridad ? '#f0b400' : '#9aa0a6'} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#202124' }}>
                    Etiqueta de prioridad
                  </div>
                  <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '2px' }}>
                    Se muestra destacada junto a "Promociones" en el catálogo del cliente (máx. 2).
                  </div>
                </div>
                <div
                  style={{
                    width: '36px',
                    height: '20px',
                    borderRadius: '10px',
                    background: tagForm.prioridad ? '#f0b400' : '#dadce0',
                    position: 'relative',
                    transition: 'background 0.2s',
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '2px',
                      left: tagForm.prioridad ? '18px' : '2px',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      background: '#fff',
                      transition: 'left 0.2s',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                    }}
                  />
                </div>
              </button>
              {errorTag && (
                <div style={{ fontSize: '12px', color: '#ea4335' }}>{errorTag}</div>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                borderTop: '1px solid #f1f3f4',
                paddingTop: '16px',
                marginTop: '12px',
              }}
            >
              <button
                onClick={() => setShowTagModal(false)}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: '1px solid #dadce0',
                  backgroundColor: '#fff',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontFamily: 'inherit',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={guardarTag}
                disabled={guardandoTag}
                style={{
                  padding: '8px 18px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: guardandoTag ? '#9aa0a6' : '#1a73e8',
                  color: '#fff',
                  cursor: guardandoTag ? 'default' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                }}
              >
                {guardandoTag ? 'Guardando...' : editandoTag ? 'Actualizar' : 'Crear'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <div style={M.overlay} onClick={() => !importLoading && setShowImportModal(false)}>
          <div
            className="inv-modal"
            style={{ ...M.modal, maxWidth: '800px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #34a853, #137333)',
                padding: '20px 24px',
                borderRadius: '16px 16px 0 0',
              }}
            >
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <h3 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#fff' }}>
                  Importar desde Excel
                </h3>
                {!importLoading && (
                  <button
                    onClick={() => setShowImportModal(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '20px',
                      cursor: 'pointer',
                      color: '#fff',
                    }}
                  >
                    &times;
                  </button>
                )}
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                {[1, 2, 3, 4].map((p) => (
                  <div key={p} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <div
                      style={{
                        width: '22px',
                        height: '22px',
                        borderRadius: '50%',
                        backgroundColor: importPaso >= p ? '#fff' : 'rgba(255,255,255,0.3)',
                        color: importPaso >= p ? '#137333' : 'rgba(255,255,255,0.6)',
                        fontSize: '11px',
                        fontWeight: 700,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {p}
                    </div>
                    <span
                      style={{
                        fontSize: '11px',
                        color: importPaso >= p ? '#fff' : 'rgba(255,255,255,0.5)',
                      }}
                    >
                      {p === 1
                        ? 'Archivo'
                        : p === 2
                          ? 'Analizando'
                          : p === 3
                            ? 'Preview'
                            : 'Resultado'}
                    </span>
                    {p < 4 && (
                      <div
                        style={{
                          width: '20px',
                          height: '2px',
                          backgroundColor: importPaso > p ? '#fff' : 'rgba(255,255,255,0.2)',
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div style={{ padding: '24px' }}>
              {importError && (
                <div
                  style={{
                    marginBottom: '12px',
                    padding: '10px 14px',
                    backgroundColor: '#fce8e6',
                    borderRadius: '8px',
                    color: '#c5221f',
                    fontSize: '13px',
                  }}
                >
                  {importError}
                </div>
              )}

              {importPaso === 1 && (
                <div>
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <div style={{ fontSize: '40px', marginBottom: '8px' }}>ðŸ“Š</div>
                    <div
                      style={{
                        fontSize: '15px',
                        fontWeight: 600,
                        color: '#202124',
                        marginBottom: '4px',
                      }}
                    >
                      Sube tu archivo Excel
                    </div>
                    <div
                      style={{ fontSize: '13px', color: 'var(--agx-muted)', marginBottom: '16px' }}
                    >
                      La IA detectara automaticamente las columnas de tu archivo
                    </div>
                    <input
                      type="file"
                      accept=".xlsx,.xls"
                      onChange={(e) => {
                        setImportFile(e.target.files[0] || null);
                        setImportError('');
                      }}
                      style={{ fontSize: '13px', fontFamily: 'inherit' }}
                    />
                    {importFile && (
                      <div style={{ marginTop: '8px', fontSize: '12px', color: '#137333' }}>
                        {importFile.name} ({(importFile.size / 1024).toFixed(0)} KB)
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      borderTop: '1px solid #f1f3f4',
                      paddingTop: '14px',
                    }}
                  >
                    <button
                      onClick={analizarExcel}
                      disabled={!importFile}
                      style={{
                        padding: '8px 18px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: importFile ? '#34a853' : '#9aa0a6',
                        color: '#fff',
                        cursor: importFile ? 'pointer' : 'default',
                        fontSize: '13px',
                        fontWeight: 600,
                        fontFamily: 'inherit',
                      }}
                    >
                      Analizar con IA
                    </button>
                  </div>
                </div>
              )}

              {importPaso === 2 && (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <Spinner size={40} />
                  <div
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      color: '#202124',
                      marginTop: '16px',
                    }}
                  >
                    Analizando archivo...
                  </div>
                  <div style={{ fontSize: '13px', color: 'var(--agx-muted)', marginTop: '4px' }}>
                    La IA está detectando las columnas de tu Excel
                  </div>
                </div>
              )}

              {importPaso === 3 && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '14px',
                    }}
                  >
                    <div>
                      <span style={{ fontSize: '14px', fontWeight: 600, color: '#202124' }}>
                        {importFilas.length} productos detectados
                      </span>
                      <span
                        style={{
                          marginLeft: '8px',
                          padding: '2px 8px',
                          borderRadius: '10px',
                          fontSize: '11px',
                          fontWeight: 600,
                          backgroundColor:
                            importConfianza === 'alta'
                              ? '#e6f4ea'
                              : importConfianza === 'media'
                                ? '#fef7e0'
                                : '#fce8e6',
                          color:
                            importConfianza === 'alta'
                              ? '#137333'
                              : importConfianza === 'media'
                                ? '#ea8600'
                                : '#c5221f',
                        }}
                      >
                        Confianza {importConfianza}
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      marginBottom: '14px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      padding: '12px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '12px',
                        fontWeight: 600,
                        color: 'var(--agx-muted)',
                        marginBottom: '8px',
                      }}
                    >
                      Mapeo detectado
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {importMapeo &&
                        Object.entries(importMapeo)
                          .filter(([, v]) => v)
                          .map(([campo, col]) => (
                            <span
                              key={campo}
                              style={{
                                padding: '3px 8px',
                                borderRadius: '6px',
                                backgroundColor: '#e8f0fe',
                                color: '#1967d2',
                                fontSize: '11px',
                              }}
                            >
                              <strong>{campo}</strong> ← {col}
                            </span>
                          ))}
                    </div>
                  </div>

                  <div style={{ marginBottom: '14px' }}>
                    <label style={SY.label}>Sede para asignar stock</label>
                    <select
                      value={importSede}
                      onChange={(e) => setImportSede(e.target.value)}
                      style={SY.select}
                    >
                      <option value="">Seleccionar sede...</option>
                      {sedes
                        .filter((s) => s.activa)
                        .map((s) => (
                          <option key={s.codigo} value={s.codigo}>
                            {s.codigo} - {s.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'var(--agx-muted)',
                      marginBottom: '6px',
                    }}
                  >
                    Preview (primeros {Math.min(importPreview.length, 20)} productos)
                  </div>
                  <div
                    style={{
                      maxHeight: '300px',
                      overflow: 'auto',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                    }}
                  >
                    <table style={{ ...C.table, minWidth: '600px' }}>
                      <thead>
                        <tr>
                          {v('vis.inventario.codigo') && <th style={C.th}>Código</th>}
                          <th style={C.th}>Descripcion</th>
                          <th style={{ ...C.th, textAlign: 'right' }}>Precio</th>
                          <th style={{ ...C.th, textAlign: 'right' }}>Stock</th>
                          {v('vis.inventario.depto') && <th style={C.th}>Subgrupo</th>}
                          <th style={C.th}>Marca</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importPreview.slice(0, 20).map((f, i) => (
                          <tr key={`${f.codigo || f.descripcion}-${i}`} style={C.tr}>
                            {v('vis.inventario.codigo') && (
                              <td style={{ ...C.td, fontFamily: 'monospace', fontSize: '11px' }}>
                                {f.codigo}
                              </td>
                            )}
                            <td style={C.td}>{f.descripcion || '-'}</td>
                            <td style={{ ...C.td, textAlign: 'right' }}>
                              {f.precio != null ? `$${fmtMonto(f.precio)}` : '-'}
                            </td>
                            {v('vis.inventario.stock') && (
                              <td style={{ ...C.td, textAlign: 'right' }}>
                                {f.stock != null ? f.stock : '-'}
                              </td>
                            )}
                            {v('vis.inventario.depto') && (
                              <td style={C.td}>{f.departamento || '-'}</td>
                            )}
                            {v('vis.inventario.marca') && <td style={C.td}>{f.marca || '-'}</td>}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'flex-end',
                      borderTop: '1px solid #f1f3f4',
                      paddingTop: '14px',
                      marginTop: '14px',
                    }}
                  >
                    <button
                      onClick={() => {
                        setImportPaso(1);
                        setImportError('');
                      }}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid #dadce0',
                        backgroundColor: '#fff',
                        color: 'var(--agx-muted)',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                      }}
                    >
                      Volver
                    </button>
                    <button
                      onClick={ejecutarImport}
                      disabled={importLoading || !importSede}
                      style={{
                        padding: '8px 18px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: importLoading || !importSede ? '#9aa0a6' : '#34a853',
                        color: '#fff',
                        cursor: importLoading || !importSede ? 'default' : 'pointer',
                        fontSize: '13px',
                        fontWeight: 600,
                        fontFamily: 'inherit',
                      }}
                    >
                      {importLoading ? 'Importando...' : `Importar ${importFilas.length} productos`}
                    </button>
                  </div>
                </div>
              )}

              {importPaso === 4 && importResult && (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <div style={{ fontSize: '40px', marginBottom: '8px' }}>✅</div>
                  <div
                    style={{
                      fontSize: '17px',
                      fontWeight: 700,
                      color: '#202124',
                      marginBottom: '16px',
                    }}
                  >
                    Importación completada
                  </div>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: '12px',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{ padding: '14px', backgroundColor: '#e6f4ea', borderRadius: '10px' }}
                    >
                      <div style={{ fontSize: '22px', fontWeight: 700, color: '#137333' }}>
                        {importResult.creados}
                      </div>
                      <div style={{ fontSize: '12px', color: '#137333' }}>Creados</div>
                    </div>
                    <div
                      style={{ padding: '14px', backgroundColor: '#e8f0fe', borderRadius: '10px' }}
                    >
                      <div style={{ fontSize: '22px', fontWeight: 700, color: '#1967d2' }}>
                        {importResult.actualizados}
                      </div>
                      <div style={{ fontSize: '12px', color: '#1967d2' }}>Actualizados</div>
                    </div>
                    <div
                      style={{
                        padding: '14px',
                        backgroundColor: importResult.errores > 0 ? '#fce8e6' : '#f8f9fa',
                        borderRadius: '10px',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '22px',
                          fontWeight: 700,
                          color: importResult.errores > 0 ? '#c5221f' : '#9aa0a6',
                        }}
                      >
                        {importResult.errores}
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: importResult.errores > 0 ? '#c5221f' : '#9aa0a6',
                        }}
                      >
                        Errores
                      </div>
                    </div>
                  </div>
                  {importResult.errores_detalle?.length > 0 && (
                    <div style={{ textAlign: 'left', marginBottom: '16px' }}>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: 600,
                          color: '#c5221f',
                          marginBottom: '6px',
                        }}
                      >
                        Detalle de errores:
                      </div>
                      {importResult.errores_detalle.map((e, i) => (
                        <div
                          key={`${e.fila}-${e.codigo || ''}-${i}`}
                          style={{ fontSize: '12px', color: '#c5221f', padding: '3px 0' }}
                        >
                          Fila {e.fila}
                          {e.codigo ? ` (${e.codigo})` : ''}: {e.error}
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    onClick={() => {
                      setShowImportModal(false);
                      cargarProductos(true);
                      cargarResumen();
                      cargarDepartamentos();
                    }}
                    style={{
                      padding: '8px 24px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#1a73e8',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'inherit',
                    }}
                  >
                    Cerrar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showExternoModal && (
        <div style={M.overlay} onClick={() => setShowExternoModal(false)}>
          <div
            className="inv-modal"
            style={{
              ...M.modal,
              maxWidth: '580px',
              padding: 0,
              borderRadius: '16px',
              overflow: 'hidden',
              maxHeight: '95vh',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #1a73e8, #1557b0)',
                color: '#fff',
                padding: '18px 24px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexShrink: 0,
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>Editar producto</h3>
                <div
                  style={{
                    fontSize: '11px',
                    opacity: 0.85,
                    marginTop: '2px',
                    fontFamily: 'monospace',
                  }}
                >
                  {externoEditando}
                </div>
              </div>
              <button
                onClick={cancelarEdicionExterna}
                style={{
                  background: 'rgba(255,255,255,0.15)',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                &times;
              </button>
            </div>
            <div
              style={{
                padding: '24px',
                overflowY: 'auto',
                flex: 1,
                WebkitOverflowScrolling: 'touch',
              }}
            >
              {errorExterno && (
                <div
                  style={{
                    marginBottom: '14px',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    backgroundColor: '#fce8e6',
                    color: '#c5221f',
                    fontSize: '13px',
                  }}
                >
                  {errorExterno}
                </div>
              )}

              <div style={{ marginBottom: '18px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}
                >
                  {v('vis.inventario.imagenes') ? (
                    <>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: 700,
                          color: 'var(--agx-muted)',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Imagenes (
                        {externoImagenes.filter(
                          (img) => !externoDeletePendientes.includes(img.prioridad)
                        ).length + externoFilesPendientes.length}
                        )
                        {(externoDeletePendientes.length > 0 ||
                          externoFilesPendientes.length > 0) && (
                          <span
                            style={{
                              color: '#ea8600',
                              fontWeight: 400,
                              textTransform: 'none',
                              letterSpacing: 0,
                              marginLeft: '6px',
                            }}
                          >
                            cambios sin guardar
                          </span>
                        )}
                      </span>
                      <button
                        onClick={subirImagenExterno}
                        disabled={subiendoExternoImg}
                        style={{
                          padding: '6px 14px',
                          borderRadius: '8px',
                          border: '1px solid #1a73e8',
                          background: '#e8f0fe',
                          color: '#1a73e8',
                          cursor: subiendoExternoImg ? 'default' : 'pointer',
                          fontSize: '12px',
                          fontWeight: 600,
                          fontFamily: 'inherit',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          opacity: subiendoExternoImg ? 0.5 : 1,
                        }}
                      >
                        <FiPlus size={14} /> {subiendoExternoImg ? 'Procesando...' : 'Agregar'}
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={subirImagenExterno}
                      disabled={subiendoExternoImg}
                      style={{
                        padding: '6px 14px',
                        borderRadius: '8px',
                        border: '1px solid #1a73e8',
                        background: '#e8f0fe',
                        color: '#1a73e8',
                        cursor: subiendoExternoImg ? 'default' : 'pointer',
                        fontSize: '12px',
                        fontWeight: 600,
                        fontFamily: 'inherit',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        opacity: subiendoExternoImg ? 0.5 : 1,
                      }}
                    >
                      <FiPlus size={14} /> {subiendoExternoImg ? 'Procesando...' : 'Agregar'}
                    </button>
                  )}
                </div>
                {(() => {
                  const imagenesDisplay = buildImageDisplay(
                    externoImagenes,
                    externoFilesPendientes,
                    externoDeletePendientes
                  );
                  return imagenesDisplay.length > 0 ? (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                        gap: '8px',
                      }}
                    >
                      {imagenesDisplay.map((img, idx) => (
                        <div
                          key={img.prioridad || idx}
                          draggable
                          onDragStart={(e) => handleDragStart(e, idx)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, idx)}
                          onDragEnd={handleDragEnd}
                          style={{
                            position: 'relative',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            background: '#f8f9fa',
                            border:
                              idx === 0
                                ? '2px solid #1a73e8'
                                : dragIdx === idx
                                  ? '2px dashed #1a73e8'
                                  : '1px solid #e8eaed',
                            aspectRatio: '1',
                            cursor: img._esPendiente ? 'default' : 'pointer',
                            opacity: dragIdx === idx ? 0.5 : img._esPendiente ? 0.85 : 1,
                            transition: 'border 0.15s, opacity 0.15s',
                          }}
                          onClick={() =>
                            !img._esPendiente &&
                            setVisorOpen({
                              images: [{ url: img.url, tipo: img.tipo }],
                              currentIndex: 0,
                            })
                          }
                        >
                          {img.tipo === 'video' ? (
                            <video
                              src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                              autoPlay
                              muted
                              loop
                              playsInline
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <img
                              src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                          {!img._esPendiente && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                eliminarImagenExterno(img.prioridad);
                              }}
                              style={{
                                position: 'absolute',
                                top: '4px',
                                right: '4px',
                                width: '22px',
                                height: '22px',
                                borderRadius: '50%',
                                background: 'rgba(0,0,0,0.5)',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                              }}
                            >
                              <FiX size={12} />
                            </button>
                          )}
                          {externoDeletePendientes.includes(img.prioridad) && (
                            <div
                              style={{
                                position: 'absolute',
                                inset: 0,
                                background: 'rgba(234,67,53,0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <span
                                style={{
                                  background: '#ea4335',
                                  color: '#fff',
                                  fontSize: '9px',
                                  fontWeight: 700,
                                  padding: '2px 8px',
                                  borderRadius: '4px',
                                }}
                              >
                                ELIMINADO
                              </span>
                            </div>
                          )}
                          {img._esPendiente && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '4px',
                                left: '4px',
                                background: '#34a853',
                                color: '#fff',
                                fontSize: '9px',
                                fontWeight: 700,
                                padding: '1px 6px',
                                borderRadius: '4px',
                              }}
                            >
                              NUEVO
                            </div>
                          )}
                          {idx === 0 &&
                            !externoDeletePendientes.includes(img.prioridad) &&
                            !img._esPendiente && (
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  left: '4px',
                                  background: '#1a73e8',
                                  color: '#fff',
                                  fontSize: '9px',
                                  fontWeight: 700,
                                  padding: '1px 6px',
                                  borderRadius: '4px',
                                }}
                              >
                                PRINCIPAL
                              </span>
                            )}
                          {idx === 1 &&
                            !img._esPendiente &&
                            imagenesDisplay.length > 1 &&
                            !externoDeletePendientes.includes(img.prioridad) && (
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  left: '4px',
                                  background: '#5f6368',
                                  color: '#fff',
                                  fontSize: '9px',
                                  fontWeight: 700,
                                  padding: '1px 6px',
                                  borderRadius: '4px',
                                }}
                              >
                                HOVER
                              </span>
                            )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        padding: '24px',
                        textAlign: 'center',
                        color: 'var(--agx-faint)',
                        fontSize: '13px',
                        background: '#f8f9fa',
                        borderRadius: '10px',
                      }}
                    >
                      <FiImage
                        size={28}
                        style={{ marginBottom: '6px', display: 'block', margin: '0 auto 6px' }}
                      />
                      Sin imagenes. Agrega fotos o videos del producto.
                    </div>
                  );
                })()}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={{ ...SY.label, marginBottom: '4px' }}>Nombre del producto</label>
                  <input
                    value={externoForm.descripcion}
                    onChange={(e) => setExternoForm((f) => ({ ...f, descripcion: e.target.value }))}
                    style={SY.input}
                    placeholder="Nombre visible en catalogo"
                  />
                </div>
                <div>
                  <label style={{ ...SY.label, marginBottom: '4px' }}>Descripcion corta</label>
                  <input
                    value={externoForm.descripcion_corta}
                    onChange={(e) =>
                      setExternoForm((f) => ({ ...f, descripcion_corta: e.target.value }))
                    }
                    style={SY.input}
                    placeholder="Breve descripcion publica"
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    {v('vis.inventario.marca') && (
                      <>
                        <label style={{ ...SY.label, marginBottom: '4px' }}>Marca</label>
                        <input
                          value={externoForm.marca}
                          onChange={(e) => setExternoForm((f) => ({ ...f, marca: e.target.value }))}
                          style={SY.input}
                          placeholder="Ej: Samsung"
                        />
                      </>
                    )}
                  </div>
                  <div>
                    {v('vis.inventario.modelo') && (
                      <>
                        <label style={{ ...SY.label, marginBottom: '4px' }}>Modelo</label>
                        <input
                          value={externoForm.modelo}
                          onChange={(e) =>
                            setExternoForm((f) => ({ ...f, modelo: e.target.value }))
                          }
                          style={SY.input}
                          placeholder="Ej: Galaxy S24"
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                padding: '16px 24px',
                borderTop: '1px solid #f1f3f4',
                background: '#fafafa',
                flexShrink: 0,
              }}
            >
              <button
                onClick={cancelarEdicionExterna}
                style={{
                  padding: '10px 20px',
                  borderRadius: '10px',
                  border: '1px solid #dadce0',
                  backgroundColor: '#fff',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  minWidth: '44px',
                  minHeight: '44px',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={() => setShowPreview(true)}
                style={{
                  padding: '10px 20px',
                  borderRadius: '10px',
                  border: '1px solid #1a73e8',
                  backgroundColor: '#fff',
                  color: '#1a73e8',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  minWidth: '44px',
                  minHeight: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <FiEye size={14} /> Vista previa
              </button>
              <button
                onClick={guardarEdicionExterna}
                disabled={guardandoExterno}
                style={{
                  padding: '10px 20px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: guardandoExterno ? '#9aa0a6' : '#1a73e8',
                  color: '#fff',
                  cursor: guardandoExterno ? 'default' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  minWidth: '44px',
                  minHeight: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                {guardandoExterno
                  ? progresoGuardado.total > 1
                    ? `Guardando ${progresoGuardado.actual}/${progresoGuardado.total}...`
                    : 'Guardando...'
                  : 'Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPreview &&
        (() => {
          const prod = productos.find((p) => p.codigo === externoEditando);
          const precio = prod?.precio || 0;
          const imagenesDisplay = buildImageDisplay(
            externoImagenes || [],
            externoFilesPendientes,
            externoDeletePendientes
          );
          const imgMain = imagenesDisplay[previewGalIdx];
          const nombre = externoForm.descripcion || prod?.descripcion || '';
          const marca = externoForm.marca || prod?.marca || '';
          const modelo = externoForm.modelo || prod?.modelo || '';
          const descCorta = externoForm.descripcion_corta || '';
          const stock = prod?.stock || 0;
          const cardImg =
            previewHovered && imagenesDisplay.length > 1 ? imagenesDisplay[1] : imagenesDisplay[0];
          return (
            <div
              style={{ ...M.overlay, background: 'rgba(0,0,0,0.7)' }}
              onClick={() => {
                setShowPreview(false);
                setPreviewGalIdx(0);
              }}
            >
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 2001,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '16px',
                  overflow: 'auto',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    background: '#F5F7FA',
                    borderRadius: '20px',
                    maxWidth: '420px',
                    width: '100%',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    position: 'relative',
                  }}
                >
                  <button
                    onClick={() => {
                      setShowPreview(false);
                      setPreviewGalIdx(0);
                    }}
                    style={{
                      position: 'absolute',
                      top: '12px',
                      right: '12px',
                      zIndex: 2,
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: 'rgba(0,0,0,0.3)',
                      border: 'none',
                      color: '#fff',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                    }}
                  >
                    &times;
                  </button>

                  <div
                    style={{
                      background: '#fff',
                      borderRadius: '20px 20px 0 0',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        position: 'relative',
                        width: '100%',
                        height: '300px',
                        background: '#f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {imgMain ? (
                        imgMain.tipo === 'video' ? (
                          <video
                            key={imgMain.url}
                            src={
                              imgMain._esPendiente
                                ? imgMain.url
                                : getImagenUrl(imgMain.url)
                            }
                            controls
                            playsInline
                            style={{
                              width: '100%',
                              minHeight: '200px',
                              background: '#000',
                              borderRadius: '12px',
                            }}
                          />
                        ) : (
                          <img
                            src={
                              imgMain._esPendiente
                                ? imgMain.url
                                : getImagenUrl(imgMain.url)
                            }
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        )
                      ) : (
                        <FiPackage size={64} color="#ccc" />
                      )}
                    </div>
                    {imagenesDisplay.length > 1 && (
                      <div
                        style={{
                          display: 'flex',
                          gap: '6px',
                          padding: '8px 12px',
                          overflowX: 'auto',
                          background: '#fafafa',
                        }}
                      >
                        {imagenesDisplay.map((img, i) => (
                          <div
                            key={img.prioridad ?? img.url ?? i}
                            onClick={() => setPreviewGalIdx(i)}
                            style={{
                              width: '48px',
                              height: '48px',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              flexShrink: 0,
                              border:
                                previewGalIdx === i ? '2px solid #1a73e8' : '2px solid transparent',
                              background: '#f0f0f0',
                              cursor: 'pointer',
                            }}
                          >
                            {img.tipo === 'video' ? (
                              <div
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  background: '#1a1a1a',
                                }}
                              >
                                <span style={{ color: '#fff', fontSize: '14px' }}>&#9654;</span>
                              </div>
                            ) : (
                              <img
                                src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      padding: '16px 18px',
                      background: '#fff',
                      borderRadius: '0 0 20px 20px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '17px',
                        fontWeight: 700,
                        color: '#202124',
                        lineHeight: 1.3,
                        marginBottom: '4px',
                      }}
                    >
                      {nombre || 'Sin nombre'}
                    </div>
                    {descCorta && (
                      <div
                        style={{
                          fontSize: '13px',
                          color: 'var(--agx-muted)',
                          marginBottom: '8px',
                          lineHeight: 1.4,
                        }}
                      >
                        {descCorta}
                      </div>
                    )}
                    <div
                      style={{
                        fontSize: '22px',
                        fontWeight: 700,
                        color: '#1a73e8',
                        marginBottom: '10px',
                      }}
                    >
                      ${fmtMonto(precio)}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '6px',
                        flexWrap: 'wrap',
                        marginBottom: '12px',
                      }}
                    >
                      {v('vis.inventario.marca') && marca && (
                        <span
                          style={{
                            fontSize: '11px',
                            padding: '4px 10px',
                            borderRadius: '20px',
                            background: '#e8f0fe',
                            color: '#1a73e8',
                            fontWeight: 600,
                          }}
                        >
                          {marca}
                        </span>
                      )}
                      {v('vis.inventario.modelo') && modelo && (
                        <span
                          style={{
                            fontSize: '11px',
                            padding: '4px 10px',
                            borderRadius: '20px',
                            background: '#f1f3f4',
                            color: 'var(--agx-muted)',
                            fontWeight: 600,
                          }}
                        >
                          {modelo}
                        </span>
                      )}
                      <span
                        style={{
                          fontSize: '11px',
                          padding: '4px 10px',
                          borderRadius: '20px',
                          background: stock > 0 ? '#e6f4ea' : '#fce8e6',
                          color: stock > 0 ? '#137333' : '#c5221f',
                          fontWeight: 600,
                        }}
                      >
                        {stock > 0 ? `${stock} en stock` : 'Agotado'}
                      </span>
                    </div>

                    <div style={{ background: '#f8f9fa', borderRadius: '12px', padding: '12px' }}>
                      <div
                        style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: 'var(--agx-faint)',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          marginBottom: '6px',
                        }}
                      >
                        Vista en catálogo
                      </div>
                      <div
                        style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}
                        onMouseEnter={() => setPreviewHovered(true)}
                        onMouseLeave={() => setPreviewHovered(false)}
                      >
                        <div
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            background: '#e8eaed',
                            flexShrink: 0,
                          }}
                        >
                          {cardImg ? (
                            <img
                              src={
                                cardImg._esPendiente
                                  ? cardImg.url
                                  : getImagenUrl(cardImg.url)
                              }
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <FiPackage size={28} color="#ccc" />
                            </div>
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: '12px',
                              fontWeight: 600,
                              color: '#202124',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {nombre || 'Sin nombre'}
                          </div>
                          <div
                            style={{
                              fontSize: '10px',
                              color: 'var(--agx-faint)',
                              marginTop: '2px',
                            }}
                          >
                            {[marca, modelo].filter(Boolean).join(' | ') || 'Sin marca'}
                          </div>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#1a73e8',
                              marginTop: '3px',
                            }}
                          >
                            ${fmtMonto(precio)}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              marginTop: '3px',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '10px',
                                padding: '1px 6px',
                                borderRadius: '10px',
                                background:
                                  stock > 20 ? '#e6f4ea' : stock > 0 ? '#fef7e0' : '#fce8e6',
                                color: stock > 20 ? '#137333' : stock > 0 ? '#ea8600' : '#c5221f',
                                fontWeight: 600,
                              }}
                            >
                              {stock > 20
                                ? 'Disponible'
                                : stock > 0
                                  ? `Quedan ${stock}`
                                  : 'Agotado'}
                            </span>
                            {imagenesDisplay.length > 1 && (
                              <span
                                style={{
                                  fontSize: '9px',
                                  color: previewHovered ? '#1a73e8' : '#9aa0a6',
                                  fontWeight: 500,
                                }}
                              >
                                {previewHovered ? 'hover activo' : 'hover: 2da imagen'}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

      {visorOpen && (
        <VisorImagen
          images={visorOpen.images}
          currentIndex={visorOpen.currentIndex}
          onClose={() => setVisorOpen(null)}
        />
      )}

      {modeloActivo && (
        <div style={M.overlay} onClick={cerrarModeloModal}>
          <div
            style={{
              ...M.modalWide,
              maxWidth: '900px',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '86vh',
              height: '86vh',
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '18px 24px',
                borderBottom: '1px solid #e8eaed',
                flexShrink: 0,
              }}
            >
              <div>
                <div style={{ fontSize: '17px', fontWeight: 700, color: '#202124' }}>
                  {modeloActivo}
                </div>
                <div style={{ fontSize: '12px', color: '#5f6368', marginTop: '2px' }}>
                  Agrega o quita productos de este modelo
                </div>
              </div>
              <button
                onClick={cerrarModeloModal}
                style={{
                  ...M.closeBtn,
                  position: 'static',
                  background: '#f1f3f4',
                  borderRadius: '50%',
                  width: '34px',
                  height: '34px',
                }}
              >
                <FiX size={18} />
              </button>
            </div>

            {/* Body: dos paneles */}
            <div
              style={{
                display: 'flex',
                flex: 1,
                minHeight: 0,
                flexDirection: 'row',
                overflow: 'hidden',
              }}
            >
              {/* Panel izquierdo: agregar */}
              <div
                style={{
                  flex: 1,
                  minWidth: '320px',
                  padding: '16px 20px',
                  borderRight: '1px solid #e8eaed',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  overflow: 'hidden',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: 700, color: '#202124', marginBottom: '10px' }}>
                  Agregar productos
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '9px 12px',
                    borderRadius: '9px',
                    border: '1px solid #dadce0',
                    background: '#fff',
                    marginBottom: '10px',
                  }}
                >
                  <FiSearch size={15} color="#9aa0a6" />
                  <input
                    placeholder="Buscar por nombre o código..."
                    value={busquedaModeloModal}
                    onChange={(e) => onBuscarProductoModal(e.target.value)}
                    autoFocus
                    style={{
                      border: 'none',
                      outline: 'none',
                      flex: 1,
                      fontSize: '13px',
                      fontFamily: 'inherit',
                      background: 'transparent',
                    }}
                  />
                  {busquedaModeloModal && (
                    <button
                      onClick={() => onBuscarProductoModal('')}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9aa0a6' }}
                    >
                      <FiX size={14} />
                    </button>
                  )}
                </div>
                <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                  {buscandoProducto ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: 'var(--agx-muted)' }}>
                      Buscando...
                    </div>
                  ) : resultadosBusquedaModelo.length === 0 ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: 'var(--agx-muted)' }}>
                      {busquedaModeloModal.trim().length >= 2
                        ? 'Sin resultados'
                        : 'Escribe al menos 2 caracteres para buscar'}
                    </div>
                  ) : (
                    resultadosBusquedaModelo.map((p) => {
                      const enModelo = (productosModelo[modeloActivo] || []).some(
                        (x) => x.codigo === p.codigo
                      );
                      return (
                        <div
                          key={p.codigo}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '9px 10px',
                            borderRadius: '8px',
                            borderBottom: '1px solid #f1f3f4',
                            background: enModelo ? '#f8f9fa' : '#fff',
                          }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: '13px',
                                fontWeight: 500,
                                color: enModelo ? '#9aa0a6' : '#202124',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {p.descripcion}
                            </div>
                            <div style={{ fontSize: '11px', color: 'var(--agx-faint)', fontFamily: 'monospace' }}>
                              {p.codigo}
                              {p.marca ? ` · ${p.marca}` : ''}
                            </div>
                          </div>
                          {enModelo ? (
                            <span style={{ fontSize: '11px', color: '#0d8043', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                              <FiCheckCircle size={14} /> En el modelo
                            </span>
                          ) : (
                            <button
                              disabled={agregandoModelo[p.codigo]}
                              onClick={() => agregarDesdeModal(p)}
                              style={{
                                ...C.btnAdd,
                                fontSize: '12px',
                                padding: '5px 12px',
                                flexShrink: 0,
                              }}
                            >
                              {agregandoModelo[p.codigo] ? '...' : '+ Agregar'}
                            </button>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* Panel derecho: productos del modelo */}
              <div
                style={{
                  flex: 1,
                  minWidth: '320px',
                  padding: '16px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '10px',
                  }}
                >
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#202124' }}>
                    Productos del modelo
                  </div>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 600,
                      padding: '1px 8px',
                      borderRadius: '10px',
                      background: '#e8f0fe',
                      color: '#1967d2',
                    }}
                  >
                    {(productosModelo[modeloActivo] || []).length}
                  </span>
                </div>
                <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                  {cargandoModelo[modeloActivo] ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: 'var(--agx-muted)' }}>
                      Cargando productos...
                    </div>
                  ) : (productosModelo[modeloActivo] || []).length === 0 ? (
                    <div
                      style={{
                        padding: '20px',
                        textAlign: 'center',
                        color: 'var(--agx-muted)',
                        fontSize: '12px',
                        border: '1px dashed #dadce0',
                        borderRadius: '10px',
                      }}
                    >
                      Sin productos. Agrega desde el panel izquierdo.
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {(productosModelo[modeloActivo] || []).map((p) => (
                        <div
                          key={p.codigo}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '10px 12px',
                            borderRadius: '10px',
                            border: '1px solid #e8eaed',
                            background: '#fff',
                          }}
                        >
                          <div
                            style={{
                              width: '34px',
                              height: '34px',
                              borderRadius: '8px',
                              background: '#f1f3f4',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <FiPackage size={16} color="#5f6368" />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: '13px',
                                fontWeight: 500,
                                color: '#202124',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {p.descripcion}
                            </div>
                            <div style={{ fontSize: '11px', color: 'var(--agx-faint)', fontFamily: 'monospace' }}>
                              {p.codigo}
                              {p.precio ? ` · $${fmtMonto(p.precio)}` : ''}
                            </div>
                          </div>
                          <button
                            disabled={agregandoModelo[p.codigo]}
                            onClick={() => quitarDesdeModal(p.codigo)}
                            title="Quitar del modelo"
                            style={{
                              ...C.btnIconSm,
                              color: '#ea4335',
                            }}
                          >
                            <FiTrash2 size={14} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDescuentoModal && (
        <div style={M.overlay} onClick={cerrarDescuentoModal}>
          <div
            className="inv-modal"
            style={{
              ...M.modalWide,
              maxWidth: '760px',
              padding: 0,
              borderRadius: '16px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '92vh',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '18px 24px',
                borderBottom: '1px solid var(--agx-border)',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#202124' }}>
                {descuentoProducto ? 'Aplicar descuento' : 'Seleccionar producto'}
              </h3>
              <button
                onClick={cerrarDescuentoModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '22px',
                  cursor: 'pointer',
                  color: 'var(--agx-faint)',
                }}
              >
                &times;
              </button>
            </div>

            <div style={{ padding: '20px 24px', overflowY: 'auto' }}>
              {!descuentoProducto ? (
                <>
                  <div className="inv-search-wrap" style={{ ...C.searchWrap, width: '100%', marginBottom: '16px' }}>
                    <FiSearch size={16} color="#9aa0a6" />
                    <input
                      value={descuentoBusqueda}
                      onChange={(e) => setDescuentoBusqueda(e.target.value)}
                      placeholder="Buscar producto por nombre, código o referencia…"
                      style={C.searchInput}
                      autoFocus
                    />
                    {descuentoBusqueda && (
                      <button onClick={() => setDescuentoBusqueda('')} style={C.clearBtn}>
                        <FiX size={14} />
                      </button>
                    )}
                  </div>

                  {cargandoCatalogo ? (
                    <Spinner />
                  ) : descuentoCatalogo.length === 0 ? (
                    <EmptyState
                      icon={FiPackage}
                      title={descuentoBusqueda ? 'Sin resultados' : 'No hay productos'}
                      description={
                        descuentoBusqueda
                          ? `No se encontraron productos para "${descuentoBusqueda}".`
                          : 'No hay productos en el catálogo para aplicar descuento.'
                      }
                    />
                  ) : (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                        gap: '12px',
                        maxHeight: '56vh',
                        overflowY: 'auto',
                        paddingRight: '4px',
                      }}
                    >
                      {descuentoCatalogo.map((p) => (
                        <div
                          key={p.codigo}
                          onClick={() => seleccionarDescuentoProducto(p)}
                          style={{
                            borderRadius: '12px',
                            border: '1px solid #e8eaed',
                            background: '#fff',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'box-shadow 0.15s, transform 0.15s',
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.transform = 'none';
                          }}
                        >
                          <div
                            style={{
                              height: '110px',
                              background: '#f8f9fa',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                            }}
                          >
                            {getImagenUrl(p.thumb_url || p.imagen_url) ? (
                              <img
                                src={getImagenUrl(p.thumb_url || p.imagen_url)}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => (e.currentTarget.style.display = 'none')}
                              />
                            ) : (
                              <FiPackage size={32} color="#dadce0" />
                            )}
                          </div>
                          <div style={{ padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#202124',
                                lineHeight: '1.3',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                              }}
                            >
                              {p.descripcion}
                            </div>
                            <div style={{ fontSize: '11px', color: 'var(--agx-faint)', fontFamily: 'monospace' }}>
                              {p.codigo}
                            </div>
                            <div style={{ fontSize: '14px', fontWeight: 700, color: '#1a73e8' }}>
                              ${p.precio != null ? fmtMonto(p.precio) : '0.00'}
                            </div>
                            {p.en_promocion && (
                              <span
                                style={{
                                  background: '#c5221f',
                                  color: '#fff',
                                  fontSize: '10px',
                                  fontWeight: 700,
                                  padding: '1px 6px',
                                  borderRadius: '8px',
                                  alignSelf: 'flex-start',
                                }}
                              >
                                -{p.porcentaje_descuento}%
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div style={C.selectedProduct}>
                    <ImagenProducto
                      imagen_url={descuentoProducto.imagen_url}
                      thumb_url={descuentoProducto.thumb_url}
                      size={44}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '14px', fontWeight: 600 }}>
                        {descuentoProducto.descripcion}
                      </div>
                      <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                        {descuentoProducto.codigo} · Precio actual: $
                        {descuentoProducto.precio != null ? fmtMonto(descuentoProducto.precio) : '0.00'}
                      </div>
                    </div>
                    <button
                      onClick={() => setDescuentoProducto(null)}
                      style={{ ...C.btnDetalleSm, display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <FiArrowUp size={13} style={{ transform: 'rotate(-90deg)' }} /> Cambiar
                    </button>
                  </div>

                  <div>
                    <label style={SY.label}>Tipo de descuento</label>
                    <select
                      value={descuentoTipo}
                      onChange={(e) => setDescuentoTipo(e.target.value)}
                      style={SY.select}
                    >
                      <option value="porcentaje">Porcentaje (%)</option>
                      <option value="monto">Monto ($)</option>
                    </select>
                  </div>
                  <div>
                    <label style={SY.label}>
                      {descuentoTipo === 'monto' ? 'Monto ($)' : 'Porcentaje (%)'}
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={descuentoValor}
                      onChange={(e) => setDescuentoValor(e.target.value)}
                      style={SY.input}
                      placeholder={descuentoTipo === 'monto' ? 'Ej: 2.50' : 'Ej: 10'}
                    />
                  </div>
                  {descuentoValor !== '' && parseFloat(descuentoValor) > 0 && (
                    <div style={{ fontSize: '12px', color: '#5f6368' }}>
                      Precio final:{' '}
                      <strong style={{ color: '#c5221f' }}>
                        $
                        {(() => {
                          const base = parseFloat(descuentoProducto.precio_original ?? descuentoProducto.precio) || 0;
                          const v = parseFloat(descuentoValor) || 0;
                          const final =
                            descuentoTipo === 'porcentaje' ? base * (1 - v / 100) : base - v;
                          return fmtMonto(Math.max(0, final));
                        })()}
                      </strong>
                    </div>
                  )}

                  {errorDescuento && (
                    <div style={{ fontSize: '12px', color: '#ea4335' }}>{errorDescuento}</div>
                  )}

                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '8px' }}>
                    <button onClick={cerrarDescuentoModal} style={C.btnDetalle}>
                      Cancelar
                    </button>
                    <button
                      onClick={guardarDescuento}
                      disabled={guardandoDescuento}
                      style={{ ...C.btnAdd, display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      {guardandoDescuento ? <Spinner size={14} /> : null}
                      Aplicar descuento
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {comboModal !== null && (
        <ComboEditorModal
          combo={comboModal.combo}
          onClose={cerrarComboModal}
          onGuardar={guardarCombo}
        />
      )}
      {comboDetalle !== null && (
        <ComboDetalleModal
          combo={comboDetalle}
          onClose={cerrarComboDetalle}
          onEditar={() => { setComboDetalle(null); abrirComboEditor(comboDetalle); }}
        />
      )}
      {ticketArticulo && (
        <TicketArticulo
          producto={ticketArticulo.producto}
          modo={ticketArticulo.modo}
          onClose={() => setTicketArticulo(null)}
        />
      )}
      {showListaPrecios && (
        <ListaPreciosModal
          sede={sede}
          empresa={usuario?.empresa_nombre || ''}
          onClose={() => setShowListaPrecios(false)}
        />
      )}
      {showConteo && (
        <ConteoInventarioModal
          sede={sede}
          sedeLabel={sede !== 'todas' ? getSedeNombre(sede) : ''}
          empresa={usuario?.empresa_nombre || ''}
          onClose={() => setShowConteo(false)}
        />
      )}
    </div>
  );
}

function ComboEditorModal({ combo, onClose, onGuardar }) {
  const [form, setForm] = useState({
    nombre: combo?.nombre || '',
    descripcion: combo?.descripcion || '',
    precio: combo ? String(combo.precio ?? '') : '',
    orden: combo ? String(combo.orden ?? 0) : '0',
    items: (combo?.items || []).map((it) => ({
      codigo_producto: it.codigo_producto,
      nombre: it.nombre || it.codigo_producto,
      precio_unitario: it.precio_unitario || 0,
      cantidad: it.cantidad || 1,
      etiquetas: it.etiquetas || [],
      etiquetas_ids: (it.etiquetas || []).map((e) => e.id),
    })),
  });
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [imagenes, setImagenes] = useState(() => (combo?.imagenes || []).map((img) => ({ ...img })));
  const [ordenOriginal] = useState(() => (combo?.imagenes || []).map((img) => img.prioridad));
  const [filesPendientes, setFilesPendientes] = useState([]);
  const [deletePendientes, setDeletePendientes] = useState([]);
  // Imagenes automaticas derivadas de los componentes: editables (quitar/reordenar).
  const [autoImagenes, setAutoImagenes] = useState([]);
  const [autoDragIdx, setAutoDragIdx] = useState(null);
  const timer = useRef(null);

  const precioNum = parseFloat(form.precio) || 0;

  const totalSinDescuento = form.items.reduce((s, it) => {
    const etiq = (it.etiquetas || [])
      .filter((e) => it.etiquetas_ids.includes(e.id))
      .reduce((t, e) => t + (Number(e.precio) || 0), 0);
    return s + ((Number(it.precio_unitario) || 0) + etiq) * (Number(it.cantidad) || 0);
  }, 0);
  const ahorro = Math.max(0, totalSinDescuento - precioNum);

  // Imagenes derivadas de los componentes (seleccion automatica editable).
  const usarAutoImagenes = imagenes.length === 0 && filesPendientes.length === 0 && autoImagenes.length > 0;

  const removerAutoImagen = (idx) => {
    setAutoImagenes((prev) => prev.filter((_, i) => i !== idx));
  };

  const moverAutoImagen = (fromIdx, toIdx) => {
    setAutoImagenes((prev) => {
      const next = [...prev];
      const [item] = next.splice(fromIdx, 1);
      next.splice(toIdx, 0, item);
      return next;
    });
  };

  const onBuscar = (termino) => {
    setBusqueda(termino);
    if (timer.current) clearTimeout(timer.current);
    if (!termino || termino.trim().length < 2) {
      setResultados([]);
      return;
    }
    timer.current = setTimeout(async () => {
      setBuscando(true);
      try {
        const res = await API.get(
          `/inventario/productos?q=${encodeURIComponent(termino)}&sede=todas&limite=30`
        );
        if (res.data.status === 'success') {
          setResultados((res.data.data || []).filter((p) => !p.pesable));
        }
      } catch {
      } finally {
        setBuscando(false);
      }
    }, 300);
  };

  const agregarComponente = async (p) => {
    if (form.items.some((it) => it.codigo_producto === p.codigo)) return;
    let etiquetas = [];
    let imagenes = [];
    let thumb_url = null;
    try {
      const res = await API.get(`/inventario/producto/${encodeURIComponent(p.codigo)}`);
      if (res.data.status === 'success') {
        etiquetas = res.data.data?.etiquetas || [];
        imagenes = res.data.data?.imagenes || [];
        thumb_url = res.data.data?.thumb_url || res.data.data?.imagen_url || null;
      }
    } catch {}
    const nombreProd = p.descripcion || p.codigo;
    setForm((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          codigo_producto: p.codigo,
          nombre: nombreProd,
          precio_unitario: Number(p.precio) || 0,
          cantidad: 1,
          etiquetas,
          etiquetas_ids: [],
          imagenes,
          thumb_url: thumb_url || p.thumb_url || p.imagen_url || null,
        },
      ],
    }));
    // Agregar las imagenes del producto a la seleccion automatica (editables).
    setAutoImagenes((prev) => [
      ...prev,
      ...(imagenes || []).map((img) => ({
        codigo_producto: p.codigo,
        prioridad: img.prioridad,
        url: img.url,
        tipo: img.tipo,
        _producto: nombreProd,
      })),
    ]);
    setBusqueda('');
    setResultados([]);
  };

  const quitarComponente = (codigo) => {
    setForm((prev) => ({
      ...prev,
      items: prev.items.filter((it) => it.codigo_producto !== codigo),
    }));
    setAutoImagenes((prev) => prev.filter((img) => img.codigo_producto !== codigo));
  };

  const setCantidad = (codigo, cantidad) => {
    setForm((prev) => ({
      ...prev,
      items: prev.items.map((it) =>
        it.codigo_producto === codigo ? { ...it, cantidad: Math.max(1, Number(cantidad) || 1) } : it
      ),
    }));
  };

  const toggleEtiqueta = (codigo, et) => {
    setForm((prev) => ({
      ...prev,
      items: prev.items.map((it) => {
        if (it.codigo_producto !== codigo) return it;
        const ya = it.etiquetas_ids.includes(et.id);
        const etiquetas_ids = ya
          ? it.etiquetas_ids.filter((id) => id !== et.id)
          : [...it.etiquetas_ids, et.id];
        return { ...it, etiquetas_ids };
      }),
    }));
  };

  const guardar = async () => {
    if (!form.nombre.trim()) {
      alert('El nombre de la promoción es obligatorio');
      return;
    }
    if (form.items.length === 0) {
      alert('Agrega al menos un producto a la promoción');
      return;
    }
    setGuardando(true);
    try {
      // Imagenes automaticas: si el combo no tiene imagenes propias (guardadas o recien
      // subidas), se siembra la galeria copiando las imagenes seleccionadas de los productos
      // (en el orden elegido por el usuario).
      const tieneImagenesManuales = imagenes.length > 0 || filesPendientes.length > 0;
      const imagenes_productos = tieneImagenesManuales
        ? []
        : autoImagenes.map((img) => ({
            codigo_producto: img.codigo_producto,
            prioridad: img.prioridad,
          }));

      const saved = await onGuardar({
        id: combo?.id,
        nombre: form.nombre.trim(),
        descripcion: form.descripcion || null,
        precio: precioNum,
        activo: combo ? combo.activo : true,
        imagen_url: combo?.imagen_url || null,
        orden: parseInt(form.orden, 10) || 0,
        items: form.items.map((it) => ({
          codigo_producto: it.codigo_producto,
          cantidad: it.cantidad,
          etiquetas: it.etiquetas_ids,
        })),
        imagenes_productos,
      });
      const cid = saved?.id || combo?.id;
      if (!cid) throw new Error('No se pudo determinar la promoción creada');

      const surviving = imagenes.filter((img) => !deletePendientes.includes(img.prioridad));
      const needsReorder =
        surviving.length > 1 &&
        JSON.stringify(surviving.map((i) => i.prioridad)) !==
          JSON.stringify(ordenOriginal.filter((p) => !deletePendientes.includes(p)));
      if (needsReorder) {
        await API.put(`/inventario/combos/${cid}/imagenes/reorder`, {
          orden: surviving.map((i) => i.prioridad),
        });
      }
      for (const prio of deletePendientes) {
        await API.delete(`/inventario/combos/${cid}/imagen/${prio}`);
      }
      for (const f of filesPendientes) {
        const fd = new FormData();
        fd.append('archivo', f.file);
        await API.post(`/inventario/combos/${cid}/imagen`, fd);
      }
      filesPendientes.forEach((f) => {
        try {
          URL.revokeObjectURL(f.previewUrl);
        } catch {}
      });
      onClose();
    } catch (e) {
      alert(e.response?.data?.detail || e.message || 'Error al guardar la promoción');
    } finally {
      setGuardando(false);
    }
  };

  const subirImagen = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/mp4,video/webm';
    input.multiple = true;
    input.onchange = (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;
      const nuevos = files.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
        tipo: file.type.startsWith('video/') ? 'video' : 'imagen',
      }));
      setFilesPendientes((prev) => [...prev, ...nuevos]);
    };
    input.click();
  };

  const eliminarImagen = (prioridad) => {
    setDeletePendientes((prev) => [...prev, prioridad]);
  };

  const quitarPendiente = (idx) => {
    setFilesPendientes((prev) => {
      const f = prev[idx];
      if (f?.previewUrl) {
        try {
          URL.revokeObjectURL(f.previewUrl);
        } catch {}
      }
      return prev.filter((_, i) => i !== idx);
    });
  };

  const { dragIdx, handleDragStart, handleDragOver, handleDrop, handleDragEnd } = useImageReorder({
    imagenes,
    filesPendientes,
    deletePendientes,
    setImagenes,
    setFilesPendientes,
  });

  const inputStyle = {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '9px',
    border: '1px solid #dadce0',
    fontSize: '13px',
    fontFamily: 'inherit',
    outline: 'none',
    boxSizing: 'border-box',
    background: '#fff',
    color: '#202124',
  };

  return (
    <div style={M.overlay} onClick={onClose}>
      <div
        style={{
          ...M.modalWide,
          maxWidth: '980px',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '90vh',
          height: '90vh',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '18px 24px',
            borderBottom: '1px solid #e8eaed',
            flexShrink: 0,
          }}
        >
          <div>
            <div style={{ fontSize: '17px', fontWeight: 700, color: '#202124' }}>
              {combo ? 'Editar promoción' : 'Nueva promoción'}
            </div>
            <div style={{ fontSize: '12px', color: '#5f6368', marginTop: '2px' }}>
              Arma el paquete, fija el precio y el cliente verá cuánto se ahorra
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              ...M.closeBtn,
              position: 'static',
              background: '#f1f3f4',
              borderRadius: '50%',
              width: '34px',
              height: '34px',
            }}
          >
            <FiX size={18} />
          </button>
        </div>

        <div style={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
          {/* Columna izquierda: datos del combo */}
          <div
            style={{
              width: '280px',
              flexShrink: 0,
              padding: '20px',
              borderRight: '1px solid #e8eaed',
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
              overflowY: 'auto',
            }}
          >
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#5f6368', display: 'block', marginBottom: '5px' }}>
                Nombre
              </label>
              <input
                value={form.nombre}
                onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                placeholder="Ej: Promoción Doble + Refresco 1L"
                style={inputStyle}
              />
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#5f6368', display: 'block', marginBottom: '5px' }}>
                Descripción
              </label>
              <textarea
                value={form.descripcion}
                onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
                placeholder="Descripción opcional"
                rows={3}
                style={{ ...inputStyle, resize: 'vertical' }}
              />
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#5f6368', display: 'block', marginBottom: '5px' }}>
                Precio de cobro ($)
              </label>
              <input
                value={form.precio}
                onChange={(e) => setForm({ ...form, precio: e.target.value })}
                type="number"
                min="0"
                step="0.01"
                placeholder="10.99"
                style={inputStyle}
              />
            </div>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#5f6368' }}>
                  Imágenes
                </label>
                <button
                  onClick={subirImagen}
                  style={{
                    padding: '5px 10px',
                    borderRadius: '8px',
                    border: '1px solid #1a73e8',
                    background: '#e8f0fe',
                    color: '#1a73e8',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                  }}
                >
                  <FiPlus size={13} /> Agregar
                </button>
              </div>
              {(() => {
                const display = [
                  ...imagenes.filter((img) => !deletePendientes.includes(img.prioridad)),
                  ...filesPendientes.map((f, i) => ({
                    _esPendiente: true,
                    _fileIdx: i,
                    url: f.previewUrl,
                    tipo: f.tipo,
                    prioridad: -(i + 1),
                  })),
                ];
                return display.length > 0 ? (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))', gap: '8px' }}>
                    {display.map((img, idx) => (
                      <div
                        key={img.prioridad || idx}
                        draggable
                        onDragStart={(e) => handleDragStart(e, idx)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, idx)}
                        onDragEnd={handleDragEnd}
                        style={{
                          position: 'relative',
                          aspectRatio: '1',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          background: '#f8f9fa',
                          border: idx === 0
                            ? '2px solid #1a73e8'
                            : dragIdx === idx
                              ? '2px dashed #1a73e8'
                              : '1px solid #e8eaed',
                          cursor: img._esPendiente ? 'default' : 'pointer',
                          opacity: dragIdx === idx ? 0.5 : 1,
                          transition: 'border 0.15s, opacity 0.15s',
                        }}
                      >
                        {img.tipo === 'video' ? (
                          <video
                            src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                            muted
                            loop
                            autoPlay
                            playsInline
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <img
                            src={img._esPendiente ? img.url : getImagenUrl(img.url)}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                          />
                        )}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (img._esPendiente) quitarPendiente(img._fileIdx);
                            else eliminarImagen(img.prioridad);
                          }}
                          style={{
                            position: 'absolute',
                            top: '3px',
                            right: '3px',
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            background: 'rgba(0,0,0,0.55)',
                            border: 'none',
                            color: '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiX size={12} />
                        </button>
                        {idx === 0 && !img._esPendiente && !deletePendientes.includes(img.prioridad) && (
                          <span style={{ position: 'absolute', top: '3px', left: '3px', background: '#1a73e8', color: '#fff', fontSize: '8px', fontWeight: 700, padding: '1px 5px', borderRadius: '4px' }}>
                            PRINCIPAL
                          </span>
                        )}
                        {img._esPendiente && (
                          <span style={{ position: 'absolute', top: '3px', left: '3px', background: '#34a853', color: '#fff', fontSize: '8px', fontWeight: 700, padding: '1px 5px', borderRadius: '4px' }}>
                            NUEVO
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ) : usarAutoImagenes ? (
                  <div>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))',
                        gap: '8px',
                      }}
                    >
                      {autoImagenes.map((img, idx) => (
                        <div
                          key={`${img.codigo_producto}#${img.prioridad}`}
                          draggable
                          onDragStart={(e) => {
                            setAutoDragIdx(idx);
                            e.dataTransfer.effectAllowed = 'move';
                          }}
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault();
                            if (autoDragIdx === null || autoDragIdx === idx) return;
                            moverAutoImagen(autoDragIdx, idx);
                            setAutoDragIdx(idx);
                          }}
                          onDragEnd={() => setAutoDragIdx(null)}
                          style={{
                            position: 'relative',
                            aspectRatio: '1',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            background: '#f8f9fa',
                            border:
                              idx === 0
                                ? '2px solid #34a853'
                                : autoDragIdx === idx
                                  ? '2px dashed #34a853'
                                  : '1px solid #e8eaed',
                            cursor: 'grab',
                            opacity: autoDragIdx === idx ? 0.5 : 1,
                            transition: 'border 0.15s, opacity 0.15s',
                          }}
                          title={`${img._producto} (arrastra para reordenar)`}
                        >
                          {img.tipo === 'video' ? (
                            <video
                              src={getImagenUrl(img.url)}
                              muted
                              loop
                              autoPlay
                              playsInline
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <img
                              src={getImagenUrl(img.url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          )}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              removerAutoImagen(idx);
                            }}
                            style={{
                              position: 'absolute',
                              top: '3px',
                              right: '3px',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              background: 'rgba(0,0,0,0.55)',
                              border: 'none',
                              color: '#fff',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FiX size={12} />
                          </button>
                          {idx === 0 && (
                            <span style={{ position: 'absolute', top: '3px', left: '3px', background: '#34a853', color: '#fff', fontSize: '8px', fontWeight: 700, padding: '1px 5px', borderRadius: '4px' }}>
                              PRINCIPAL
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        marginTop: '8px',
                        padding: '8px 10px',
                        borderRadius: '8px',
                        background: '#e6f4ea',
                        color: '#137333',
                        fontSize: '11px',
                        fontWeight: 500,
                      }}
                    >
                      <FiZap size={13} />
                      Se usarán las fotos de los productos. Arrástralas para reordenarlas o quítalas con la ×. Si subes fotos propias, reemplazan estas.
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: '16px', textAlign: 'center', color: '#9aa0a6', fontSize: '12px', background: '#f8f9fa', borderRadius: '8px' }}>
                    Sin imágenes. Agrega fotos o videos de la promoción.
                  </div>
                );
              })()}
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#5f6368', display: 'block', marginBottom: '5px' }}>
                Orden (posición)
              </label>
              <input
                value={form.orden}
                onChange={(e) => setForm({ ...form, orden: e.target.value })}
                type="number"
                min="0"
                step="1"
                placeholder="0"
                style={inputStyle}
              />
            </div>

            {/* Resumen en vivo */}
            <div
              style={{
                marginTop: 'auto',
                padding: '14px',
                borderRadius: '10px',
                background: '#f8f9fa',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#5f6368' }}>
                <span>Por separado</span>
                <span>${fmtMonto(totalSinDescuento)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#5f6368' }}>
                <span>Precio promoción</span>
                <span>${fmtMonto(precioNum)}</span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '13px',
                  fontWeight: 700,
                  color: ahorro > 0 ? '#137333' : '#5f6368',
                  borderTop: '1px solid #e8eaed',
                  paddingTop: '8px',
                }}
              >
                <span>Ahorro</span>
                <span>${fmtMonto(ahorro)}</span>
              </div>
            </div>

            <button
              onClick={guardar}
              disabled={guardando}
              style={{
                ...C.btnAdd,
                width: '100%',
                padding: '11px',
                opacity: guardando ? 0.6 : 1,
                cursor: guardando ? 'default' : 'pointer',
              }}
            >
              {guardando ? 'Guardando...' : combo ? 'Guardar cambios' : 'Crear promoción'}
            </button>
          </div>

          {/* Columna derecha: componentes */}
          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <div style={{ padding: '16px 20px 12px', flexShrink: 0 }}>
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#202124', marginBottom: '10px' }}>
                Componentes de la promoción
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '9px 12px',
                  borderRadius: '9px',
                  border: '1px solid #dadce0',
                  background: '#fff',
                }}
              >
                <FiSearch size={15} color="#9aa0a6" />
                <input
                  placeholder="Buscar producto por nombre o código..."
                  value={busqueda}
                  onChange={(e) => onBuscar(e.target.value)}
                  style={{
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    fontSize: '13px',
                    fontFamily: 'inherit',
                    background: 'transparent',
                  }}
                />
                {busqueda && (
                  <button
                    onClick={() => onBuscar('')}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9aa0a6' }}
                  >
                    <FiX size={14} />
                  </button>
                )}
              </div>
              {busqueda.trim().length >= 2 && (
                <div
                  style={{
                    marginTop: '8px',
                    maxHeight: '180px',
                    overflowY: 'auto',
                    border: '1px solid #e8eaed',
                    borderRadius: '9px',
                  }}
                >
                  {buscando ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: '#5f6368' }}>Buscando...</div>
                  ) : resultados.length === 0 ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: '#5f6368' }}>Sin resultados</div>
                  ) : (
                    resultados.map((p) => (
                      <div
                        key={p.codigo}
                        onClick={() => agregarComponente(p)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '9px 12px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f1f3f4',
                          transition: 'background 0.12s',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = '#f8f9fa')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                      >
                        <div
                          style={{
                            width: '38px',
                            height: '38px',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            background: '#f1f3f4',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {p.thumb_url || p.imagen_url ? (
                            <img
                              src={getImagenUrl(p.thumb_url || p.imagen_url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          ) : (
                            <FiPackage size={18} color="#9aa0a6" />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '13px', fontWeight: 500, color: '#202124', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.descripcion}</div>
                          <div style={{ fontSize: '11px', color: '#5f6368' }}>
                            {p.codigo} · ${fmtMonto(p.precio || 0)}
                          </div>
                        </div>
                        <FiPlus size={15} color="#1a73e8" />
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>

            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '0 20px 20px' }}>
              {form.items.length === 0 ? (
                <div style={{ padding: '30px', textAlign: 'center', color: '#9aa0a6', fontSize: '13px' }}>
                  Aún no hay productos. Búscalos arriba para agregarlos.
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {form.items.map((it) => (
                    <div
                      key={it.codigo_producto}
                      style={{ border: '1px solid #e8eaed', borderRadius: '12px', padding: '12px 14px', background: '#fff' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '42px',
                            height: '42px',
                            borderRadius: '9px',
                            overflow: 'hidden',
                            background: '#f1f3f4',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {it.thumb_url ? (
                            <img
                              src={getImagenUrl(it.thumb_url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          ) : (
                            <FiPackage size={20} color="#9aa0a6" />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '13px', fontWeight: 600, color: '#202124' }}>{it.nombre}</div>
                          <div style={{ fontSize: '11px', color: '#5f6368' }}>
                            {it.codigo_producto} · ${fmtMonto(it.precio_unitario || 0)} c/u
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '11px', color: '#5f6368' }}>Cant.</span>
                          <input
                            type="number"
                            min="1"
                            value={it.cantidad}
                            onChange={(e) => setCantidad(it.codigo_producto, e.target.value)}
                            style={{
                              width: '52px',
                              padding: '6px 8px',
                              borderRadius: '7px',
                              border: '1px solid #dadce0',
                              fontSize: '13px',
                              fontFamily: 'inherit',
                              textAlign: 'center',
                            }}
                          />
                          <button
                            onClick={() => quitarComponente(it.codigo_producto)}
                            style={{ ...C.btnIconSm, color: '#ea4335' }}
                            title="Quitar"
                          >
                            <FiTrash2 size={14} />
                          </button>
                        </div>
                      </div>
                      {(it.etiquetas || []).filter((e) => e.activo !== false).length > 0 && (
                        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f1f3f4' }}>
                          <div style={{ fontSize: '11px', fontWeight: 600, color: '#5f6368', marginBottom: '6px' }}>
                            Personalizaciones incluidas
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                            {it.etiquetas
                              .filter((e) => e.activo !== false)
                              .map((et) => {
                                const sel = it.etiquetas_ids.includes(et.id);
                                return (
                                  <button
                                    key={et.id}
                                    onClick={() => toggleEtiqueta(it.codigo_producto, et)}
                                    style={{
                                      padding: '5px 10px',
                                      borderRadius: '20px',
                                      border: `1px solid ${sel ? '#1a73e8' : '#dadce0'}`,
                                      background: sel ? '#e8f0fe' : '#fff',
                                      color: sel ? '#1967d2' : '#5f6368',
                                      fontSize: '11px',
                                      fontWeight: sel ? 600 : 400,
                                      cursor: 'pointer',
                                      fontFamily: 'inherit',
                                    }}
                                  >
                                    {et.nombre}
                                    {Number(et.precio) > 0 ? ` (+$${fmtMonto(et.precio)})` : ''}
                                  </button>
                                );
                              })}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ComboDetalleModal({ combo, onClose, onEditar }) {
  const { isPlanExterno, tienePermiso, isTipoEmpresa } = useAuth();
  const puedeGestionar = tienePermiso('inventario.combos') && (isTipoEmpresa('importador') || !isPlanExterno());
  return (
    <div style={M.overlay} onClick={onClose}>
      <div
        style={{ ...M.modal, maxWidth: '560px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '18px 24px',
            borderBottom: '1px solid #e8eaed',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '44px',
                height: '44px',
                borderRadius: '10px',
                background: '#c5221f15',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              {combo.imagen_url ? (
                <img
                  src={getImagenUrl(combo.imagen_url)}
                  alt=""
                  onError={(e) => (e.currentTarget.style.display = 'none')}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <FiLayers size={22} color="#c5221f" />
              )}
            </div>
            <div>
              <div style={{ fontSize: '16px', fontWeight: 700, color: '#202124' }}>{combo.nombre}</div>
              <div style={{ fontSize: '12px', color: '#5f6368' }}>
                {combo.items.length} componentes · {combo.activo ? 'Activo' : 'Inactivo'}
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{ ...M.closeBtn, position: 'static', background: '#f1f3f4', borderRadius: '50%', width: '34px', height: '34px' }}
          >
            <FiX size={18} />
          </button>
        </div>

        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '120px', padding: '12px 14px', borderRadius: '10px', background: '#f8f9fa' }}>
              <div style={{ fontSize: '11px', color: '#5f6368' }}>Precio promoción</div>
              <div style={{ fontSize: '20px', fontWeight: 700, color: '#202124' }}>${fmtMonto(combo.precio || 0)}</div>
            </div>
            <div style={{ flex: 1, minWidth: '120px', padding: '12px 14px', borderRadius: '10px', background: '#f8f9fa' }}>
              <div style={{ fontSize: '11px', color: '#5f6368' }}>Por separado</div>
              <div style={{ fontSize: '20px', fontWeight: 700, color: '#5f6368' }}>${fmtMonto(combo.precio_sin_descuento || 0)}</div>
            </div>
            <div style={{ flex: 1, minWidth: '120px', padding: '12px 14px', borderRadius: '10px', background: combo.ahorro > 0 ? '#e6f4ea' : '#f8f9fa' }}>
              <div style={{ fontSize: '11px', color: '#5f6368' }}>Ahorro</div>
              <div style={{ fontSize: '20px', fontWeight: 700, color: combo.ahorro > 0 ? '#137333' : '#5f6368' }}>
                ${fmtMonto(combo.ahorro || 0)}
              </div>
            </div>
          </div>

          {combo.descripcion && (
            <div style={{ fontSize: '13px', color: '#5f6368', lineHeight: '1.5' }}>{combo.descripcion}</div>
          )}

          <div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#202124', marginBottom: '8px' }}>
              Componentes
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {combo.items.map((it) => (
                <div
                  key={it.id || it.codigo_producto}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 12px',
                    borderRadius: '9px',
                    border: '1px solid #e8eaed',
                    background: '#fff',
                  }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: 500, color: '#202124' }}>{it.nombre}</div>
                    {(it.etiquetas || []).length > 0 && (
                      <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '2px' }}>
                        {it.etiquetas.map((e) => e.nombre).join(', ')}
                      </div>
                    )}
                  </div>
                  <span style={{ fontSize: '12px', color: '#5f6368', whiteSpace: 'nowrap' }}>
                    {it.cantidad} × ${fmtMonto(it.precio_unitario || 0)}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {puedeGestionar && (
            <button
              onClick={onEditar}
              style={{
                ...C.btnAdd,
                width: '100%',
                padding: '11px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
              }}
            >
              <FiEdit2 size={14} /> Editar promoción
            </button>
          )}
        </div>
      </div>
    </div>
  );
}


export default Inventario;
